import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getAllParameters } from '../../../features/parameters/helper/api';
import _ from 'lodash';
import { isAuthenticated } from '../../../auth/index';
import { convert_24_to_12, getMealTime, getShortString, startLoader, stopLoader, useAsyncState } from '../../../lib/utils';
import { getAllContents, getContentsCount } from '../../../features/content/helper/api';
import config, { weekDayDisplayNames } from '../../../config';
import { getAllGym, getGymCount } from '../../../features/company/helper/api';
import { getAllBranches, getBranchCount } from '../../../features/gyms/helper/api';
import { createNutritionPlanner, createPlanner, editPlanner, updateNutritionPlanner } from '../../../features/planner/helper/api';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Toast from "../../../lib/toast";
import '../../../features/planner/style.scss';
import FlatPicker from 'flatpickr';
import SearchFilter from '../../search-filter';
import "../style.scss";

let flatpickr;

const ManageWorkoutPlanner = (props) => {

  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const [sortByAccessRight,setSortByAccessRight]=useState('');
  const [currentElementId, setCurrentElementId] = useState("");
  const [weekdayExerciseTypeOpenDropdown, setWeekdayExerciseTypeOpenDropdown] = useState(false);
  const [exerciseWeightUnitTypeDropdownOpen, setExerciseWeightUnitTypeDropdownOpen] = useState(false);
  const [exerciseDistanceUnitTypeDropdownOpen, setExerciseDistanceUnitTypeDropdownOpen] = useState(false);
  const [isExerciseDetailsViewOpen, setExerciseDetailsViewOpen] = useState(false);
  const [isVideoPlayerOpen, setVideoPlayerOpen] = useState(false);
  const [isContentFilter, setContentFilter] = useState('');
  const [currentWindow, setCurrentWindow] = useState("create-planner");
  const [sortExerciseTypeIDs, setSortExerciseTypeIDs] = useState([]);
  const [sortExerciseLevelIDs, setSortExerciseLevelIDs] = useState([]);
  const [sortTargetMuscleIDs, setTargetMuscleIDs] = useState([])
  var [prevContentFilterOpen, setPrevContentFilterOpen] = useState('');
  const [displayContent, setDisplayContent] = useState('');
  const [dayPlanner, setDayPlanner] = useState({
    workoutPlannerId: "",
    accessRight:'private',
    exerciseLevelIDs: [],
    name: "",
    warmup: [],
    cooldown: [],
    workout: [],
  });
  const [workoutPlanner, setWorkoutPlanner] = useState({
    workoutPlannerId: "",
    accessRight:'private',
    exerciseLevelIDs: [],
    name: "",
    warmup: [],
    cooldown: [],
    weekdays: [],
  })
  const [isAccessRightDropdown,setAccessRightDropdown]=useState(false);
  const exerciseTemplate = {
    content: {},
    optionalExercises: [],
    parameter: {
      id: "",
      set: [{
        reps: "15",
        weight:{
          value:"",
          unit:"Kg"
        }
      }],
      distance: {
        value: "",
        unit: ""
      },
      count: "",
      duration: {
        hour: "",
        min: ""
      }
    }
  }
  const [exerciseNames, setExerciseNames] = useState([]);
  const [exerciseTypes, setExerciseTypes] = useState([])
  const [targetMuscles, setTargetMuscles] = useState([])
  const [exerciseLevels, setExerciseLevels] = useState([])
  var [pageNo, setPageNo] = useState({
    content: 1,
    gym: 1,
    branch: 1
  });
  const [pageCount, setPageCount] = useState({
    content: 1,
    gym: 1,
    branch: 1
  });
  const pageSize = {
    content: 20,
    gym: 20,
    branch: 20
  };
  const [Total, setTotal] = useState({
    content: 0,
    gym: 0,
    branch: 0
  });
  const accessRights=['private','public'];
  const [Contents, setContents] = useAsyncState([]);
  const [selectedSet, setSelectedSet] = useState(0);
  const [exerciseDetails, setExerciseDetails] = useState({
    id: "",
    set: [
      {
        reps: "15",
        weight:{
          value:"",
          unit:"Kg"
        }
      }
    ],
    distance: {
      value: "",
      unit: ""
    },
    count: "",
    duration: {
      hour: "",
      min: ""
    }
  })
  const [contentSearchKey, setContentSearchKey] = useState('');
  const { user, token } = isAuthenticated();
  var [sortByContentType, setSortByContentType] = useState("");
  const [contentApiAction, setContentApiAction] = useState(false);
  const [isContentLoader, setContentLoader] = useState(false);
  var [prevPopupWindow, setPrevPopupWindow] = useState('');
  const [selectedWeekDay, setSelectedWeekDay] = useState(1);
  const [selectedExerciseIndex, setSelectedExerciseIndex] = useState(-1);
  const [selectedOptionalExerciseIndex, setSelectedOptionalExerciseIndex] = useState(-1);
  const [selectedContent, setSelectedContent] = useState("");
  const [ContentRole, setContentRole] = useState('All');
  var [isSearchBranch, setSearchBranch] = useState(false);
  const [Branches, setBranches] = useAsyncState([]);
  const [Gyms, setGyms] = useAsyncState([])
  const [selectedGym, setSelectedGym] = useState('');
  const [branchIDs, setBranchIDs] = useState([]);
  const [isGymSpinnerLoader, setGymSpinnerLoader] = useState(false);
  const [isBrachSpinnerLoader, setBranchSpinnerLoader] = useState(false);
  var [branchSearchKey, setBranchSearchKey] = useState('');
  const [gymSearchKey, setGymSearchKey] = useState('');
  const [tempIDs, setTempIDs] = useState([]);
  const [isButtonLock, setButtonLock] = useState(true)
  const [weekDayFrequency, setWeekdayFrequency] = useState(3);
  const [isEditActive,setEditActive] = useState(false);
  const [copyFrom, setCopyFrom] = useState("");
  const [copyTo, setCopyTo] = useState([{
    day: "Sunday",
    isSelected: false
  },{
    day: "Monday",
    isSelected: false
  },{
    day: "Tuesday",
    isSelected: false
  },{
    day: "Wednesday",
    isSelected: false
  },{
    day: "Thursday",
    isSelected: false
  },{
    day: "Friday",
    isSelected: false
  },{
    day: "Saturday",
    isSelected: false
  }]);

  const [dayStorage, setDayStorage] = useState({
    Days: [
      {
        name: "Sun",
        isSelected: false
      },
      {
        name: "Mon",
        isSelected: false, 
      },
      {
        name: "Tue",
        isSelected: false
      },
      {
        name: "Wed",
        isSelected: false
      },
      {
        name: "Thu",
        isSelected: false
      },
      {
        name: "Fri",
        isSelected: false
      },
      {
        name: "Sat",
        isSelected: false
      }
    ],
    name: "",
    displayName:"",
    exercises: [],
    nutrition: []
  });

  const [nutritionContent, setNutritionContent] = useState({
    name: "",
    imgSrc : "",
    videoSrc : "",
    servingSize : "",
    calorie : ""
  })

  const [nutritionMeal, setNutritionMeal] = useState({
    days: [],
    mealName: "Untitled",
    mealTime: "",
    contents : []
  });

  const [nutritionCarrier, setNutritionCarrier] = useState([]);

  const [nutritionPlanner, setNutritionPlanner] = useState([]);

  const [plannerType, setPlannerType] = useState("weekday");

  const [isSetIndexDeleteEnabled, setIndexDeleteEnabled] = useState("-1");

  const [isCurrentNutritionContentIndex, setCurrentNutritionContentIndex] = useState({
    parentIndex: -1,
    childIndex: -1
  });

  const [allSelectedNutritionContent, setAllSelectedNutritionContent] = useState([]);

  const handlePlannerType = (data) => {
    setWorkoutPlanner({
      ...workoutPlanner,
      workoutPlannerId: "",
      accessRight:'private',
      exerciseLevelIDs: [],
      name: "",
      warmup: [],
      cooldown: [],
      weekdays: [],
    })
    setDayPlanner({
      ...dayPlanner,
      workoutPlannerId: "",
      accessRight:'private',
      exerciseLevelIDs: [],
      name: "",
      warmup: [],
      cooldown: [],
      workout: [],
    })
    setPlannerType(data);
  }

  const handleSelectAccessRight=data=>{
    if(plannerType == 'day'){
      setDayPlanner({
        ...dayPlanner,
        accessRight:data
      });
    }else{
      setWorkoutPlanner({
        ...workoutPlanner,
        accessRight:data
      });
    }
  }

  const handleSelectedExerciseLevelIDs = id => event => {
    event.preventDefault();
    let list = plannerType == 'day'?[...dayPlanner.exerciseLevelIDs]:[...workoutPlanner.exerciseLevelIDs];
    let index = list.indexOf(id)
    if (index == -1) {
      list.push(id);
    } else {
      list.splice(index, 1)
    }
    if(plannerType == 'day'){
      setDayPlanner({
        ...dayPlanner,
        exerciseLevelIDs:list
      })
    }else{
      setWorkoutPlanner({
        ...workoutPlanner,
        exerciseLevelIDs: list
      })
    }
  }



  const checkDataField = () => {
    if(plannerType == 'day'){
      if (dayPlanner.cooldown.length > 0 && dayPlanner.accessRight && dayPlanner.cooldown.every(d => d.content && d.content._id) && dayPlanner.warmup.length > 0 && dayPlanner.warmup.every(d => d.content && d.content._id) && dayPlanner.name && dayPlanner.workout.length > 0 && dayPlanner.workout.every(d =>d.content && d.content._id)) {
        setButtonLock(false);
      } else {
        setButtonLock(true);
      }
    }else if(plannerType == "nutrition"){
      if(workoutPlanner.accessRight && workoutPlanner.name && nutritionPlanner.length){
        setButtonLock(false)
      }else{
        setButtonLock(true)
      }
    } else{
      if (workoutPlanner.cooldown.length > 0 && workoutPlanner.accessRight && workoutPlanner.cooldown.every(d => d.content && d.content._id) && workoutPlanner.warmup.length > 0 && workoutPlanner.warmup.every(d => d.content && d.content._id) && workoutPlanner.name && workoutPlanner.weekdays.length > 0 && workoutPlanner.weekdays.every(d => d.displayName && d.exercises.length > 0 && d.exercises.every(d2 => d2.content && d2.content._id))) {
        setButtonLock(false);
      } else {
        setButtonLock(true);
      }
    }
  }

  const CreatePlanner = async event => {
    event.preventDefault()
    try {
      await startLoader()
      setButtonLock(true);
      let payload = {
        name: plannerType=='day'?dayPlanner.name:workoutPlanner.name,
        accessRight:plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight
      };

      if(plannerType != "nutrition"){
        payload ={
          ...payload,
          exerciseLevelIDs: plannerType == 'day'?dayPlanner.exerciseLevelIDs:workoutPlanner.exerciseLevelIDs,
          warmup: [],
          weekdays: [],
          cooldown: []
        }
      }

      if(plannerType=='day') payload.isOneDayPlanner=true;

      if(plannerType == 'day'){
        delete payload.weekdays;
        payload.workout=[];
      }
      
      // if(user.role > 0){
      //   payload.gymId = user.gymIDs[0]
      // }
      // if(user.role > 4){
      //   payload.branchId = user.branchIDs[0]
      // }


      if(user.role == 0) payload.isInstafitPlanner = true;
      else{
        payload.branchId = localStorage?.getItem("branchId")
        payload.gymId = localStorage?.getItem("gymId");
      }


      if(plannerType == 'day'){
        if (dayPlanner.warmup.length > 0) {
          await Promise.all(dayPlanner.warmup.map(async exercise => {
            let exerciseObject = {
              optionalExercises: []
            }
            if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;
  
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({
                contentId: opex._id
              });
            }));
  
            payload.warmup.push(exerciseObject)
          }))
        }

        if(dayPlanner.workout.length){
          await Promise.all(dayPlanner.workout.map(async (exercise, index) => {
            let exerciseObject = {}
            if (exercise.content && exercise.content._id) {
              exerciseObject.contentId = exercise.content._id;
            }
            if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
              exerciseObject.optionalExercises = [];
              await Promise.all(exercise.optionalExercises.map(d => {
                let opExObject = {
                  parameter: d.parameter ? d.parameter : {}
                };
                if (d.content && d.content._id) opExObject.contentId = d.content._id;
                exerciseObject.optionalExercises.push(opExObject);
              }));
            }
            if (exercise.parameter) {
              exerciseObject.parameter = exercise.parameter;
            }
  
            payload.workout.push(exerciseObject);
          }))
        }

        if (dayPlanner.cooldown.length > 0) {
          await Promise.all(dayPlanner.cooldown.map(async exercise => {
            let exerciseObject = {
              optionalExercises: []
            }
  
            if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;
  
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({ contentId: opex._id });
            }));
  
            payload.cooldown.push(exerciseObject)
          }))
        }
      }else if(plannerType == 'weekday'){
        if (workoutPlanner.warmup.length > 0) {
          await Promise.all(workoutPlanner.warmup.map(async exercise => {
            let exerciseObject = {
              optionalExercises: []
            }
            if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;
  
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({
                contentId: opex._id
              });
            }));
  
            payload.warmup.push(exerciseObject)
          }))
        }
  
        if (workoutPlanner.weekdays.length > 0) {
          await Promise.all(workoutPlanner.weekdays.map(async (day, index) => {
            let dayObject = {
              displayName: day.displayName,
              dayName:day.dayName,
              dayIndex:day.dayIndex,
              exercises: []
            };
            await Promise.all(day.exercises.map(async (exercise, index) => {
              let exerciseObject = {}
              if (exercise.content && exercise.content._id) {
                exerciseObject.contentId = exercise.content._id;
              }
              if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
                exerciseObject.optionalExercises = [];
                await Promise.all(exercise.optionalExercises.map(d => {
                  let opExObject = {
                    parameter: d.parameter ? d.parameter : {}
                  };
                  if (d.content && d.content._id) opExObject.contentId = d.content._id;
                  exerciseObject.optionalExercises.push(opExObject);
                }));
              }
              if (exercise.parameter) {
                exerciseObject.parameter = exercise.parameter;
              }
  
              dayObject.exercises.push(exerciseObject);
            }))
            payload.weekdays.push(dayObject)
          }))
        }
  
        if (workoutPlanner.cooldown.length > 0) {
          await Promise.all(workoutPlanner.cooldown.map(async exercise => {
            let exerciseObject = {
              optionalExercises: []
            }
  
            if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;
  
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({ contentId: opex._id });
            }));
  
            payload.cooldown.push(exerciseObject)
          }))
        }
      }else {
        payload = {
          ...payload,
          nutritionSchedules:nutritionPlanner.map(data=>{
            return {
              dayName:data.dayName,
              meals:data.nutritionContents.map(data2=>{
                return {
                  mealTime: data2.mealTime,
                  mealName: data2.mealName,
                  items:data2.contents.map(content=>{
                    return {
                      contentId:content.content._id,
                      servingSize: { 
                          value:content.servingSize,
                          unit:'g'
                      },
                      calorie:{
                          value:content.calorie,
                          unit:'kcal'
                      }
                    }
                  })
                }
              })
            }
          })
        }
      }



      const response=plannerType == "nutrition"?await createNutritionPlanner(user._id,token,payload):await createPlanner(user._id, token, payload);

      await stopLoader();
      if(response.error){
        new Toast({
          type:"error",
          message:response.error,
          duration:3000
        })
        setButtonLock(false);
        return;
      }

      new Toast({
        type:"success",
        message:"Planner created successfully",
        duration:3000
      });

      if (path == "/planners") history.push("/planners");
      closePopup()
      setButtonLock(false);
    } catch (error) {
      console.log(error)
      await stopLoader()
      setButtonLock(false);
    }
    event.stopPropagation()
  }

  const EditPlanner = async event => {
    event.preventDefault()
    try {
      setButtonLock(true);
      let payload = {
        name: plannerType=='day'?dayPlanner.name:workoutPlanner.name,
        accessRight:plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight
      };

      if(plannerType != "nutrition"){
        payload ={
          ...payload,
          // isOneDayPlanner:plannerType=='day'?true:false,
          exerciseLevelIDs: plannerType == 'day'?dayPlanner.exerciseLevelIDs:workoutPlanner.exerciseLevelIDs,
          warmup: [],
          weekdays: [],
          cooldown: []
        }
      }

      if(plannerType == 'day'){
        delete payload.weekdays;
        payload.workout=[];
      }
      
      if(user.role > 0){
        payload.gymId = user.gymIDs[0]
      }
      if(user.role > 4){
        payload.branchId = user.branchIDs[0]
      }

      if(plannerType == 'day'){
        if (dayPlanner.warmup.length > 0) {
          await Promise.all(dayPlanner.warmup.map(async exercise => {
            let exerciseObject = {
              optionalExercises: []
            }
            if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;
  
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({
                contentId: opex._id
              });
            }));
  
            payload.warmup.push(exerciseObject)
          }))
        }

        if(dayPlanner.workout.length){
          await Promise.all(dayPlanner.workout.map(async (exercise, index) => {
            let exerciseObject = {}
            if (exercise.content && exercise.content._id) {
              exerciseObject.contentId = exercise.content._id;
            }
            if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
              exerciseObject.optionalExercises = [];
              await Promise.all(exercise.optionalExercises.map(d => {
                let opExObject = {
                  parameter: d.parameter ? d.parameter : {}
                };
                if (d.content && d.content._id) opExObject.contentId = d.content._id;
                exerciseObject.optionalExercises.push(opExObject);
              }));
            }
            if (exercise.parameter) {
              exerciseObject.parameter = exercise.parameter;
            }
  
            payload.workout.push(exerciseObject);
          }))
        }

        if (dayPlanner.cooldown.length > 0) {
          await Promise.all(dayPlanner.cooldown.map(async exercise => {
            let exerciseObject = {
              optionalExercises: []
            }
  
            if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;
  
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({ contentId: opex._id });
            }));
  
            payload.cooldown.push(exerciseObject)
          }))
        }
      }else if(plannerType == 'weekday'){
        if (workoutPlanner.warmup.length > 0) {
          await Promise.all(workoutPlanner.warmup.map(async exercise => {
            let exerciseObject = {
              optionalExercises: []
            }
            if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;
  
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({
                contentId: opex._id
              });
            }));
  
            payload.warmup.push(exerciseObject)
          }))
        }
  
        if (workoutPlanner.weekdays.length > 0) {
          await Promise.all(workoutPlanner.weekdays.map(async (day, index) => {
            let dayObject = {
              displayName: day.displayName,
              dayName:day.dayName,
              dayIndex:day.dayIndex,
              exercises: []
            };
            await Promise.all(day.exercises.map(async (exercise, index) => {
              let exerciseObject = {}
              if (exercise.content && exercise.content._id) {
                exerciseObject.contentId = exercise.content._id;
              }
              if (exercise.optionalExercises && exercise.optionalExercises.length > 0) {
                exerciseObject.optionalExercises = [];
                await Promise.all(exercise.optionalExercises.map(d => {
                  let opExObject = {
                    parameter: d.parameter ? d.parameter : {}
                  };
                  if (d.content && d.content._id) opExObject.contentId = d.content._id;
                  exerciseObject.optionalExercises.push(opExObject);
                }));
              }
              if (exercise.parameter) {
                exerciseObject.parameter = exercise.parameter;
              }
  
              dayObject.exercises.push(exerciseObject);
            }))
            payload.weekdays.push(dayObject)
          }))
        }
  
        if (workoutPlanner.cooldown.length > 0) {
          await Promise.all(workoutPlanner.cooldown.map(async exercise => {
            let exerciseObject = {
              optionalExercises: []
            }
  
            if (exercise.content && exercise.content._id) exerciseObject.contentId = exercise.content._id;
  
            await Promise.all(exercise.optionalExercises.map(opex => {
              if (opex._id) exerciseObject.optionalExercises.push({ contentId: opex._id });
            }));
  
            payload.cooldown.push(exerciseObject)
          }))
        }
      }else{
        payload = {
          ...payload,
          nutritionSchedules:nutritionPlanner.map(data=>{
            return {
              dayName:data.dayName,
              meals:data.nutritionContents.map(data2=>{
                return {
                  mealTime: data2.mealTime,
                  mealName: data2.mealName,
                  items:data2.contents.map(content=>{
                    return {
                      contentId:content.content._id,
                      servingSize: { 
                          value:content.servingSize,
                          unit:'g'
                      },
                      calorie:{
                          value:content.calorie,
                          unit:'kcal'
                      }
                    }
                  })
                }
              })
            }
          })
        }
      }
      
      const response = plannerType == 'nutrition'?await updateNutritionPlanner(user._id,token,workoutPlanner.workoutPlannerId,payload):await editPlanner(user._id, token, plannerType == 'day'?dayPlanner.workoutPlannerId:workoutPlanner.workoutPlannerId, payload);
      await stopLoader()
      if(response.error){
        new Toast({
          type:"error",
          message:response.error,
          duration:3000
        })
        setButtonLock(false);
        return;
      }

      new Toast({
        type:"success",
        message:"Planner updated successfully",
        duration:3000
      });

      if (path == "/planners") history.push("/planners");
      closePopup()
    } catch (error) {
      await stopLoader()
    }
    event.stopPropagation();
  }

  const handleWeekdayFrequency = (currentFeq) => {
    if(weekDayFrequency != currentFeq){
      setWeekdayFrequency(currentFeq)
      
      if(currentFeq == 6 && workoutPlanner.weekdays.length == 3){
        
        workoutPlanner.weekdays.push({
          isSelected: false,
          name: "",
          displayName:"",
          exercises: [
            {
              content: {},
              optionalExercises: [],
              parameter: {}
            }
          ]
        },{
          isSelected: false,
          name: "",
          displayName:"",
          exercises: [
            {
              content: {},
              optionalExercises: [],
              parameter: {}
            }
          ]
        },{
          isSelected: false,
          name: "",
          displayName:"",
          exercises: [
            {
              content: {},
              optionalExercises: [],
              parameter: {}
            }
          ]
        })


        setWorkoutPlanner({
          ...workoutPlanner
        })
      } else{
          if(workoutPlanner.weekdays.length == 6){
            workoutPlanner.weekdays.splice(3, 5);
            setWorkoutPlanner({
              ...workoutPlanner
            })
          }
      }
    }
  }

  const handleSelectedWeekDays = (index) => {
    setWorkoutPlanner(oldstate=>{
      if(workoutPlanner.weekdays[index].isSelected == false){
        oldstate.weekdays[index].isSelected = true
      }else{
        oldstate.weekdays[index].isSelected = false
      }
      return {
        ...oldstate
      }
    });
  }
  
  const handleDeleteWeekDays = () => {
    workoutPlanner.weekdays.pop();
    setWorkoutPlanner({
      ...workoutPlanner
    })
  }

  const handleSelectPlannerDay = (type, name,isUpdate) => {
      const index=dayStorage.Days.findIndex(d=>d.name == name);
      if(index>-1){
        const weekDayIndex=type == "nutrition"?nutritionPlanner.findIndex(d=>d.dayName == name):workoutPlanner.weekdays.findIndex(d=>d.dayName==name);
        if(isUpdate && weekDayIndex>-1){
          setEditActive(true);
          var Days=[...dayStorage.Days];
          Days.map((day)=>{
            day.isSelected=false;
          })
          Days[index].isSelected=true;
          if(type == "nutrition"){
            setDayStorage({
              ...dayStorage,
              Days
            })
          }else{
            setDayStorage({
              ...dayStorage,
              Days,
              displayName:workoutPlanner.weekdays[weekDayIndex].displayName,
              name:workoutPlanner.weekdays[weekDayIndex].name,
              exercises: type == "workout" ? workoutPlanner.weekdays[weekDayIndex].exercises : "",
            })
          }

          if(type == "nutrition"){
             setNutritionCarrier(nutritionPlanner[weekDayIndex].nutritionContents)
             setCurrentWindow("add-nutrition-planner")
          }

        }else{
          var Days=[...dayStorage.Days];
          Days[index].isSelected=!dayStorage.Days[index].isSelected;
          setDayStorage({
            ...dayStorage,
            Days
          });
        }
      }

      type == "workout" && (
        setWorkoutPlanner({
          ...workoutPlanner
        })
      );
      
  }

  const handleAddWorkouts = async event => {

    event.preventDefault();


    const exerciseTemplateCopy = {
      ...exerciseTemplate
    }

    await Promise.all(dayStorage.Days.map(data => {
      if(data.isSelected == true){
        setWorkoutPlanner(oldWeekDays => {
          const weekIndex=oldWeekDays.weekdays.findIndex(d=>`${d.dayName}`.toString().toLocaleLowerCase() == `${data.name}`.toString().toLocaleLowerCase());
          //isEditActive
          if(weekIndex>-1){
            oldWeekDays.weekdays[weekIndex].name=dayStorage.name;
            oldWeekDays.weekdays[weekIndex].displayName=dayStorage.displayName;
            oldWeekDays.weekdays[weekIndex].exercises=dayStorage.exercises;
          }else{
            oldWeekDays.weekdays.push({
              dayIndex:config.weekDays.indexOf(data.name),
              dayName : data.name,
              displayName : dayStorage.displayName,
              exercises : dayStorage.exercises,
              isSelected : false,
              name: ""
            });
          }

          const sortWeekDays=oldWeekDays.weekdays.sort((a,b)=>a.dayIndex-b.dayIndex);
          oldWeekDays.weekdays=[...sortWeekDays];

          return{
            ...oldWeekDays
          }
        })     
      }      
    }))

    setDayStorage(oldState => {

      oldState.exercises = [];
      oldState.displayName = "";
      exerciseTemplateCopy.content = {};
      oldState.exercises.push(exerciseTemplateCopy);

      oldState.Days.map(data => {
        if(data.isSelected == true){
          data.isSelected = false
        }
      })

      return {
        ...oldState
      }
    })

    setEditActive(false);
  }

  const handleDayWorkoutCopyTo = (dayName) => {
    setCopyTo(oldstate=>{
      oldstate.map(d=>{
        d.isSelected=false;
      })
      return [...oldstate];
    })
    let formattedDayName = dayName == "Mon" ? "Monday" : dayName == "Tue" ? "Tuesday" : dayName == "Wed" ? "Wednesday" : dayName == "Thu" ? "Thursday" : dayName == "Fri" ? "Friday" : dayName == "Sat" ? "Saturday" : "Sunday"  
    if(dayName.length > 0){
      setCopyFrom(formattedDayName)
    }else{
      setCopyFrom("")
    }
  }

  const handleCopyTo = (index) => {
    setCopyTo(oldState => {  
      
      oldState[index].isSelected = !oldState[index].isSelected;

      return[
        ...oldState
      ]
    })
  }

  const handleDeleteNutritionPlan = (index) =>{
    let dayName = nutritionPlanner[index].dayName;
    setDayStorage(oldstate=>{
      let findIndex = oldstate.Days.findIndex(d=>d.name == dayName);
      if(findIndex>-1) oldstate.Days[findIndex].isSelected = false;
      return {...oldstate};
    })
    if(nutritionPlanner.length == 1){
      setCurrentWindow("create-planner");
    }
    setNutritionPlanner(oldstate=>{
      oldstate.splice(index,1);
      oldstate.sort((a, b) => {
        return config.weekDays.indexOf(a.dayName) - config.weekDays.indexOf(b.dayName);
      });
      return [...oldstate];
    })
  }

  const handlePasteTo = (index) => {
    let copiedFrom = copyFrom == "Monday" ? "Mon" : copyFrom == "Tuesday" ? "Tue" : copyFrom == "Wednesday" ? "Wed" : copyFrom == "Thursday" ? "Thu" : copyFrom == "Friday" ? "Fri" : copyFrom == "Sunday"? "Sun":"Sat";
    const copiedExerciseList = plannerType == "nutrition"?nutritionPlanner[nutritionPlanner.findIndex(d=>d.dayName == copiedFrom)]:workoutPlanner.weekdays[workoutPlanner.weekdays.findIndex(data => data.dayName == copiedFrom)]
    
    copyTo.map(data => {
      if(data.isSelected == true){
        if(plannerType == "nutrition"){
          setNutritionPlanner(oldstate=>{
            let foundedIndex = oldstate.findIndex(weekData => weekData.dayName == ((data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "Sun")))    
            if(foundedIndex !== -1){
              oldstate[foundedIndex] = {
                ...copiedExerciseList,
                dayName:data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "Sun",
                dayDisplayName:data.day
              }
            }else{
              oldstate.push({
                ...copiedExerciseList,
                dayName:data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "Sun",
                dayDisplayName:data.day
              }) 
            }

            oldstate.sort((a, b) => {
              return config.weekDays.indexOf(a.dayName) - config.weekDays.indexOf(b.dayName);
            });

            return[
              ...oldstate
            ]

          })
        }else{
          setWorkoutPlanner(oldDayWorkout => {
            let foundedIndex = oldDayWorkout.weekdays.findIndex(weekData => weekData.dayName == ((data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "Sun")))    
            if(foundedIndex !== -1){
              oldDayWorkout.weekdays[foundedIndex] = {
                dayName: data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "Sun",
                displayName: copiedExerciseList.displayName,
                exercises: copiedExerciseList.exercises,
                isSelected: false,
                name: ""
              }
              oldDayWorkout.weekdays[foundedIndex].dayIndex=config.weekDays.indexOf(oldDayWorkout.weekdays[foundedIndex].dayName)
            }else{
              oldDayWorkout.weekdays.push({
                dayIndex:config.weekDays.indexOf("Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "Sun"),
                dayName: data.day == "Monday" ? "Mon" : data.day == "Tuesday" ? "Tue" : data.day == "Wednesday" ? "Wed" : data.day == "Thursday" ? "Thu" : data.day == "Friday" ? "Fri" : data.day == "Saturday" ? "Sat" : "Sun",
                displayName: copiedExerciseList.displayName,
                exercises: copiedExerciseList.exercises,
                isSelected: false,
                name: ""
              }) 
            }

            const sortWeekDays=oldDayWorkout.weekdays.sort((a,b)=>a.dayIndex-b.dayIndex);
            oldDayWorkout.weekdays=[...sortWeekDays];

            return{
              ...oldDayWorkout
            }
          })
        }
      }
    })

    // TODO
    handleDayWorkoutCopyTo("")
    
  }

  const handleSelectedSet = (index) => {
    setSelectedSet(index)
  }

  const handleDeleteSet = (index) => {
    setIndexDeleteEnabled(index)
  }

  const handleSetAction = (type, index) => {
    if(type == "delete"){
      if(exerciseDetails.set.length>1){
        let newSelectedSet=selectedSet-1;
        setSelectedSet(newSelectedSet);
      } 
      setExerciseDetails(oldData => {
        oldData.set.splice(index, 1)
        return{
          ...oldData
        }
      })
    }else{
      setExerciseDetails(oldData => {
        oldData.set.push({
          reps:"15",
          weight:{
            value:"",
            unit:""
          }
        })
        return{
          ...oldData
        }
      })
    }
  }

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const { source, destination } = result;
    const newItems = [...dayStorage.exercises];
    const [removed] = newItems.splice(source.index, 1);
    newItems.splice(destination.index, 0, removed);

    // setExerciseDetails(oldData => {
    //   oldData.set.splice(index, 1)
    //   return{
    //     ...oldData
    //   }
    // })

    setDayStorage(oldData => {
      oldData.exercises = newItems;
      return{
        ...oldData
      }
    });

  };

  const handleRevertExercises = () => {
    setDayStorage(oldState => {
      oldState.Days.map(data => {
        if(data.isSelected == true){
          data.isSelected = false;
        }
      })

      oldState.displayName = "";
      oldState.exercises = [];

      return{
        ...oldState
      }
    })
  }

  const handleSelectedNutritionDay = (dayName) => {
    setDayStorage((oldState) => {
      return {
        ...oldState,
        Days: oldState.Days.map((day, idx) =>
          day.name === dayName
            ? { ...day, isSelected: true }
            : {...day,isSelected:false}
        ),
      };
    });
    
    setCurrentWindow("add-nutrition-planner");
    const weekDayIndex=nutritionPlanner.findIndex(d=>d.dayName == dayName);
    if(weekDayIndex>-1) setNutritionCarrier(nutritionPlanner[weekDayIndex].nutritionContents)
    else setNutritionCarrier([]);
  }

  const handleSelectedDays = useCallback((viewType) => {
    return (
      <div>
        {dayStorage.Days[0].isSelected && 
         dayStorage.Days.slice(1, 5).findIndex(item => item.isSelected == true) !== -1  ? viewType == "short" ? "S, " : "Sun, "
        : dayStorage.Days[0].isSelected && dayStorage.Days.filter((day) => day.isSelected).length < 2 ? viewType == "short" ? "S" : "Sunday"
        : dayStorage.Days[0].isSelected ? viewType == "short" ? "S" : "Sun"
        : null} 

       {dayStorage.Days[1].isSelected && 
        dayStorage.Days.slice(2, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(2, 7).filter(item => item.isSelected == true).length > 1 ? viewType == "short" ? "M, " : "Mon, " 
        : dayStorage.Days[1].isSelected && 
        dayStorage.Days.slice(2, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(2, 7).filter(item => item.isSelected == true).length == 1 ? viewType == "short" ? "M & " : "Mon & " 
        : dayStorage.Days[1].isSelected && dayStorage.Days.filter((day) => day.isSelected).length < 2 ? viewType == "short" ? "M" : "Monday" 
        : dayStorage.Days[1].isSelected ? viewType == "short" ? "M" : "Mon"
        : null}
        

        {dayStorage.Days[2].isSelected && 
        dayStorage.Days.slice(3, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(3, 7).filter(item => item.isSelected == true).length > 1 ? viewType == "short" ? "Tu, " : "Tue, " 
        : dayStorage.Days[2].isSelected && 
        dayStorage.Days.slice(3, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(3, 7).filter(item => item.isSelected == true).length == 1 ? viewType == "short" ? "Tu & " : "Tue & " 
        : dayStorage.Days[2].isSelected && dayStorage.Days.filter((day) => day.isSelected).length < 2 ? viewType == "short" ? "Tu" : "Tuesday" 
        : dayStorage.Days[2].isSelected ? viewType == "short" ? "T" : "Tue"
        : null}
  
        {dayStorage.Days[3].isSelected && 
        dayStorage.Days.slice(4, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(4, 7).filter(item => item.isSelected == true).length > 1 ? viewType == "short" ? "W, " : "Wed, " 
        : dayStorage.Days[3].isSelected && 
        dayStorage.Days.slice(4, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(4, 7).filter(item => item.isSelected == true).length == 1 ? viewType == "short" ? "W & " : "Wed & " 
        : dayStorage.Days[3].isSelected && dayStorage.Days.filter((day) => day.isSelected).length < 2 ? viewType == "short" ? "W" : "Wednesday"
        : dayStorage.Days[3].isSelected ? viewType == "short" ? "W" : "Wed"
        : null} 
  
        {dayStorage.Days[4].isSelected && 
        dayStorage.Days.slice(5, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(5, 7).filter(item => item.isSelected == true).length > 1 ? viewType == "short" ? "Th " : "Thu, " 
        : dayStorage.Days[4].isSelected && 
        dayStorage.Days.slice(5, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(5, 7).filter(item => item.isSelected == true).length == 1 ? viewType == "short" ? "Th & " : "Thu & " 
        : dayStorage.Days[4].isSelected && dayStorage.Days.filter((day) => day.isSelected).length < 2 ? viewType == "short" ? "Th" : "Thursday"
        : dayStorage.Days[4].isSelected ? viewType == "short" ? "Th" : "Thu" :
        null} 
  
        {dayStorage.Days[5].isSelected && 
        dayStorage.Days.slice(6, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(6, 7).filter(item => item.isSelected == true).length > 1 ? viewType == "short" ? "F, " : "Fri, " 
        : dayStorage.Days[5].isSelected && 
        dayStorage.Days.slice(6, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(6, 7).filter(item => item.isSelected == true).length == 1 ? viewType == "short" ? "F & " : "Fri & " 
        : dayStorage.Days[5].isSelected && dayStorage.Days.filter((day) => day.isSelected).length < 2 ? viewType == "short" ? "F" : "Friday"
        : dayStorage.Days[5].isSelected ? viewType == "short" ? "F" : "Fri" :
        null} 
        
        {dayStorage.Days[6].isSelected && 
        dayStorage.Days.slice(7, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(7, 7).filter(item => item.isSelected == true).length > 1 ? viewType == "short" ? "Sa, " : "Sat, " 
        : dayStorage.Days[6].isSelected && 
        dayStorage.Days.slice(7, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(7, 7).filter(item => item.isSelected == true).length == 1 ? viewType == "short" ? "Sa & " : "Sat & " 
        : dayStorage.Days[6].isSelected && dayStorage.Days.filter((day) => day.isSelected).length < 2 ? viewType == "short" ? "Sa" : "Saturday"
        : dayStorage.Days[6].isSelected ? viewType == "short" ? "Sa " : "Sat" :
        null} 


        {/* {dayStorage.Days[6].isSelected && 
        dayStorage.Days.slice(7, 7).findIndex(item => item.isSelected == true) !== -1 && 
        dayStorage.Days.slice(7, 7).filter(item => item.isSelected == true).length == 1 ? viewType == "short" ? "Su " : "Sun" 
        : dayStorage.Days[6].isSelected && dayStorage.Days.filter((day) => day.isSelected).length < 2 ? viewType == "short" ? "Su " : "Sunday"
        : dayStorage.Days[6].isSelected ? viewType == "short" ? "Su" : "Sun" :
        null}  */}

      </div>
    )
  },[dayStorage])

  const handleAddNutritionContent = (index) => {
    setCurrentNutritionContentIndex({
      parentIndex : index,
      childIndex : -1
    });
    setCurrentWindow("nutrition-content-list");
  }

  const handleChangeNutritionContent = (parentIndex, childIndex) => {
    setCurrentNutritionContentIndex({
      parentIndex : parentIndex,
      childIndex : childIndex
    });
    if(childIndex>-1) setAllSelectedNutritionContent([nutritionCarrier[parentIndex].contents[childIndex]])
    setCurrentWindow("nutrition-content-list");
  }

  const handleDeleteNutritionContent = (parentIndex, childIndex) => {
    setNutritionCarrier((prev) =>{
      prev[parentIndex].contents.splice(childIndex,1);
      return [...prev]
    }
    );
  }

  const handleAddNutritionMeal = () => {
    setNutritionCarrier((prevData) => [
      ...prevData, {
        days: [],
        mealName: "Untitled",
        mealTime: "",
        contents : []
      }]);    
  }

  const handleNutritionCarrierData  = (name,index) => event =>{
    setNutritionCarrier(oldstate=>{

      oldstate[index][name] = event.target.value;

      return [...oldstate]
    })
  }

  const handleTimeSelect = index =>event => {
    flatpickr = FlatPicker("#time-wrapper"+index, {
      disableMobile: true,
      enableTime: true,
      noCalendar: true,
      dateFormat: "H:i",
      time_24hr: true,
      onChange: (e) => {
        setNutritionCarrier(oldstate=>{


          oldstate[index].mealTime=e[0].toLocaleTimeString("en-US", { hour: '2-digit', minute: '2-digit', hour12: false });
         
          return [...oldstate]
        })
      }
    })
    flatpickr.open();
    event.stopPropagation()
  }

  // TODO - Save & continue
  const handleUpdateNutritionContent = () => {

    const dayNames = dayStorage.Days.filter(d=>d.isSelected).map(d=>d.name);
    
    setNutritionPlanner(oldState=>{
      dayNames.map(dayName=>{
        let findIndex = oldState.findIndex(d=>d.dayName == dayName)
        if(findIndex == -1){
          let dataObject ={
            dayName:dayName,
            dayDisplayName:weekDayDisplayNames[dayName],
            nutritionContents:[...nutritionCarrier]
          }
          oldState.push(dataObject)
        }else{
          oldState[findIndex]={
            ...oldState[findIndex],
            nutritionContents:[...nutritionCarrier]
          }
        }
      });
      oldState.sort((a, b) => {
        return config.weekDays.indexOf(a.dayName) - config.weekDays.indexOf(b.dayName);
      });
      return [...oldState];
    });
    setCurrentWindow("selected-nutrition-content");
  }

  const handleDeleteNutritionMeal = (index) => {
    setNutritionCarrier((prev) => {
      prev.splice(index,1);
      return [...prev]
    });   
  }

  const handleSelectNutritionContent = (content, index) => {
    let list = isCurrentNutritionContentIndex.childIndex>-1?[{content:{...content},index,...nutritionContent}]:[...allSelectedNutritionContent];

    if(isCurrentNutritionContentIndex.childIndex==-1){
      const findExisting = list.findIndex(d => d.content._id == content._id);

      if (findExisting == -1) {
        list.push({content:{...content},index,...nutritionContent})
      }else{
        list.splice(findExisting,1);
      }
    }

    setAllSelectedNutritionContent(list);
  }

  const handleCloseContentSelect = () =>{
    setCurrentWindow("add-nutrition-planner");
  }

  const handleAssignNutritionContent = () => {
    setNutritionCarrier(oldstate=>{
      
      if(isCurrentNutritionContentIndex.childIndex>-1){
        oldstate[isCurrentNutritionContentIndex.parentIndex].contents[isCurrentNutritionContentIndex.childIndex]={
          ...oldstate[isCurrentNutritionContentIndex.parentIndex].contents[isCurrentNutritionContentIndex.childIndex],
          ...allSelectedNutritionContent[0]
        }
      }else{
        if(!oldstate[isCurrentNutritionContentIndex.parentIndex].contents) oldstate[isCurrentNutritionContentIndex.parentIndex].contents=[];
        
        for(const content of allSelectedNutritionContent){
          oldstate[isCurrentNutritionContentIndex.parentIndex].contents.push({...content});
        }
      }
      
      return [...oldstate]
    })  
    setAllSelectedNutritionContent([])
    setCurrentWindow("add-nutrition-planner");
  }

  const handlePlannerHome = (isRedirectHome) => {
    setDayStorage(oldstate=>{
      oldstate.Days.map(d=>{
        d.isSelected=false
      })

      return {...oldstate}
    })
    setCurrentWindow((nutritionPlanner.length && !isRedirectHome)?"selected-nutrition-content":"create-planner");
  }

  useEffect(() => {
    if(allSelectedNutritionContent.length>0 && currentWindow == "nutrition-content-list") setButtonLock(false);
    else if(currentWindow == 'add-nutrition-planner' && nutritionCarrier.filter(d=>d.mealName && d.mealTime && d.contents.length).length) setButtonLock(false)
    else setButtonLock(true);
  },[allSelectedNutritionContent,currentWindow,nutritionCarrier])


  useEffect(()=>{
    if(selectedWeekDay>-1 && selectedExerciseIndex>-1 && selectedContent && selectedContent.contentType=="mainexercise" && currentWindow == "add-exercise"){
      if(plannerType == 'day'){
      
      }else{
        if (selectedOptionalExerciseIndex > -1) {
          if (selectedContent && dayStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content && dayStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content._id &&  dayStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content._id == selectedContent._id && dayStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter && dayStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter.isParameterAdded) {
            setExerciseDetails({
              ...exerciseDetails,
              ...dayStorage.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter
            });
          } else {
            setExerciseDetails({
              ...exerciseDetails,
              set: [
                {
                  reps: "15",
                  weight:{
                    value:"",
                    unit:"Kg"
                  }
                }
              ],
              weight: {
                value: 0,
                unit: "Kg"
              },
              count: 0,
              distance: {
                value: 0,
                unit: "Km"
              },
              duration: {
                hour: 0,
                min: 0
              }
            })
          }
        } else {
          if (selectedContent && dayStorage.exercises[selectedExerciseIndex].content && dayStorage.exercises[selectedExerciseIndex].content._id && dayStorage.exercises[selectedExerciseIndex].content._id == selectedContent._id && dayStorage.exercises[selectedExerciseIndex].parameter && dayStorage.exercises[selectedExerciseIndex].parameter.isParameterAdded) {
            setExerciseDetails({
              ...exerciseDetails,
              ...dayStorage.exercises[selectedExerciseIndex].parameter
            })
          } else {
            setExerciseDetails({
              ...exerciseDetails,
              set: [{
                reps: "15",
                weight:{
                  value:"",
                  unit:"Kg"
                }
              }],
              weight: {
                value: 0,
                unit: "Kg"
              },
              count: 0,
              distance: {
                value: 0,
                unit: "Km"
              },
              duration: {
                hour: 0,
                min: 0
              }
            })
          }
        }
      }
    }else{
      setExerciseDetails({
        ...exerciseDetails,
        set: [
          {
            reps: "15",
            weight:{
              value:"",
              unit:"Kg"
            }
          }
        ],
        weight: {
          value: 0,
          unit: "Kg"
        },
        count: 0,
        distance: {
          value: 0,
          unit: "Km"
        },
        duration: {
          hour: 0,
          min: 0
        }
      })
    }
  },[selectedWeekDay,selectedExerciseIndex,selectedOptionalExerciseIndex,selectedContent])

  const toggleWeekDayDropdown = (mainExerciseIndex, optionalExerciseIndex = -1) => {
    if(plannerType == 'day'){
      if (mainExerciseIndex > -1) {
        setDayPlanner(oldstate => {
          if (optionalExerciseIndex > -1) {
            oldstate.workout[mainExerciseIndex].optionalExercises[optionalExerciseIndex].isDropdownOpen = oldstate.workout[mainExerciseIndex].optionalExercises[optionalExerciseIndex].isDropdownOpen ? false : true;
          } else {
            oldstate.workout[mainExerciseIndex].isDropdownOpen = oldstate.workout[mainExerciseIndex].isDropdownOpen ? false : true;
          }
          return {
            ...oldstate
          }
        })
      }
    }else{
      if (mainExerciseIndex > -1) {
        setDayStorage(oldstate => {
          if (optionalExerciseIndex > -1) {
            oldstate.exercises[mainExerciseIndex].optionalExercises[optionalExerciseIndex].isDropdownOpen = oldstate.exercises[mainExerciseIndex].optionalExercises[optionalExerciseIndex].isDropdownOpen ? false : true;
          } else {
            oldstate.exercises[mainExerciseIndex].isDropdownOpen = oldstate.exercises[mainExerciseIndex].isDropdownOpen ? false : true;
          }
          return {
            ...oldstate
          }
        })
      }
    }
  }


  const handleViewExerciseDay = index => event => {
    setSelectedWeekDay(index);
    handleSelectedWeekDays(index);
    toggleCurrentWindow("weekdays-exercise")
  }


  const confirmTempSelectionIDs = event => {
    switch (isContentFilter) {
      case "exercise-type":
        setSortExerciseTypeIDs(tempIDs)
        break;
      case "exercise-level":
        setSortExerciseLevelIDs(tempIDs)
        break;
      case "muscle-type":
        setTargetMuscleIDs(tempIDs);
        break;
      case "branch":
        setBranchIDs(tempIDs);
        break;
      default:
      // do somethig 

    }

    toggleContentFilter(isContentFilter)
  }


  const handleTempIDs = id => event => {
    let ids = [...tempIDs];
    let index = ids.findIndex(d => d == id);
    if (index == -1) {
      ids.push(id);
    } else {
      ids.splice(index, 1);
    }
    setTempIDs(ids);
  }


  const handleGymSearch = async event => {
    try {
      await setGyms([])
      setGymSearchKey(event.target.value)
    } catch (error) {
      // do something
    }
  }

  const handleClearGym = async () => {
    setSelectedGym("");
    setBranchIDs([])
  }

  const handleContentRole = (contentRole) => {
    if (contentRole == "branch" && ContentRole == "gym" && selectedGym) {
      isSearchBranch = true;
      setSearchBranch(isSearchBranch);
      setBranches([])
    }
    setContentRole(contentRole);
  }


  const handleContentSearchKey = async event => {
    await setContents([]);
    setContentSearchKey(event.target.value);
  }


  const addDayExerciseContent = event => {
    event.preventDefault();
    setDayStorage(oldstate => {
      if (selectedOptionalExerciseIndex > -1) {
        oldstate.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content = {
          ...selectedContent
        };
      } else {
        oldstate.exercises[selectedExerciseIndex].content = {
          ...selectedContent
        }
      }

      let exerciseDetailValues = {};

      if (selectedContent.exerciseUnit == "weight") {
        if (exerciseDetails.set.length > 0) {
          exerciseDetailValues = {
            set: exerciseDetails.set,
            isParameterAdded: true
          }
        }
      } else if (selectedContent.exerciseUnit == "time") {
        if (exerciseDetails.duration.hour > 0 || exerciseDetails.duration.min > 0) {
          exerciseDetailValues = {
            duration: { ...exerciseDetails.duration },
            isParameterAdded: true
          }
        }
      } else if (selectedContent.exerciseUnit == "distance") {
        if (exerciseDetails.distance.value > 0 && exerciseDetails.distance.unit) {
          exerciseDetailValues = {
            distance: { ...exerciseDetails.distance },
            isParameterAdded: true
          }
        }
      } else if (selectedContent.exerciseUnit == "number") {
        if (exerciseDetails.count > 0) {
          exerciseDetailValues = {
            count: exerciseDetails.count,
            isParameterAdded: true
          }
        }
      }

      if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex == -1) {
        oldstate.exercises[selectedExerciseIndex].parameter = {
          ...exerciseDetailValues,
          unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
        }
      }
      if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex > -1) {
        oldstate.exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter = {
          ...exerciseDetailValues,
          unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
        }
      }

      return ({
        ...oldstate
      })
    })
    setSelectedContent("");
    toggleBackToPrevWindow();
    event.stopPropagation()
  }


  const addExerciseContent = event => {
    event.preventDefault()
    if(plannerType == 'day'){
      setDayPlanner(oldstate=>{
        if (sortByContentType == "cooldown") {
          if (selectedOptionalExerciseIndex > -1) {
            oldstate.cooldown[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex] = {
              ...selectedContent
            }
          } else {
            oldstate.cooldown[selectedExerciseIndex].content = {
              ...selectedContent
            }
          }
        } else if (sortByContentType == "warmup") {
          if (selectedOptionalExerciseIndex > -1) {
            oldstate.warmup[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex] = {
              ...selectedContent
            }
          } else {
            oldstate.warmup[selectedExerciseIndex].content = {
              ...selectedContent
            }
          }
        } else if (sortByContentType == "mainexercise") {
          if (selectedOptionalExerciseIndex > -1) {
            oldstate.workout[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content = {
              ...selectedContent
            };
          } else {
            oldstate.workout[selectedExerciseIndex].content = {
              ...selectedContent
            }
          }

          let exerciseDetailValues = {};


          if (selectedContent.exerciseUnit == "weight") {
            if (exerciseDetails.set.length > 0) {
              exerciseDetailValues = {
                set: [...exerciseDetails.set ],
                isParameterAdded: true
              }
            }
          } else if (selectedContent.exerciseUnit == "time") {
            if (exerciseDetails.duration.hour > 0 || exerciseDetails.duration.min > 0) {
              exerciseDetailValues = {
                duration: { ...exerciseDetails.duration },
                isParameterAdded: true
              }
            }
          } else if (selectedContent.exerciseUnit == "distance") {
            if (exerciseDetails.distance.value > 0 && exerciseDetails.distance.unit) {
              exerciseDetailValues = {
                distance: { ...exerciseDetails.distance },
                isParameterAdded: true
              }
            }
          } else if (selectedContent.exerciseUnit == "number") {
            if (exerciseDetails.count > 0) {
              exerciseDetailValues = {
                count: exerciseDetails.count,
                isParameterAdded: true
              }
            }
          }

          if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex == -1) {
            oldstate.workout[selectedExerciseIndex].parameter = {
              ...exerciseDetailValues,
              unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
            }
          }
          if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex > -1) {
            oldstate.workout[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter = {
              ...exerciseDetailValues,
              unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
            }
          }

          
        }
        return {
          ...oldstate
        };
      })
    }else{
      setWorkoutPlanner(oldstate => {
        if (sortByContentType == "cooldown") {
          if (selectedOptionalExerciseIndex > -1) {
            oldstate.cooldown[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex] = {
              ...selectedContent
            }
          } else {
            oldstate.cooldown[selectedExerciseIndex].content = {
              ...selectedContent
            }
          }
        } else if (sortByContentType == "warmup") {
          if (selectedOptionalExerciseIndex > -1) {
            oldstate.warmup[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex] = {
              ...selectedContent
            }
          } else {
            oldstate.warmup[selectedExerciseIndex].content = {
              ...selectedContent
            }
          }
        } else if (sortByContentType == "mainexercise") {
          if (selectedOptionalExerciseIndex > -1) {
            oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].content = {
              ...selectedContent
            };
          } else {
            oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].content = {
              ...selectedContent
            }
          }

          let exerciseDetailValues = {};

          if (selectedContent.exerciseUnit == "weight") {
            if (exerciseDetails.set.length > 0) {
              exerciseDetailValues = {
                // weight: { ...exerciseDetails.weight },
                set: [ ...exerciseDetails.set ],
                isParameterAdded: true
              }
            }
          } else if (selectedContent.exerciseUnit == "time") {
            if (exerciseDetails.duration.hour > 0 || exerciseDetails.duration.min > 0) {
              exerciseDetailValues = {
                duration: { ...exerciseDetails.duration },
                isParameterAdded: true
              }
            }
          } else if (selectedContent.exerciseUnit == "distance") {
            if (exerciseDetails.distance.value > 0 && exerciseDetails.distance.unit) {
              exerciseDetailValues = {
                distance: { ...exerciseDetails.distance },
                isParameterAdded: true
              }
            }
          } else if (selectedContent.exerciseUnit == "number") {
            if (exerciseDetails.count > 0) {
              exerciseDetailValues = {
                count: exerciseDetails.count,
                isParameterAdded: true
              }
            }
          }

          if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex == -1) {
            oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].parameter = {
              ...exerciseDetailValues,
              unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
            }
          }
          if (selectedWeekDay > -1 && selectedExerciseIndex > -1 && selectedOptionalExerciseIndex > -1) {
            oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].optionalExercises[selectedOptionalExerciseIndex].parameter = {
              ...exerciseDetailValues,
              unit: selectedContent.exerciseUnit ? selectedContent.exerciseUnit : ""
            }
          }
          
        }
        return ({
          ...oldstate
        })
      });
    }
    setSelectedContent("");
    toggleBackToPrevWindow();
    event.stopPropagation()
  }

  const handleSelectContent = content => event => {
    setSelectedContent(content);
  }

  const toggleExerciseContentManageWindow = (opindex = -1, content = {}, exIndex,byContentType) => event => {
    event.preventDefault();
    setSelectedSet(0);
    if(exIndex != null){
      setSelectedExerciseIndex(exIndex);
      if (currentWindow == "weekdays-exercise"){
        toggleWeekDayDropdown(exIndex, -1);
      }
    }
    if(byContentType){
      sortByContentType=byContentType;
      setSortByContentType(sortByContentType);
    }
    handleExerciseContentWindow(opindex, content);
    event.stopPropagation();
  }

  const handleExerciseContentWindow = (opindex, content) => {
    let typeValue = currentWindow == "weekdays-exercise" ? "mainexercise" : currentWindow == "cool-down" ? "cooldown" : currentWindow == "warm-up" ? "warmup" : plannerType == 'day'?sortByContentType:'';
    //if (!typeValue) return "";
    setSelectedOptionalExerciseIndex(opindex)
    setSelectedContent({ ...content })
    sortByContentType = typeValue;
    setSortByContentType(typeValue);
    toggleCurrentWindow("add-exercise");
  }

  const handleAddOptionalWeekdayExercise = () => {
    const opindex=dayStorage.exercises[selectedExerciseIndex].optionalExercises.length;
    setDayStorage(oldstate => {
      oldstate.exercises[selectedExerciseIndex].optionalExercises.push({
        content: {},
        parameter: {}
      })
      return ({
        ...oldstate
      })
    })

    setTimeout(() => {
      handleExerciseContentWindow(opindex, {})
    }, 10);
  }


  const handleAddOptionalExerise = (currentIndex,contentType) => {
    if(plannerType == 'day'){
      setDayPlanner(oldstate => {
        if (contentType == "cooldown") {
          oldstate.cooldown[selectedExerciseIndex].optionalExercises.push({})
        } else if(contentType == "warmup") {
          oldstate.warmup[selectedExerciseIndex].optionalExercises.push({})
        } else if (contentType == "mainexercise") {
          oldstate.workout[selectedExerciseIndex].optionalExercises.push({
            content: {},
            parameter: {}
          })
        }
        return ({
          ...oldstate
        })
      })
    }else{
      setWorkoutPlanner(oldstate => {
        if (currentWindow == "cool-down") {
          oldstate.cooldown[selectedExerciseIndex].optionalExercises.push({})
        } else if (currentWindow == "warm-up") {
          oldstate.warmup[selectedExerciseIndex].optionalExercises.push({})
        } else if (currentWindow == "weekdays-exercise") {
          oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].optionalExercises.push({
            content: {},
            parameter: {}
          })
        }
        return ({
          ...oldstate
        })
      })
    }

    setTimeout(() => {
      handleExerciseContentWindow(currentIndex, {})
    }, 10);

  }

  const handleRemoveOptionalWeekDayExercise = index =>  event => {
    setDayStorage(oldstate => {
      oldstate.exercises[selectedExerciseIndex].optionalExercises.splice(index, 1);
      return ({
        ...oldstate
      })
    })
    event.stopPropagation();
  }

  const handleRemoveOptionalExercise = (index,sortByContentType) => event => {
   if(plannerType == 'day'){
    if(!sortByContentType) return;
    setDayPlanner(oldstate => {
      if (sortByContentType == "cooldown") {
        oldstate.cooldown[selectedExerciseIndex].optionalExercises.splice(index, 1);
      } else if (sortByContentType == "warmup") {
        oldstate.warmup[selectedExerciseIndex].optionalExercises.splice(index, 1);
      } else if (sortByContentType == "mainexercise") {
        oldstate.workout[selectedExerciseIndex].optionalExercises.splice(index, 1);
      }
      return ({
        ...oldstate
      })
    })
   }else{
    setWorkoutPlanner(oldstate => {
      if (currentWindow == "cool-down") {
        oldstate.cooldown[selectedExerciseIndex].optionalExercises.splice(index, 1);
      } else if (currentWindow == "warm-up") {
        oldstate.warmup[selectedExerciseIndex].optionalExercises.splice(index, 1);
      } else if (currentWindow == "weekdays-exercise") {
        oldstate.weekdays[selectedWeekDay].exercises[selectedExerciseIndex].optionalExercises.splice(index, 1);
      }
      return ({
        ...oldstate
      })
    })
   }
    event.stopPropagation()
  }

  const handleSelectExercise = index => event => {
    setSelectedExerciseIndex(index);
    if (currentWindow == "weekdays-exercise" || plannerType=='day'){
      toggleWeekDayDropdown(index, -1);
    }
    event.stopPropagation()
  }

  const handleClearBranch = () => {
    setBranchIDs([]);
  }


  const clearExerciseLevels = () => {
    setSortExerciseLevelIDs([]);
  }

  const clearExerciseTypes = () => {
    setSortExerciseTypeIDs([])
  }

  const clearTargetMuscles = () => {
    setTargetMuscleIDs([]);
  }

  const handleAddExercise = (index = -1) => {
    switch (currentWindow) {
      case "weekdays-exercise":
        setWorkoutPlanner(oldstate => {
          let exerciseTemplateCopy = {
            ...exerciseTemplate
          }
          exerciseTemplateCopy.content = {}
          oldstate.weekdays[selectedWeekDay].exercises.push(exerciseTemplateCopy);
          return { ...oldstate }
        })
        break;
      case "cool-down":
        setWorkoutPlanner(oldstate => {
          let exerciseTemplateCopy = {
            ...exerciseTemplate
          }
          delete exerciseTemplateCopy.parameter;
          exerciseTemplateCopy.content = {}

          oldstate.cooldown.push(exerciseTemplateCopy);
          return ({
            ...oldstate
          })
        })
        break;
      case "warm-up":
        setWorkoutPlanner(oldstate => {
          let exerciseTemplateCopy = {
            ...exerciseTemplate
          }
          delete exerciseTemplateCopy.parameter;
          exerciseTemplateCopy.content = {}
          oldstate.warmup.push(exerciseTemplateCopy);
          return(
            {...oldstate}
          )
        })
        break;
      default:
        if(plannerType == 'day'){
          setDayPlanner(oldstate => {
            let exerciseTemplateCopy = {
              ...exerciseTemplate
            }
            exerciseTemplateCopy.content = {}
            oldstate.workout.push(exerciseTemplateCopy);
            return { ...oldstate }
          })
        }
      // do something 
    }

  }

  const handleAddDayExercises = () => {
    setDayStorage(oldstate => {
      let exerciseTemplateCopy = {
        ...exerciseTemplate
      }
      exerciseTemplateCopy.content = {}
      oldstate.exercises.push(exerciseTemplateCopy);
      return { ...oldstate }
    })
  } 

  useEffect(() =>{
    handleAddDayExercises();
  },[])

  const removeDayExercise = (index) => {

    let exerciseTemplateCopy = {
      ...exerciseTemplate
    }

    setDayStorage(oldstate => {
      if(index == 0 && oldstate.exercises.length == 1){
        oldstate.exercises = [];  
        oldstate.exercises.push(exerciseTemplateCopy)
      }else{
        oldstate.exercises.splice(index, 1);
      }
      return ({
        ...oldstate
      })
    })
  }


  const removeExercise = (index,sortByContentType) => event => {
    if(plannerType == 'day'){
      if(!sortByContentType) return;
      setDayPlanner(oldstate => {

        if (sortByContentType == "cooldown") {
          if(index == 0 && oldstate.warmup.length == 1){
            oldstate.cooldown[index].content = "";  
          }else{
            oldstate.cooldown.splice(index, 1);
          }
        } else if (sortByContentType == "warmup") {
          if(index == 0 && oldstate.warmup.length == 1){
            oldstate.warmup[index].content = "";  
          }else{
            oldstate.warmup.splice(index, 1);
          }
        } 
        else if (sortByContentType == "mainexercise") {
          oldstate.workout.splice(index, 1);
          if(oldstate.workout.length<1) oldstate.workout.push({
            ...exerciseTemplate
          });
        }
        return ({
          ...oldstate
        })
      })
    }else{
      setWorkoutPlanner(oldstate => {

        if (currentWindow == "cool-down") {
          if(index == 0 && oldstate.warmup.length == 1){
            oldstate.cooldown[index].content = "";  
          }else{
            oldstate.cooldown.splice(index, 1);
          }
        } else if (currentWindow == "warm-up") {
          if(index == 0 && oldstate.warmup.length == 1){
            oldstate.warmup[index].content = "";  
          }else{
            oldstate.warmup.splice(index, 1);
          }
        } 
        else if (currentWindow == "weekdays-exercise") {
          oldstate.weekdays[selectedWeekDay].exercises.splice(index, 1);
        }
        return ({
          ...oldstate
        })
      })
    }
    event.stopPropagation()
  }

  //API method start
  const handleBranchScroll = async event => {
    try {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight)) && pageNo.branch < pageCount.branch && !isBrachSpinnerLoader) {
        setBranchSpinnerLoader(true)
        pageNo.branch = pageNo.branch + 1;
        setPageNo({
          ...pageNo
        });
        await GetAllBranches();
        setBranchSpinnerLoader(false)
      }
    } catch (error) {
      setBranchSpinnerLoader(false)
    }
  }

  const handleGymScroll = async event => {
    try {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      if ((scrollTop > 0) && ((Math.ceil((scrollTop + clientHeight)) >= scrollHeight)) && pageNo.gym < pageCount.gym && !isGymSpinnerLoader) {
        setGymSpinnerLoader(true)
        pageNo.gym = pageNo.gym + 1;
        setPageNo({
          ...pageNo
        });
        await GetAllGyms();
        setGymSpinnerLoader(false)
      }
    } catch (error) {
      setGymSpinnerLoader(false)
    }
  }

  const handleSelectGym = gym => event => {
    try {
      setSelectedGym(gym);
      if (ContentRole == "branch") {
        isSearchBranch = true;
        setSearchBranch(isSearchBranch);
        setBranches([]);
      }
      toggleContentFilter();
    } catch (error) {
      // do someting
    }
  }



  const GetGymParams = () => {
    let params = {
      pageNo: pageNo.gym,
      pageSize: pageSize.gym
    };
    if (gymSearchKey) params.q = gymSearchKey;
    return params;
  }

  const GetGymCount = async () => {
    try {
      let params = GetGymParams();
      let response = await getGymCount(user._id, token, params);
      if (!response.error) {
        pageNo.gym = 1;
        setPageNo({
          ...pageNo
        });
        setPageCount({
          ...pageCount,
          gym: Math.ceil(response.COUNT / pageSize.gym)
        })
        setTotal({
          ...Total,
          gym: response.COUNT
        })
      }

    } catch (error) {
      // do something
    }
  }

  const GetAllGyms = async () => {
    try {
      let params = GetGymParams();
      let response = await getAllGym(user._id, token, params);
      if (!response.error) {
        setGyms([...Gyms, ...response]);
      }
    } catch (error) {
      // do something 
    }
  }

  const handleBranchSearch = async event => {
    await setBranches([])
    branchSearchKey = event.target.value;
    setBranchSearchKey(branchSearchKey);
    isSearchBranch = true
    setSearchBranch(isSearchBranch)
  }


  const handleAccessRight = accessRight =>{
    setSortByAccessRight(accessRight);
  }


  const GetBranchParams = () => {
    let params = {
      pageNo: pageNo.branch,
      pageSize: pageSize.branch
    };

    if (branchSearchKey) params.q = branchSearchKey;
    if (selectedGym) params.gymIds = selectedGym._id;

    return params;
  }

  const GetBranchCount = async () => {
    try {
      let params = GetBranchParams();
      let response = await getBranchCount(user._id, token, params);
      if (!response.error) {
        pageNo.branch = 1;
        setPageNo({
          ...pageNo
        });
        setPageCount({
          ...pageCount,
          branch: Math.ceil(response.COUNT / pageSize.gym)
        })
        setTotal({
          ...Total,
          branch: response.COUNT
        })
      }

    } catch (error) {
      // do something
    }
  }

  const GetAllBranches = async () => {
    try {
      let params = GetBranchParams();
      let response = await getAllBranches(user._id, token, params);
      if (!response.error) {
        setBranches([...Branches, ...response]);
      }
    } catch (error) {
      // do something 
    }
  }

  const getContentParams = () => {
    let params = {
      pageNo: pageNo.content,
      pageSize: pageSize.content
    };
    params.activationStatus = "activate";
    if (contentSearchKey) params.q = contentSearchKey;
    if (sortExerciseLevelIDs.length) params.exerciseLevelIDs = sortExerciseLevelIDs;
    if (sortExerciseTypeIDs.length) params.exerciseTypeIDs = sortExerciseTypeIDs;
    if (sortTargetMuscleIDs.length) params.targetMuscleIDs = sortTargetMuscleIDs;
    if (ContentRole != "All") params.contentRole = ContentRole;
    params.contentType = sortByContentType;
    params.accessRight=sortByAccessRight;
    if(plannerType == 'nutrition') params.contentType = 'nutrition';
    return params;
  }

  const GetContentCount = async () => {
    try {
      let params = getContentParams();
      delete params.pageNo;
      delete params.pageSize;
      let response = await getContentsCount(user._id, token, params);
      if (response.error) {
        // do something
      } else {
        pageNo.content = 1;
        setPageNo({
          ...pageNo
        })
        setPageCount({
          ...pageCount,
          content: Math.ceil(response.COUNT / pageSize.content)
        })
        setTotal({
          ...Total,
          content: response.COUNT
        })
      }
    } catch (error) {
      // do something
    }
  }

  const GetAllContents = async (isReload) => {
    try {
      let params = getContentParams();
      let response = await getAllContents(user._id, token, params);
      if (response.error) {
        // do something
      } else {
        if(isReload) await setContents(response); 
        else await setContents([...Contents, ...response]);
      }
    } catch (error) {
      // do something
    }
  }


  const GetAllParams = async (type = "exerciseName") => {
    try {
      let params = {
        noLimit: 'noLimit',
        type
      };
      let responses = await getAllParameters(user._id, token, params);
      if (responses.error) {
        // do something
        return []
      } else {
        return responses;
      }
    } catch (error) {
      // do something
      return []
    }
  }

  //end method

  const handleChange = name => event => {
    setWorkoutPlanner({
      ...workoutPlanner,
      [name]: event.target.value
    });
  }



  const toggleInputFields = (id) => event => {

    event.preventDefault();
    setCurrentElementId(id);
    
    if (id == 'weight-unit') setExerciseWeightUnitTypeDropdownOpen(!exerciseWeightUnitTypeDropdownOpen);
    if (id == 'exercise-name') setWeekdayExerciseTypeOpenDropdown(true);
    if(id == 'access-right') setAccessRightDropdown(!isAccessRightDropdown);
    if (event) {
      let interval = setInterval(() => {
        let element = event.target.querySelector('input');
        if (element) {
          element.focus();
          clearInterval(interval)
        }
      }, 0);
    }

    event.stopPropagation();
  }

  const toggleBackToPrevWindow = async () => {
    setEditActive(false);
    if (prevPopupWindow != "add-exercise") {
      if(currentWindow == "weekdays-exercise"){    
        setWorkoutPlanner(prev=>{
          prev.weekdays.map((data, index) => {
            if(data.isSelected){
              data[index] = {
                ...data[index],
                ...prev.weekdays[0]
              };
            }
          });
          return {...prev}
        });

      }
      await setContents([])
      setSelectedContent("");
    }
    if (prevPopupWindow) {
      setCurrentWindow(prevPopupWindow);
      prevPopupWindow = "";
      setPrevPopupWindow(prevPopupWindow)
    } else {
      setCurrentWindow("create-planner")
    }
  }

  const toggleCurrentWindow = (newcurrentWindow) => {
    prevPopupWindow = currentWindow;
    setPrevPopupWindow(prevPopupWindow);
    setCurrentWindow(newcurrentWindow);
  }

  const getSelectedExerciseType = (selectedExercise) => event => {
    event.preventDefault();
    setWeekdayExerciseTypeOpenDropdown(false)
    setWorkoutPlanner(oldstate => {
      oldstate.weekdays[selectedWeekDay].name = selectedExercise.name;
      if(!oldstate.weekdays[selectedWeekDay].displayName)  {
        oldstate.weekdays[selectedWeekDay].displayName = selectedExercise.name;
      }
      return {
        ...oldstate
      }
    })
    event.stopPropagation();
  }


  const handleSetReps = event => {
    setExerciseDetails(oldState => {
      oldState.set[selectedSet].reps = event.target.value
      return{
        ...oldState
      }
    })
  }


  const handleChangeExerciseDetails = name => event => {
    setExerciseDetails(oldstate => {
      let listNames = `${name}`.split('.');
      if (listNames.length > 1) {
        if(listNames[0] == 'weight') oldstate.set[selectedSet][listNames[0]][listNames[1]]= event.target.value;
        else oldstate[listNames[0]][listNames[1]]= event.target.value;
      } else {
        oldstate[name] = event.target.value;
      }
      return {
        ...oldstate
      }
    })
  }



  const getSelectedWeightUnit = (selectedUnit) => {
    setExerciseWeightUnitTypeDropdownOpen(false)
    setExerciseDetails(prev=>{
      prev.set[selectedSet]['weight']['unit']=selectedUnit;
      return {
        ...prev
      };
    });
  }

  const getSelectedDistanceUnit = (selectedUnit) => {
    setExerciseDistanceUnitTypeDropdownOpen(false);
    setExerciseDetails({
      ...exerciseDetails,
      distance: {
        ...exerciseDetails.distance,
        unit: selectedUnit
      }
    })
  }

  const toggleExerciseDetailsView = () => {
    if (isExerciseDetailsViewOpen) {
      setExerciseDetailsViewOpen(false)
    } else {
      setExerciseDetailsViewOpen(true)
    }
  }

  const toggleContentFilter = (filterType) => {
    if (isContentFilter == filterType) {
      if (prevContentFilterOpen) {
        setContentFilter(prevContentFilterOpen);
        prevContentFilterOpen = "";
        setPrevContentFilterOpen(prevContentFilterOpen);
      } else {
        setContentFilter('')
        setTempIDs([])
      }
    } else {
      prevContentFilterOpen = isContentFilter;
      setContentFilter(filterType)
      setPrevContentFilterOpen(prevContentFilterOpen)
      if (filterType == "exercise-type") {
        setTempIDs(sortExerciseTypeIDs);
      } else if (filterType == "exercise-level") {
        setTempIDs(sortExerciseLevelIDs);
      } else if (filterType == "muscle-type") {
        setTempIDs(sortTargetMuscleIDs);
      } else if (filterType == "branch") {
        setTempIDs(branchIDs);
      }
    }
  }

  const toggleVideoPlayer = (content = "") => {
    if (isVideoPlayerOpen) {
      setVideoPlayerOpen(false)
    } else {
      if (content) {
        setDisplayContent({
          ...displayContent,
          ...content
        })
      }
      setVideoPlayerOpen(true)
    }
  }

  const handleDayRemove = name => event =>{
    event.preventDefault();
    setWorkoutPlanner(prev=>{
      let index=prev.weekdays.findIndex(data=>data.dayName == name);
      if(index>-1){
        prev.weekdays.splice(index,1);
      }

      const sortWeekDays=prev.weekdays.sort((a,b)=>a.dayIndex-b.dayIndex);
      prev.weekdays=[...sortWeekDays];

      return {
        ...prev
      };
    });
  }

  const handleWeekDayWorkoutDisplayName = event => {
    if(plannerType == 'day'){
      setDayPlanner(oldstate=>{
        oldstate.name=event.target.value;
        return {...oldstate}
      })
    }else{
      setDayStorage(oldstate => {
        oldstate.displayName = event.target.value;
        return {
          ...oldstate
        }
      })
    }
  }

  const handleScroll = async event => {
    const { offsetHeight, scrollTop, scrollHeight } = event.target;

    if (offsetHeight + scrollTop === scrollHeight && pageNo.content < pageCount.content) {
      pageNo.content = pageNo.content + 1;
      setPageNo(pageNo);
      setContentLoader(true);
      await GetAllContents();
      setContentLoader(false);
    }
}

const handleNutritionCarrierContent= (parentIndex,childIndex,name)=>event =>{
  setNutritionCarrier(oldstate=>{
    oldstate[parentIndex].contents[childIndex][name]=event.target.value;
    return [...oldstate]
  });
}

const closePopup = () =>{
  setWorkoutPlanner({
    ...workoutPlanner,
    exerciseLevelIDs: [],
    name: "",
    warmup: [{
      content: {
        name: "",
        contentId: "",
        isSelected: false
      },
      optionalExercises: []
    }],
    cooldown: [{
      content: {
        name: "",
        contentId: "",
        isSelected: false
      },
      optionalExercises: []
    }],
    weekdays: [],
  })
  setNutritionCarrier([])
  setNutritionPlanner([])
  if(props.toggleAddWorkoutPlanner) props.toggleAddWorkoutPlanner()
}


  useEffect(() => {
    if(currentWindow == 'create-planner') checkDataField()
  }, [workoutPlanner,dayPlanner,plannerType,nutritionPlanner,currentWindow]);

  useEffect(() => {
    if (currentWindow == "add-exercise" ||  currentWindow == "nutrition-content-list") setContentApiAction(!contentApiAction)
  }, [currentWindow])

  useEffect(async () => {
    try {
      if (isSearchBranch && Branches.length == 0 && selectedGym) {
        setBranchSpinnerLoader(true)
        isSearchBranch = false;
        setSearchBranch(isSearchBranch)
        await GetBranchCount();
        await GetAllBranches()
        setBranchSpinnerLoader(false)
      }
    } catch (Error) {
      // do something
      setBranchSpinnerLoader(false)
    }
  }, [isSearchBranch, Branches, selectedGym])


  useEffect(async () => {
    try {
      setGymSpinnerLoader(true)
      await GetGymCount()
      await GetAllGyms()
      setGymSpinnerLoader(false)
    } catch (error) {
      // do something
      setGymSpinnerLoader(false)
    }
  }, [gymSearchKey])

  useEffect(async () => {
    try {
      if (currentWindow == "add-exercise" || currentWindow == "nutrition-content-list") {
        setContentLoader(true);
        await GetContentCount();
        await GetAllContents(true);
        setContentLoader(false);
      }
    } catch (error) {
      // do something
      setContentLoader(false);
    }
  }, [contentApiAction,plannerType,sortByAccessRight, contentSearchKey, sortExerciseTypeIDs, sortExerciseLevelIDs, sortTargetMuscleIDs, ContentRole, selectedGym, branchIDs])

  useEffect(async () => {
    try {
      let exerciseNameList = await GetAllParams('exerciseName');
      setExerciseNames(exerciseNameList);
    } catch (error) {

    }
  }, [])

  useEffect(() => {
    if (props.isEdit && props.workoutPlanner) {
      if(props.workoutPlanner.isOneDayPlanner){
        setPlannerType("day");
        setDayPlanner({
          ...dayPlanner,
          exerciseLevelIDs: props.workoutPlanner.exerciseLevelIDs ? props.workoutPlanner.exerciseLevelIDs : [],
          workoutPlannerId: props.workoutPlanner._id,
          name: props.workoutPlanner.name,
          cooldown: props.workoutPlanner.cooldown,
          warmup: props.workoutPlanner.warmup,
          accessRight:props.workoutPlanner.accessRight,
          workout: props.workoutPlanner.workout
        });
      }else{
        setPlannerType("weekday");
        setWorkoutPlanner({
          ...workoutPlanner,
          exerciseLevelIDs: props.workoutPlanner.exerciseLevelIDs ? props.workoutPlanner.exerciseLevelIDs : [],
          workoutPlannerId: props.workoutPlanner._id,
          name: props.workoutPlanner.name,
          cooldown: props.workoutPlanner.cooldown,
          warmup: props.workoutPlanner.warmup,
          accessRight:props.workoutPlanner.accessRight,
          weekdays: props.workoutPlanner.weekdays.sort((a,b)=>a.dayIndex-b.dayIndex)
        });
        setWeekdayFrequency(props.workoutPlanner.weekdays.length);
        // console.log("trs")
        // console.log(props.workoutPlanner);
      }
    } if(props.isEdit && props.nutritionPlanner){
      setPlannerType('nutrition')
      setWorkoutPlanner({
        ...workoutPlanner,
        workoutPlannerId:props.nutritionPlanner._id,
        name:props.nutritionPlanner.name,
        accessRight:props.nutritionPlanner.accessRight
      })
      setNutritionPlanner(oldState=>{

        if(props.nutritionPlanner.nutritionSchedules){
          for(let nutritionSchedule of props.nutritionPlanner.nutritionSchedules){
            let nutritionPlanner = {
              dayName:nutritionSchedule.dayName,
              dayDisplayName:config.weekDayDisplayNames[nutritionSchedule.dayName]
            }

            nutritionPlanner.nutritionContents=[];

            if(nutritionSchedule.meals){
              for(let meal of nutritionSchedule.meals){
                let nutritionContent={
                  mealName:meal.mealName,
                  mealTime:meal.mealTime,
                  contents:[]
                };

                if(meal.items){
                  for(let item of meal.items){
                    let content = {
                      servingSize:(item.servingSize&&item.servingSize.value)?item.servingSize.value:0,
                      calorie:(item.calorie&&item.calorie.value)?item.calorie.value:0
                    };

                    content.content=props.nutritionPlanner.nutritionContents.find(d=>d._id == item.contentId)
                    nutritionContent.contents.push(content)
                  }
                }
                nutritionPlanner.nutritionContents.push(nutritionContent)
              }
            }
            oldState.push(nutritionPlanner)
          }
        }

        return [...oldState]
      })
    }
    setButtonLock(true);
  }, [props])

  useEffect(async () => {
    window.addEventListener("click", () => {
      setCurrentElementId("");
    })
    setContents([])
    setSelectedContent("")
    try {
      await startLoader()
      let targetMuscleList = await GetAllParams("targetMuscle");
      setTargetMuscles(targetMuscleList)
      let exerciseTypeList = await GetAllParams('exerciseType')
      setExerciseTypes(exerciseTypeList);
      let exerciseLevelList = await GetAllParams('exerciseLevel');
      setExerciseLevels(exerciseLevelList)
      await stopLoader()
    } catch (error) {
      await stopLoader()
    }
  }, [])

  return (
    <div onTouchStart={(e)=>e.stopPropagation()} className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`} style={{borderRadius: window.innerWidth < 640 ? "12px 12px 0 0" : ""}}>
      <div className="modal-container d-flex flex-item" style={{width: window.innerWidth > 650 && "46%", height: window.innerWidth > 650 && "90%"}}>
        <div className={`${window.innerWidth < 640 && "m-t-8"} w-full`} style={{height: window.innerWidth > 767 ? "82%" : "100%"}}>
          {
            window.innerWidth > 767 && (
              <div className="d-flex w-full space-between m-b-12" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
                <div className='d-flex'>
                  <svg className='flex-item m-r-8' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.8672 10.4033C12.8672 10.0407 13.0112 9.69297 13.2676 9.43657C13.524 9.18018 13.8718 9.03613 14.2344 9.03613H21.0703V11.7705H14.2344C13.8718 11.7705 13.524 11.6265 13.2676 11.3701C13.0112 11.1137 12.8672 10.7659 12.8672 10.4033ZM1.92969 13.1377H7.39844C7.76104 13.1377 8.10879 13.2817 8.36518 13.5381C8.62158 13.7945 8.76562 14.1423 8.76562 14.5049C8.76562 14.8675 8.62158 15.2152 8.36518 15.4716C8.10879 15.728 7.76104 15.8721 7.39844 15.8721H1.92969V13.1377Z" fill="#ffffff"/>
                    <path d="M5.34766 0.833008C5.52896 0.833008 5.70283 0.905029 5.83103 1.03323C5.95923 1.16143 6.03125 1.3353 6.03125 1.5166V2.2002H16.9688V1.5166C16.9688 1.3353 17.0408 1.16143 17.169 1.03323C17.2972 0.905029 17.471 0.833008 17.6523 0.833008C17.8336 0.833008 18.0075 0.905029 18.1357 1.03323C18.2639 1.16143 18.3359 1.3353 18.3359 1.5166V2.2002H19.7031C20.4283 2.2002 21.1238 2.48828 21.6366 3.00108C22.1494 3.51387 22.4375 4.20937 22.4375 4.93457V19.9736C22.4375 20.6988 22.1494 21.3943 21.6366 21.9071C21.1238 22.4199 20.4283 22.708 19.7031 22.708H3.29688C2.57167 22.708 1.87617 22.4199 1.36338 21.9071C0.850585 21.3943 0.5625 20.6988 0.5625 19.9736V4.93457C0.5625 4.20937 0.850585 3.51387 1.36338 3.00108C1.87617 2.48828 2.57167 2.2002 3.29688 2.2002H4.66406V1.5166C4.66406 1.3353 4.73608 1.16143 4.86428 1.03323C4.99248 0.905029 5.16636 0.833008 5.34766 0.833008ZM1.92969 6.30176V19.9736C1.92969 20.3362 2.07373 20.684 2.33013 20.9404C2.58652 21.1968 2.93427 21.3408 3.29688 21.3408H19.7031C20.0657 21.3408 20.4135 21.1968 20.6699 20.9404C20.9263 20.684 21.0703 20.3362 21.0703 19.9736V6.30176H1.92969Z" fill="#ffffff"/>
                  </svg>
                  <p className="flex-item fs-20 font-weight-700 color-white m-t-3">Planner</p>
                </div>
                <div onClick={closePopup.bind(this)} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                  <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                  </svg>
                </div>
              </div>
            )
          }
          {
            currentWindow == "create-planner" && [
              <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ padding: window.innerWidth > 767 ? "0 12px 40px 12px" : "12px" }}>
                {/* Toggle Planner Type */}
                {
                  !props.isEdit && (
                    <div className='w-full d-flex'>
                      <div className="d-flex m-b-20 m-t-8" style={{ padding: "12px", borderRadius: "12px", background: "#ffffff", boxShadow:"0px 0px 8px rgba(0,0,0,0.25)"}}>
                        {/* <div className='d-flex flex-item' style={{margin:"0 auto"}}> */}
                          <div onClick={()=>handlePlannerType("weekday")} className='flex-item cursor-pointer d-flex m-r-30'>
                            <input id="weekday" className='flex-item m-r-8' type="radio" name="planner-type" checked={plannerType == "weekday" ? true : false} style={{width:"26px", height:"26px"}}/>
                            <p className='flex-item fs-18' style={{ fontWeight: "700", color: plannerType == "weekday" ? "#E33A34" : "#6d6d6d" }}>Weekday</p>
                          </div>
                          <div onClick={()=>handlePlannerType("nutrition")} className='flex-item cursor-pointer d-flex'>
                            <input id="nutrition" className='flex-item m-r-8' type="radio" name="planner-type" checked={plannerType == "nutrition" ? true : false} style={{width:"26px", height:"26px"}} />
                            <p className='flex-item fs-18' style={{ fontWeight: "700", color: plannerType == "nutrition" ? "#E33A34" : "#6d6d6d" }}>Nutrition</p>
                          </div>
                          {/* <div onClick={()=>handlePlannerType("day")} className='flex-item cursor-pointer d-flex'>
                            <input id="day-planner" className='flex-item m-r-8' type="radio" name="planner-type" checked={plannerType == "day" ? true : false} />
                            <p className='flex-item fs-16' style={{ fontWeight: "600", color: plannerType == "day" ? "#0088da" : "#6d6d6d" }}>Day</p>
                          </div> */}
                        {/* </div> */}
                      </div>
                    </div>
                  )
                }
                <div onClick={toggleInputFields('access-right')} className={`${(currentElementId == "access-right" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "access-right" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <svg className="flex-item m-r-4" width={(currentElementId == "access-right" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "12" : "18"} height={(currentElementId == "access-right" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.37735 2.24821C5.67548 2.24821 5.9614 2.12977 6.17221 1.91896C6.38302 1.70815 6.50145 1.42223 6.50145 1.1241C6.50145 0.825972 6.38302 0.540052 6.17221 0.329242C5.9614 0.118432 5.67548 0 5.37735 0C5.07922 0 4.7933 0.118432 4.58249 0.329242C4.37168 0.540052 4.25325 0.825972 4.25325 1.1241C4.25325 1.42223 4.37168 1.70815 4.58249 1.91896C4.7933 2.12977 5.07922 2.24821 5.37735 2.24821ZM3.11915 3.31785C2.80765 3.39529 2.59507 3.5117 2.42346 3.65608C2.16616 3.87291 1.95833 4.18566 1.67755 4.67727C1.6118 4.79231 1.50304 4.87653 1.37519 4.91138C1.24735 4.94623 1.11089 4.92887 0.995847 4.86312C0.880801 4.79736 0.796589 4.6886 0.761735 4.56076C0.726881 4.43291 0.74424 4.29646 0.809995 4.18141C1.08952 3.69255 1.37205 3.23517 1.77997 2.89194C2.20563 2.53323 2.72672 2.33039 3.4294 2.2522C3.72317 2.21973 4.04641 2.22622 4.34942 2.36137C4.66742 2.5035 4.89973 2.75805 5.0581 3.09828C5.27143 3.55616 5.43006 3.82869 5.55696 3.98657C5.61816 4.06251 5.66087 4.09773 5.6851 4.11347C5.70434 4.12596 5.71258 4.12696 5.71558 4.12746C5.73731 4.12995 5.80801 4.12746 6.01484 4.03578C6.10502 3.99581 6.20344 3.94785 6.32384 3.88915L6.35257 3.87516C6.49982 3.80249 6.6484 3.73254 6.79822 3.66533C6.91917 3.61222 7.05623 3.60919 7.17942 3.65688C7.30261 3.70458 7.40189 3.79911 7.45556 3.91982C7.50922 4.04053 7.5129 4.17757 7.46579 4.30098C7.41867 4.42439 7.3246 4.52412 7.20414 4.57835C7.06531 4.64066 6.92765 4.70553 6.79122 4.77294L6.7585 4.78893C6.64334 4.84513 6.52743 4.90184 6.41877 4.9498C6.19395 5.04922 5.90668 5.15713 5.59518 5.11941C5.26644 5.07945 5.01314 4.89384 4.80456 4.64479L4.12185 5.96199L5.0661 7.19051C5.1223 7.26395 5.15703 7.35138 5.16677 7.44331L5.3746 9.44072C5.38252 9.50652 5.37726 9.57325 5.35914 9.63701C5.34102 9.70077 5.31039 9.76028 5.26903 9.81208C5.22768 9.86388 5.17644 9.90694 5.11828 9.93874C5.06012 9.97054 4.99622 9.99046 4.93029 9.99732C4.86437 10.0042 4.79773 9.99785 4.73428 9.97871C4.67082 9.95956 4.6118 9.92798 4.56067 9.8858C4.50954 9.84362 4.46731 9.79169 4.43645 9.73304C4.40558 9.67438 4.3867 9.61016 4.3809 9.54413L4.18755 7.68736L3.61401 6.94096L3.60901 6.9502L3.58803 6.90724L2.52837 5.52834C2.47628 5.46056 2.44245 5.38056 2.43012 5.29597C2.41779 5.21139 2.42736 5.12505 2.45793 5.04522L3.11915 3.31785Z" fill={(currentElementId == "access-right" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "var(--darkBlue)" : "#6d6d6d"} />
                      <path d="M2.36235 6.24658L1.99464 7.23579L0.545797 7.12088C0.479925 7.11477 0.413495 7.12179 0.35036 7.14156C0.287225 7.16132 0.228644 7.19342 0.178016 7.236C0.127387 7.27859 0.0857207 7.3308 0.0554334 7.38962C0.0251461 7.44843 0.00684141 7.51268 0.00158161 7.57862C-0.00367819 7.64457 0.00421159 7.7109 0.0247932 7.77378C0.0453747 7.83665 0.0782381 7.89481 0.121476 7.94488C0.164714 7.99495 0.217466 8.03593 0.27667 8.06545C0.335875 8.09497 0.400352 8.11244 0.466361 8.11684L2.2919 8.26172C2.40025 8.27035 2.50845 8.2434 2.60009 8.18498C2.69174 8.12655 2.76183 8.03984 2.79975 7.93798L3.08077 7.18159L2.36235 6.24658Z" fill={(currentElementId == "access-right" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "var(--darkBlue)" : "#6d6d6d"} />
                    </svg>
                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "workout-gym-type" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "10px" : "14px", color: (currentElementId == "access-right" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "var(--darkBlue)" : "", transition: "180ms" }}>Access Right <span className='color-red'>*</span></p>
                  </div>
                  <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                    <svg className="flex-item" style={{ transform: isAccessRightDropdown ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                    </svg>
                  </div>
                  <input id="access-right" className={`${(currentElementId == "workout-gym-type" || (plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Gym Type" value={(plannerType == 'day'?dayPlanner.accessRight:workoutPlanner.accessRight)} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
                  {
                    isAccessRightDropdown && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                        {
                          accessRights.map(data=>{
                            return (
                              <div onClick={handleSelectAccessRight.bind(this, data)} className="global-input-field-arrow-dropdown-item">
                                <p className="flex-item" style={{textTransform:'capitalize'}}>{data}</p>
                              </div>
                            );
                          })
                        }
                      </div>
                    )
                  }
                </div>
       
                {
                   plannerType != "day" && (
                      <div onClick={toggleInputFields('workout-planner-name')} className={`${(currentElementId == "workout-planner-name" || workoutPlanner.name) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "workout-planner-name" || workoutPlanner.name) ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <svg className="flex-item m-r-8" width={(currentElementId == 'workout-planner-name' || workoutPlanner.name) ? "12" : "18"} height={(currentElementId == 'workout-planner-name' || workoutPlanner.name) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_661_1357)">
                              <path d="M3 0.375C3 0.275544 2.96049 0.180161 2.89016 0.109835C2.81984 0.0395088 2.72446 0 2.625 0C2.52554 0 2.43016 0.0395088 2.35984 0.109835C2.28951 0.180161 2.25 0.275544 2.25 0.375V0.75H1.5C1.10218 0.75 0.720644 0.908035 0.43934 1.18934C0.158035 1.47064 0 1.85218 0 2.25L0 3H12V2.25C12 1.85218 11.842 1.47064 11.5607 1.18934C11.2794 0.908035 10.8978 0.75 10.5 0.75H9.75V0.375C9.75 0.275544 9.71049 0.180161 9.64017 0.109835C9.56984 0.0395088 9.47446 0 9.375 0C9.27554 0 9.18016 0.0395088 9.10983 0.109835C9.03951 0.180161 9 0.275544 9 0.375V0.75H3V0.375ZM12 10.5V3.75H0V10.5C0 10.8978 0.158035 11.2794 0.43934 11.5607C0.720644 11.842 1.10218 12 1.5 12H10.5C10.8978 12 11.2794 11.842 11.5607 11.5607C11.842 11.2794 12 10.8978 12 10.5ZM9.375 5.25H10.125C10.2245 5.25 10.3198 5.28951 10.3902 5.35984C10.4605 5.43016 10.5 5.52554 10.5 5.625V6.375C10.5 6.47446 10.4605 6.56984 10.3902 6.64017C10.3198 6.71049 10.2245 6.75 10.125 6.75H9.375C9.27554 6.75 9.18016 6.71049 9.10983 6.64017C9.03951 6.56984 9 6.47446 9 6.375V5.625C9 5.52554 9.03951 5.43016 9.10983 5.35984C9.18016 5.28951 9.27554 5.25 9.375 5.25Z" fill={(currentElementId == 'workout-planner-name' || workoutPlanner.name) ? "var(--darkBlue)" : "#6d6d6d"} />
                            </g>
                            <defs>
                              <clipPath id="clip0_661_1357">
                                <rect width="12" height="12" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "workout-planner-name" || workoutPlanner.name) ? "10px" : "14px", color: (currentElementId == "workout-planner-name" || workoutPlanner.name) ? "var(--darkBlue)" : "", transition: "180ms" }}>Planner Name <span className='color-red'>*</span></p>
                        </div>
                        <input id="workout-planner-name" onChange={handleChange("name")} value={workoutPlanner.name} className={`${(currentElementId == "workout-planner-name" || workoutPlanner.name) ? "active-input-field" : "inactive-input-field"}`} type="text" />
                      </div>
                  )
                }
           
                {
                  plannerType == "nutrition" && (
                    <div className='w-full'>
                      <p className='fs-16 font-weight-700 m-b-10'>Manage Nutrition</p>
                      <div className='d-flex w-full'>
                        {/* dayStorage.Days.filter(d=>nutritionPlanner.findIndex(data=>data.dayName == d.name) == -1).map((data, index) => { */}
                        {console.log(nutritionPlanner)}
                        {
                          dayStorage.Days.map((data, index) => {
                            return(
                              <div onClick={() => handleSelectedNutritionDay(data.name)} className="day-chips d-flex cursor-pointer m-r-10 m-b-16" style={{width:"auto", minWidth:"60px", height: "30px", padding: "0 12px", background: nutritionPlanner.findIndex(plan => plan.dayName == data.name) !== -1 && "var(--darkBlue)"}}>
                                <p className='flex-item' style={{margin:"0 auto", color: nutritionPlanner.findIndex(plan => plan.dayName == data.name) !== -1 && "var(--darkBlue)" && "#ffffff"}}>{data.name}</p>
                                {
                                  nutritionPlanner.findIndex(plan => plan.dayName == data.name) !== -1 && "var(--darkBlue)" && (
                                    <svg className='flex-item m-l-12' width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M0.5 5.5L4 9L11.5 0.5" stroke-width="2" stroke="white" stroke-linecap="round"/>
                                    </svg>
                                  )
                                }
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  )
                }
                {
                  plannerType != "nutrition" && (
                    <div className='w-full'>
                      <div className="d-flex w-full m-b-8">
                        <p className="flex-item m-r-12 fs-16 color-dark-blue" style={{ fontWeight: "700" }}>Exercise Level</p>
                      </div>
                      <div className="w-full m-b-12" style={{ padding: "12px 12px 0 12px", borderRadius: "12px", background: "#ffffff" }}>
                        <div className="d-flex-wrap w-full suggestion-list-container-gym-1">
                          {
                            exerciseLevels.map(data => {
                              return (
                                <div onClick={handleSelectedExerciseLevelIDs(data._id)} className={`global-button-container ${(plannerType == 'day'?[...dayPlanner.exerciseLevelIDs]:[...workoutPlanner.exerciseLevelIDs]).indexOf(data._id) != -1 ? "global-button-container-active" : ""} d-flex flex-item p-l-12 p-r-12 m-r-20 m-b-12`} style={{ background: "#e0e0e0" }}>
                                  <p className='flex-item'>{data.name}</p>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                      {/* TODO */}
                      {
                        plannerType == "weekday" ? [
                          <p className='color-dark-blue fs-16 font-weight-700 flex-item m-t-20 m-b-12 m-r-12'>Manage Exercises</p>,
                          <div className='d-flex m-b-20'>
                            <div onClick={() => toggleCurrentWindow("warm-up")} className='warm-cool-container m-r-20 d-flex'>
                              <p className='flex-item m-r-12'>Warm Up</p>
                              <svg className='flex-item' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(workoutPlanner.warmup.length > 0 && workoutPlanner.warmup[0].content && workoutPlanner.warmup[0].content._id) ? "#5D883C" : "#E0E0E0"} />
                                <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                              </svg>
                            </div>
                            <div onClick={() => toggleCurrentWindow("cool-down")} className='warm-cool-container d-flex'>
                              <p className='flex-item m-r-12'>Cool Down</p>
                              <svg className='flex-item' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(workoutPlanner.cooldown.length > 0 && workoutPlanner.cooldown[0].content && workoutPlanner.cooldown[0].content._id) ? "#5D883C" : "#E0E0E0"} />
                                <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                              </svg>
                            </div>
                          </div>,
                          <div className='d-flex'>
                            <div onClick={() =>{
                              toggleCurrentWindow("weekdays-exercise");
                              setEditActive(false);
                              setDayStorage({
                                ...dayStorage,
                                Days: dayStorage.Days.map(d=>({...d,isSelected:false}))
                              })
                            }}  className='day-workout-btn cursor-pointer d-flex'>
                              <div className='flex-item m-r-30'>
                                <p>Day Workout (s)</p>
                                <p>{workoutPlanner.weekdays.length?`Planner assigned for ${workoutPlanner.weekdays.map((data,index)=>(index+1==workoutPlanner.weekdays.length)?` and ${data.dayName}`:`${index==0?'':' , '}${data.dayName}`).join("")}`:"No days Planned"}</p>
                              </div>
                              <svg className='flex-item' width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.143 1.17658C16.516 0.803596 16.9587 0.507719 17.446 0.305841C17.9333 0.103963 18.4556 3.81562e-05 18.9831 1.05049e-08C19.5106 -3.81352e-05 20.0329 0.103811 20.5202 0.305618C21.0075 0.507426 21.4504 0.803239 21.8234 1.17617C22.1964 1.5491 22.4923 1.99184 22.6941 2.47912C22.896 2.96639 23 3.48866 23 4.0161C23 4.54354 22.8962 5.06583 22.6944 5.55313C22.4925 6.04044 22.1967 6.48322 21.8238 6.85621L21.0828 7.59635L15.4028 1.91672L16.143 1.17658ZM14.2412 3.0791L1.93662 15.3847C1.52233 15.7987 1.23648 16.3236 1.11346 16.8962L0.0183858 22.0057C-0.010493 22.1399 -0.00528421 22.2792 0.0335362 22.4108C0.0723567 22.5425 0.143551 22.6623 0.240615 22.7594C0.337679 22.8565 0.457518 22.9276 0.589184 22.9665C0.72085 23.0053 0.860144 23.0105 0.994342 22.9816L6.10414 21.8866C6.67679 21.7636 7.2017 21.4778 7.61573 21.0635L19.922 8.7579L14.2412 3.0791Z" fill="black"/>
                              </svg>
                            </div>
                          </div>
                        ] : [
                          <p className='modal-sub-heading flex-item m-t-24 m-b-8 m-r-12'>Plan Workout</p>,
                          <div onClick={toggleInputFields("exercise-display-name")} className={`${(currentElementId == "exercise-display-name" || dayPlanner.name) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-display-name" || dayPlanner.name) ? "1px solid var(--darkBlue)" : "" }}>
                            <div className="flex-item d-flex">
                              <svg className='m-r-4 flex-item' width={(currentElementId == "exercise-display-name" || dayPlanner.name) ? "12" : "18"} height={(currentElementId == "exercise-display-name" || dayPlanner.name) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.955 6.969L16.267 6.281L17.17 5.332L13.817 1.979L12.868 2.882L12.155 2.169L13.767 0.507L18.617 5.357L16.955 6.969ZM0.543 13.806L2.155 12.194L2.868 12.907L1.958 13.811L5.338 17.191L6.242 16.281L6.955 16.994L5.343 18.606L0.543 13.806ZM15.707 11.171L17.709 9.169L9.98 1.44L7.978 3.442L15.707 11.171ZM9.13 17.748L11.151 15.721L3.428 7.998L1.401 10.019L9.13 17.748ZM8.865 12.032L11.999 8.904L10.245 7.15L7.117 10.284L8.865 12.032ZM12.578 15.74L9.13 19.15L0 10.019L3.409 6.571L6.403 9.571L9.538 6.436L6.557 3.442L9.999 0L19.149 9.15L15.707 12.592L12.713 9.612L9.578 12.746L12.578 15.74Z" fill={(currentElementId == "exercise-display-name" || dayPlanner.name) ? "var(--darkBlue)" : "#6d6d6d"}/>
                              </svg>
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-display-name" || dayPlanner.name) ? "10px" : "14px", color: (currentElementId == "exercise-display-name" || dayPlanner.name) ? "var(--darkBlue)" : "", transition: "180ms" }}>Workout Display Name *</p>
                            </div>
                            <input id="exercise-display-name" value={dayPlanner.name} onInput={handleWeekDayWorkoutDisplayName} className={`${(currentElementId == "exercise-display-name" || dayPlanner.name) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Enter Name" style={{ textTransform: 'capitalize' }} />
                          </div>,
                          dayPlanner.warmup.map((exercise, index) => {
                            return(
                              <div className='planner-exercise-container m-b-12' style={{ position: 'relative', backgroundColor: exercise.content._id ? "#ffffff" : "#f5f5f5" }} onClick={handleSelectExercise(index)}>
                                <div className='d-flex w-full space-between'>
                                  <div className='d-flex' style={{ width: "80%" }}>
                                    <div className='w-full'>
                                      <p className='fs-14 font-weight-600' style={{color: "#EF4035"}}>Warm Up</p>
                                      <div className='d-flex w-full'>
                                        <p className='planner-exercise-name fs-18 flex-item' style={{ maxWidth: "75%" }}>{(exercise.content && exercise.content._id) ? getShortString(exercise.content.name,15) : "Select Exercise"}</p>
                                        <svg className='flex-item m-l-16 m-t-2' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(exercise.content && exercise.content._id) ? "#5D883C" : "#E0E0E0"} />
                                          <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>

                                  {
                                    exercise.content._id && (
                                      <div className='d-flex'>
                                        <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                          <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                          </svg>
                                        </div>
                                        <div className='m-r-20 d-flex'>
                                          <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content,null,'warmup')} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                          </svg>
                                        </div>
                                      </div>
                                    )
                                  }

                                  {
                                    exercise && !exercise.content._id  && (
                                      <div onClick={toggleExerciseContentManageWindow(-1, {}, index,'warmup')} className={`global-button-container button-orange d-flex flex-item p-l-12 p-r-12`} style={{ width: "100px", background: '#EF4035', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                      </div>
                                    )
                                  }

                                  {
                                    index == 0 && exercise && exercise.content._id && (
                                      <svg onClick={removeExercise(index,'warmup')} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                        <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                      </svg>
                                    )
                                  }

                                  {
                                    index > 0 && (
                                      <svg onClick={removeExercise(index,'warmup')} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                        <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                      </svg>
                                    )
                                  }
                                  

                                </div>

                                {
                                  (exercise.content._id) && [
                                    <div className='exercise-container-saperator' />,
                                    exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{fontWeight: 'bold'}}>Optional</p>,
                                    exercise.optionalExercises.map((optionalExercise, opindex) => {
                                      return (
                                        <div className='d-flex w-full space-between m-b-16'>
                                          <div className='d-flex' style={{ width: "80%" }}>
                                            <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise._id) ? optionalExercise.name : "Select Exercise"}</p>
                                            <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise._id) ? "#5D883C" : "#E0E0E0"} />
                                              <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                            </svg>
                                          </div>
                                          <div className='d-flex'>
                                            {
                                              optionalExercise._id && [
                                                <div onClick={toggleVideoPlayer.bind(this, optionalExercise)} className='d-flex planner-play-exercise m-r-20'>
                                                  <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                                  </svg>
                                                </div>,
                                                <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise,null,'warmup')} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                                </svg>
                                              ]
                                            }


                                            {
                                              !optionalExercise._id && (
                                                <div onClick={toggleExerciseContentManageWindow(opindex, {},null,'warmup')} className="global-button-container button-orange d-flex flex-item p-l-12 p-r-12 m-r-20" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                                  <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                                </div>
                                              )
                                            }

                                            <svg onClick={handleRemoveOptionalExercise(opindex,'warmup')} className='m-l-12 flex-item' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                              <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                            </svg>
                                          </div>
                                        </div>
                                      )
                                    }),
                                    (exercise.optionalExercises.length == 0) && (
                                      <div onClick={()=>handleAddOptionalExerise(0,"warmup")} className="global-button-container button-orange d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Optional Exercise</p>
                                      </div>
                                    ),
                                    (exercise.optionalExercises.length == 1) && (
                                      <div onClick={()=>handleAddOptionalExerise(1,"warmup")} className="global-button-container button-orange d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add More</p>
                                      </div>
                                    )
                                  ]
                                }
                              </div>
                            )
                          }),
                          dayPlanner.cooldown.map((exercise, index) => {
                            return(
                              <div className='planner-exercise-container m-b-12' style={{ position: 'relative', backgroundColor: exercise.content._id ? "#ffffff" : "#f5f5f5" }} onClick={handleSelectExercise(index)}>
                                <div className='d-flex w-full space-between'>
                                  <div className='d-flex' style={{ width: "80%" }}>
                                    <div className='w-full'>
                                      <p className='fs-14 font-weight-600' style={{color: "#0088da"}}>Cool Down</p>
                                      <div className='d-flex w-full'>
                                        <p className='planner-exercise-name fs-18 flex-item' style={{ maxWidth: "75%" }}>{(exercise.content && exercise.content._id) ? getShortString(exercise.content.name,15) : "Select Exercise"}</p>
                                        <svg className='flex-item m-l-16 m-t-2' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(exercise.content && exercise.content._id) ? "#5D883C" : "#E0E0E0"} />
                                          <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>

                                  {
                                    exercise.content._id && (
                                      <div className='d-flex'>
                                        <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                          <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                          </svg>
                                        </div>
                                        <div className='m-r-20 d-flex'>
                                          <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content,null,'cooldown')} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                          </svg>
                                        </div>
                                      </div>
                                    )
                                  }

                                  {
                                    exercise && !exercise.content._id  && (
                                      <div onClick={toggleExerciseContentManageWindow(-1, {}, index,'cooldown')} className={`global-button-container button-blue d-flex flex-item p-l-12 p-r-12`} style={{ width: "100px", background: '#0088da', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                      </div>
                                    )
                                  }

                                  {
                                    index == 0 && exercise && exercise.content._id && (
                                      <svg onClick={removeExercise(index,'cooldown')} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                        <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                      </svg>
                                    )
                                  }

                                  {
                                    index > 0 && (
                                      <svg onClick={removeExercise(index,'cooldown')} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                        <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                      </svg>
                                    )
                                  }
                                  

                                </div>

                                {
                                  (exercise.content._id) && [
                                    <div className='exercise-container-saperator' />,
                                    exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{fontWeight: 'bold'}}>Optional</p>,
                                    exercise.optionalExercises.map((optionalExercise, opindex) => {
                                      return (
                                        <div className='d-flex w-full space-between m-b-16'>
                                          <div className='d-flex' style={{ width: "80%" }}>
                                            <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise._id) ? optionalExercise.name : "Select Exercise"}</p>
                                            <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise._id) ? "#5D883C" : "#E0E0E0"} />
                                              <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                            </svg>
                                          </div>
                                          <div className='d-flex'>
                                            {
                                              optionalExercise._id && [
                                                <div onClick={toggleVideoPlayer.bind(this, optionalExercise)} className='d-flex planner-play-exercise m-r-20'>
                                                  <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                                  </svg>
                                                </div>,
                                                <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise,null,'cooldown')} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                                </svg>
                                              ]
                                            }


                                            {
                                              !optionalExercise._id && (
                                                <div onClick={toggleExerciseContentManageWindow(opindex, {},null,'cooldown')} className="global-button-container button-blue d-flex flex-item p-l-12 p-r-12 m-r-20" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                                  <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                                </div>
                                              )
                                            }

                                            <svg onClick={handleRemoveOptionalExercise(opindex,'cooldown')} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                              <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                            </svg>
                                          </div>
                                        </div>
                                      )
                                    }),
                                    (exercise.optionalExercises.length == 0) && (
                                      <div onClick={()=>handleAddOptionalExerise(0,"cooldown")} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Optional Exercise</p>
                                      </div>
                                    ),
                                    (exercise.optionalExercises.length == 1) && (
                                      <div onClick={()=>handleAddOptionalExerise(1,"cooldown")} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                        <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add More</p>
                                      </div>
                                    )
                                  ]
                                }
                              </div>
                            )
                          }),
                          <div className='m-t-14 m-b-14 w-full' style={{height:"1px", background: "#f5f5f5"}} />,
                            dayPlanner.workout.map((exercise, index) => {
                              return(
                                <div className='planner-exercise-container m-b-12' style={{ position: 'relative', backgroundColor: exercise.content._id ? "#ffffff" : "#f5f5f5" }} onClick={handleSelectExercise(index)}>
                                  <div className='d-flex w-full space-between'>
                                    <div className='d-flex' style={{ width: "80%" }}>
                                      {
                                        exercise.content._id && (
                                          <svg style={{transform: (!exercise.isDropdownOpen) ? 'rotate(0deg)' : 'rotate(180deg)' }} className='flex-item m-r-12' width="16" height="11" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1.00098 1L6.50098 6.5L12.501 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                          </svg>
                                        )
                                      }
                                      <p className='planner-exercise-name fs-18' style={{ maxWidth: "75%" }}>{(exercise.content && exercise.content._id) ? getShortString(exercise.content.name,15) : "Select Exercise"}</p>
                                      <svg className='m-l-16 m-t-2' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(exercise.content && exercise.content._id) ? "#5D883C" : "#E0E0E0"} />
                                        <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                      </svg>
                                    </div>

                                    {
                                      exercise.content._id && (
                                        <div className='d-flex'>
                                          <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                            <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                            </svg>
                                          </div>
                                          <div className='m-r-20 d-flex'>
                                            <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content,null,'mainexercise')} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                            </svg>
                                          </div>
                                        </div>
                                      )
                                    }

                                    {
                                      exercise && !exercise.content._id  && (
                                        <div onClick={toggleExerciseContentManageWindow(-1, {}, index,'mainexercise')} className={`global-button-container d-flex flex-item p-l-12 p-r-12`} style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                          <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                        </div>
                                      )
                                    }

                                    {
                                      index == 0 && exercise && exercise.content._id && (
                                        <svg onClick={removeExercise(index,'mainexercise')} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                          <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                        </svg>
                                      )
                                    }

                                    {
                                      index > 0 && (
                                        <svg onClick={removeExercise(index,'mainexercise')} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                          <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                        </svg>
                                      )
                                    }

                                  </div>

                                  {
                                    (exercise.isDropdownOpen && exercise.parameter && exercise.parameter.isParameterAdded) && [
                                      (exercise.parameter.unit == "weight") && [
                                        <div className='d-flex m-t-12 m-b-8'>
                                          <div className='d-flex' style={{ width: "120px" }}>
                                            <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <g clip-path="url(#clip0_683_1507)">
                                                <path d="M10.5 10.5V2.25H7.5V10.5H6V5.25H3V10.5H1.5V0.75H0.75V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H11.25V10.5H10.5ZM8.25 3H9.75V6.75H8.25V3ZM3.75 6H5.25V8.25H3.75V6Z" fill="var(--darkBlue)" />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_683_1507">
                                                  <rect width="12" height="12" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                            <p className='flex-item sub-txt-title'>Set</p>
                                          </div>
                                          <p className='flex-item sub-txt-value'>{exercise.parameter.set ? exercise.parameter.set.length : 0}</p>
                                        </div>],
                                        (exercise.parameter.unit == "distance") && <div className='d-flex m-t-12'>
                                          <div className='d-flex' style={{ width: "120px" }}>
                                            <svg className='flex-item m-r-8 svg-fill' width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M4.34105 4.84112L4.34107 4.8411C4.65572 4.52642 4.86999 4.12551 4.95679 3.68906C4.98559 3.54423 4.99993 3.39764 5 3.25139C4.99998 3.3978 4.98566 3.54455 4.95685 3.68954C4.87012 4.12593 4.65597 4.52681 4.34145 4.84151C4.34142 4.84154 4.34139 4.84157 4.34137 4.84159L2.75041 6.43255L2.75002 6.43215L3.10355 6.07862L4.34105 4.84112ZM2.39645 6.07862L2.68855 6.37072L1.15864 4.84159C1.15861 4.84157 1.15858 4.84154 1.15855 4.84151C1.15852 4.84148 1.15849 4.84145 1.15846 4.84142C0.843996 4.52674 0.629872 4.12589 0.543157 3.68954C0.514343 3.54455 0.500027 3.3978 0.500001 3.25139C0.500078 3.39764 0.514415 3.54423 0.543218 3.68906C0.630016 4.12551 0.844285 4.52642 1.15893 4.8411L1.15895 4.84112L2.39645 6.07862ZM8.695 9.48788L7.31336 10.8688L7.60355 10.5786L8.84105 9.34112L8.84107 9.3411C9.15572 9.02642 9.36999 8.62551 9.45679 8.18906C9.48192 8.06268 9.49604 7.93497 9.49928 7.80731C9.49605 7.93497 9.48196 8.06267 9.45685 8.18904C9.37011 8.62547 9.15593 9.02638 8.84136 9.34109L8.695 9.48753V9.48788ZM5.65895 9.34112L6.771 10.4532L5.65864 9.34109C5.34408 9.02638 5.12989 8.62547 5.04316 8.18904C5.01436 8.04413 5.00004 7.89747 5 7.75114C5.00006 7.89748 5.0144 8.04415 5.04322 8.18906C5.13002 8.62551 5.34429 9.02642 5.65893 9.3411L5.65895 9.34112ZM2.75 3.50006C2.6837 3.50006 2.62011 3.47372 2.57322 3.42684C2.52634 3.37996 2.5 3.31637 2.5 3.25006C2.5 3.18376 2.52634 3.12017 2.57322 3.07329C2.62011 3.0264 2.6837 3.00006 2.75 3.00006C2.81631 3.00006 2.87989 3.0264 2.92678 3.07329C2.97366 3.12017 3 3.18376 3 3.25006C3 3.31637 2.97366 3.37996 2.92678 3.42684C2.87989 3.47372 2.81631 3.50006 2.75 3.50006ZM7.25 8.00006C7.1837 8.00006 7.12011 7.97372 7.07322 7.92684C7.02634 7.87996 7 7.81637 7 7.75006C7 7.68376 7.02634 7.62017 7.07322 7.57329C7.12011 7.5264 7.1837 7.50006 7.25 7.50006C7.31631 7.50006 7.37989 7.5264 7.42678 7.57329C7.47366 7.62017 7.5 7.68376 7.5 7.75006C7.5 7.81637 7.47366 7.87996 7.42678 7.92684C7.37989 7.97372 7.3163 8.00006 7.25 8.00006Z" stroke="var(--darkBlue)" />
                                            </svg>
                                            <p className='flex-item sub-txt-title'>Distance</p>
                                          </div>
                                          <p className='flex-item sub-txt-value'>{(exercise.parameter.distance && exercise.parameter.distance.value) ? exercise.parameter.distance.value : 0} {(exercise.parameter.distance && exercise.parameter.distance.unit) ? exercise.parameter.distance.unit : "Km"}</p>
                                        </div>,
                                        (exercise.parameter.unit == "number") && <div className='d-flex m-t-12'>
                                          <div className='d-flex' style={{ width: "120px" }}>
                                            <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M1.20041 2.6999C1.20041 2.62034 1.23202 2.54403 1.28828 2.48777C1.34454 2.43151 1.42084 2.3999 1.50041 2.3999H10.5004C10.58 2.3999 10.6563 2.43151 10.7125 2.48777C10.7688 2.54403 10.8004 2.62034 10.8004 2.6999C10.8004 2.77947 10.7688 2.85577 10.7125 2.91203C10.6563 2.9683 10.58 2.9999 10.5004 2.9999H1.50041C1.42084 2.9999 1.34454 2.9683 1.28828 2.91203C1.23202 2.85577 1.20041 2.77947 1.20041 2.6999ZM1.20041 5.6999C1.20041 5.62034 1.23202 5.54403 1.28828 5.48777C1.34454 5.43151 1.42084 5.3999 1.50041 5.3999H10.5004C10.58 5.3999 10.6563 5.43151 10.7125 5.48777C10.7688 5.54403 10.8004 5.62034 10.8004 5.6999C10.8004 5.77947 10.7688 5.85577 10.7125 5.91203C10.6563 5.9683 10.58 5.9999 10.5004 5.9999H1.50041C1.42084 5.9999 1.34454 5.9683 1.28828 5.91203C1.23202 5.85577 1.20041 5.77947 1.20041 5.6999ZM4.55321 7.7999C4.18541 7.7999 3.89741 8.1329 3.89741 8.4815C3.89741 8.56107 3.8658 8.63737 3.80954 8.69363C3.75328 8.7499 3.67697 8.7815 3.59741 8.7815C3.51784 8.7815 3.44154 8.7499 3.38528 8.69363C3.32902 8.63737 3.29741 8.56107 3.29741 8.4815C3.29741 7.8491 3.80861 7.1999 4.55321 7.1999C4.99121 7.1999 5.41061 7.4057 5.64341 7.7663C5.88581 8.1407 5.89661 8.6315 5.60921 9.1241C5.46281 9.3743 5.26121 9.5651 5.06081 9.7241C4.96121 9.8039 4.85741 9.8777 4.75901 9.9479L4.71701 9.9779C4.63241 10.0379 4.55261 10.0943 4.47521 10.1525C4.21181 10.3523 4.02101 10.5413 3.94061 10.7999H5.49641C5.57597 10.7999 5.65228 10.8315 5.70854 10.8878C5.7648 10.944 5.79641 11.0203 5.79641 11.0999C5.79641 11.1795 5.7648 11.2558 5.70854 11.312C5.65228 11.3683 5.57597 11.3999 5.49641 11.3999H3.59681C3.51724 11.3999 3.44094 11.3683 3.38468 11.312C3.32842 11.2558 3.29681 11.1795 3.29681 11.0999C3.29681 10.3829 3.71141 9.9779 4.11281 9.6743C4.19801 9.6101 4.28621 9.5471 4.37021 9.4883L4.41101 9.4583C4.50881 9.3893 4.60061 9.3227 4.68701 9.2543C4.86101 9.1163 4.99781 8.9801 5.09021 8.8211C5.28101 8.4959 5.24141 8.2499 5.13941 8.0927C5.02841 7.9211 4.81001 7.7999 4.55261 7.7999H4.55321ZM7.24301 7.9619C7.16101 8.03544 7.10116 8.1304 7.07021 8.2361C7.05962 8.27418 7.0416 8.3098 7.0172 8.34089C6.9928 8.37199 6.96249 8.39796 6.92802 8.41731C6.89356 8.43666 6.8556 8.449 6.81635 8.45363C6.77709 8.45827 6.73731 8.4551 6.69928 8.44431C6.66126 8.43352 6.62574 8.41532 6.59477 8.39075C6.5638 8.36619 6.53799 8.33575 6.51882 8.30118C6.49965 8.26661 6.4875 8.2286 6.48307 8.18932C6.47864 8.15004 6.48202 8.11027 6.49301 8.0723C6.53861 7.9109 6.64181 7.6925 6.84461 7.5125C7.05341 7.3277 7.34921 7.1999 7.74521 7.1999C8.55161 7.1999 9.00941 7.7903 9.00941 8.3183C9.00941 8.5295 8.96861 8.8541 8.75081 9.1301C8.70761 9.1841 8.65901 9.2351 8.60501 9.2813C8.68601 9.3413 8.76221 9.4157 8.82641 9.5063C8.94401 9.6725 9.00941 9.8777 9.00941 10.1183C9.00941 10.5563 8.86301 10.8923 8.60261 11.1143C8.35061 11.3273 8.03261 11.3999 7.74521 11.3999C7.47401 11.3999 7.20941 11.3543 6.98201 11.2097C6.74921 11.0615 6.59261 10.8329 6.49601 10.5389C6.48376 10.5014 6.479 10.4619 6.48202 10.4226C6.48504 10.3833 6.49577 10.345 6.5136 10.3098C6.53143 10.2747 6.55601 10.2434 6.58593 10.2177C6.61586 10.1921 6.65054 10.1726 6.68801 10.1603C6.72547 10.1481 6.76499 10.1433 6.80429 10.1463C6.84359 10.1493 6.88192 10.1601 6.91707 10.1779C6.95223 10.1957 6.98353 10.2203 7.00919 10.2502C7.03484 10.2801 7.05436 10.3148 7.06661 10.3523C7.13081 10.5485 7.21541 10.6475 7.30421 10.7039C7.39841 10.7639 7.53461 10.7999 7.74521 10.7999C7.94081 10.7999 8.10401 10.7495 8.21381 10.6559C8.31521 10.5707 8.40941 10.4159 8.40941 10.1183C8.41417 10.0244 8.38873 9.93147 8.33681 9.8531C8.28738 9.78786 8.22183 9.73658 8.14661 9.7043C7.96841 9.6203 7.74101 9.5999 7.58501 9.5999C7.50544 9.5999 7.42914 9.5683 7.37288 9.51203C7.31662 9.45577 7.28501 9.37947 7.28501 9.2999C7.28501 9.22034 7.31662 9.14403 7.37288 9.08777C7.42914 9.03151 7.50544 8.9999 7.58501 8.9999C8.00801 8.9999 8.19161 8.8697 8.27981 8.7581C8.37881 8.6333 8.40941 8.4665 8.40941 8.3183C8.40941 8.1257 8.22461 7.7999 7.74521 7.7999C7.48721 7.7999 7.33541 7.8797 7.24301 7.9619ZM1.80701 8.6189C1.65492 8.78467 1.48396 8.93207 1.29761 9.0581C1.26495 9.08143 1.22794 9.09797 1.18878 9.10673C1.14962 9.1155 1.10909 9.11632 1.06961 9.10915C1.03012 9.10197 0.992474 9.08695 0.958898 9.06496C0.925323 9.04297 0.8965 9.01447 0.874136 8.98115C0.851772 8.94783 0.836323 8.91035 0.828701 8.87095C0.82108 8.83155 0.821442 8.79102 0.829766 8.75175C0.83809 8.71249 0.854207 8.6753 0.877163 8.64238C0.900119 8.60946 0.929446 8.58148 0.963409 8.5601C1.40321 8.2655 1.73681 7.7921 1.81421 7.4363C1.81421 7.4363 1.88021 7.1999 2.09021 7.1999C2.39141 7.1999 2.40761 7.4999 2.40761 7.4999V11.0999C2.40761 11.1795 2.376 11.2558 2.31974 11.312C2.26348 11.3683 2.18717 11.3999 2.10761 11.3999C2.02804 11.3999 1.95174 11.3683 1.89548 11.312C1.83922 11.2558 1.80761 11.1795 1.80761 11.0999V8.6189H1.80701ZM9.60041 8.6999C9.60041 8.62034 9.63202 8.54403 9.68828 8.48777C9.74454 8.43151 9.82084 8.3999 9.90041 8.3999H10.5004C10.58 8.3999 10.6563 8.43151 10.7125 8.48777C10.7688 8.54403 10.8004 8.62034 10.8004 8.6999C10.8004 8.77947 10.7688 8.85577 10.7125 8.91203C10.6563 8.9683 10.58 8.9999 10.5004 8.9999H9.90041C9.82084 8.9999 9.74454 8.9683 9.68828 8.91203C9.63202 8.85577 9.60041 8.77947 9.60041 8.6999Z" fill="var(--darkBlue)" />
                                            </svg>
                                            <p className='flex-item sub-txt-title'>Count</p>
                                          </div>
                                          <p className='flex-item sub-txt-value'>{exercise.parameter.count ? exercise.parameter.count : 0}</p>
                                        </div>,
                                        (exercise.parameter.unit == "time") && <div className='d-flex m-t-12'>
                                        <div className='d-flex' style={{ width: "120px" }}>
                                          <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_683_1515)">
                                              <path d="M6 11.25C4.96165 11.25 3.94662 10.9421 3.08326 10.3652C2.2199 9.78834 1.54699 8.9684 1.14963 8.00909C0.752275 7.04978 0.648307 5.99418 0.85088 4.97578C1.05345 3.95738 1.55347 3.02192 2.28769 2.28769C3.02192 1.55347 3.95738 1.05345 4.97578 0.85088C5.99418 0.648307 7.04978 0.752275 8.00909 1.14963C8.9684 1.54699 9.78834 2.2199 10.3652 3.08326C10.9421 3.94662 11.25 4.96165 11.25 6C11.25 7.39239 10.6969 8.72775 9.71231 9.71231C8.72775 10.6969 7.39239 11.25 6 11.25ZM6 1.5C5.10999 1.5 4.23996 1.76392 3.49994 2.25839C2.75992 2.75286 2.18314 3.45566 1.84254 4.27793C1.50195 5.10019 1.41284 6.00499 1.58647 6.87791C1.7601 7.75082 2.18869 8.55265 2.81802 9.18198C3.44736 9.81132 4.24918 10.2399 5.1221 10.4135C5.99501 10.5872 6.89981 10.4981 7.72208 10.1575C8.54434 9.81686 9.24715 9.24009 9.74162 8.50007C10.2361 7.76005 10.5 6.89002 10.5 6C10.5 4.80653 10.0259 3.66194 9.18198 2.81802C8.33807 1.97411 7.19348 1.5 6 1.5Z" fill="var(--darkBlue)" />
                                              <path d="M7.72125 8.25L5.625 6.15375V2.625H6.375V5.8425L8.25 7.72125L7.72125 8.25Z" fill="var(--darkBlue)" />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_683_1515">
                                                <rect width="12" height="12" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <p className='flex-item sub-txt-title'>Duration</p>
                                        </div>
                                        <p className='flex-item sub-txt-value'>{(exercise.parameter.duration && exercise.parameter.duration.hour) ? exercise.parameter.duration.hour : 0} hr {(exercise.parameter.duration && exercise.parameter.duration.min) ? exercise.parameter.duration.min : 0} min</p>
                                      </div>
                                    ]
                                  }

                                  {
                                    (exercise.content._id) && [
                                      <div className='exercise-container-saperator' />,
                                      exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{fontWeight: 'bold'}}>Optional</p>,
                                      exercise.optionalExercises.map((optionalExercise, opindex) => {
                                        return [
                                          <div className='d-flex w-full space-between m-b-16'>
                                            <div className='d-flex' style={{ width: "80%" }} onClick={e => {
                                                toggleWeekDayDropdown(index, opindex)
                                                e.stopPropagation()
                                              }}>
                                              <svg style={{transform: (!optionalExercise.isDropdownOpen) ? 'rotate(0deg)' : 'rotate(180deg)' }} className='flex-item m-r-12' width="16" height="11" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1.00098 1L6.50098 6.5L12.501 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                              </svg>
                                              <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise.content && optionalExercise.content._id) ? optionalExercise.content.name : "Select Exercise"}</p>
                                              <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise.content && optionalExercise.content._id) ? "#5D883C" : "#E0E0E0"} />
                                                <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                              </svg>
                                            </div>
                                            <div className='d-flex'>
                                              {
                                                (optionalExercise.content && optionalExercise.content._id) && [
                                                  <div onClick={toggleVideoPlayer.bind(this, optionalExercise)} className='d-flex planner-play-exercise m-r-20'>
                                                    <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                                    </svg>
                                                  </div>,
                                                  <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise,null,'mainexercise')} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                                  </svg>
                                                ]
                                              }


                                              {
                                                !(optionalExercise.content && optionalExercise.content._id) && (
                                                  <div onClick={toggleExerciseContentManageWindow(opindex, {},null,'mainexercise')} className="global-button-container d-flex flex-item p-l-12 p-r-12" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                                    <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                                  </div>
                                                )
                                              }

                                              <svg onClick={handleRemoveOptionalExercise(opindex,'mainexercise')} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                                <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                              </svg>
                                            </div>
                                          </div>,
                                          (optionalExercise.isDropdownOpen && optionalExercise.parameter && optionalExercise.parameter.isParameterAdded) && [
                                            optionalExercise.parameter && optionalExercise.parameter.unit == "weight" && [
                                              <div className='d-flex m-t-12 m-b-12'>
                                                <div className='d-flex' style={{ width: "120px" }}>
                                                  <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_683_1507)">
                                                      <path d="M10.5 10.5V2.25H7.5V10.5H6V5.25H3V10.5H1.5V0.75H0.75V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H11.25V10.5H10.5ZM8.25 3H9.75V6.75H8.25V3ZM3.75 6H5.25V8.25H3.75V6Z" fill="var(--darkBlue)" />
                                                    </g>
                                                    <defs>
                                                      <clipPath id="clip0_683_1507">
                                                        <rect width="12" height="12" fill="white" />
                                                      </clipPath>
                                                    </defs>
                                                  </svg>
                                                  <p className='flex-item sub-txt-title'>Set</p>
                                                </div>
                                                <p className='flex-item sub-txt-value'>{optionalExercise.parameter.set ? optionalExercise.parameter.set.length : 0}</p>
                                              </div>],
                                            optionalExercise.parameter.unit == "distance" && <div className='d-flex m-t-12 m-b-14'>
                                              <div className='d-flex' style={{ width: "120px" }}>
                                                <svg className='flex-item m-r-8 svg-fill' width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M4.34105 4.84112L4.34107 4.8411C4.65572 4.52642 4.86999 4.12551 4.95679 3.68906C4.98559 3.54423 4.99993 3.39764 5 3.25139C4.99998 3.3978 4.98566 3.54455 4.95685 3.68954C4.87012 4.12593 4.65597 4.52681 4.34145 4.84151C4.34142 4.84154 4.34139 4.84157 4.34137 4.84159L2.75041 6.43255L2.75002 6.43215L3.10355 6.07862L4.34105 4.84112ZM2.39645 6.07862L2.68855 6.37072L1.15864 4.84159C1.15861 4.84157 1.15858 4.84154 1.15855 4.84151C1.15852 4.84148 1.15849 4.84145 1.15846 4.84142C0.843996 4.52674 0.629872 4.12589 0.543157 3.68954C0.514343 3.54455 0.500027 3.3978 0.500001 3.25139C0.500078 3.39764 0.514415 3.54423 0.543218 3.68906C0.630016 4.12551 0.844285 4.52642 1.15893 4.8411L1.15895 4.84112L2.39645 6.07862ZM8.695 9.48788L7.31336 10.8688L7.60355 10.5786L8.84105 9.34112L8.84107 9.3411C9.15572 9.02642 9.36999 8.62551 9.45679 8.18906C9.48192 8.06268 9.49604 7.93497 9.49928 7.80731C9.49605 7.93497 9.48196 8.06267 9.45685 8.18904C9.37011 8.62547 9.15593 9.02638 8.84136 9.34109L8.695 9.48753V9.48788ZM5.65895 9.34112L6.771 10.4532L5.65864 9.34109C5.34408 9.02638 5.12989 8.62547 5.04316 8.18904C5.01436 8.04413 5.00004 7.89747 5 7.75114C5.00006 7.89748 5.0144 8.04415 5.04322 8.18906C5.13002 8.62551 5.34429 9.02642 5.65893 9.3411L5.65895 9.34112ZM2.75 3.50006C2.6837 3.50006 2.62011 3.47372 2.57322 3.42684C2.52634 3.37996 2.5 3.31637 2.5 3.25006C2.5 3.18376 2.52634 3.12017 2.57322 3.07329C2.62011 3.0264 2.6837 3.00006 2.75 3.00006C2.81631 3.00006 2.87989 3.0264 2.92678 3.07329C2.97366 3.12017 3 3.18376 3 3.25006C3 3.31637 2.97366 3.37996 2.92678 3.42684C2.87989 3.47372 2.81631 3.50006 2.75 3.50006ZM7.25 8.00006C7.1837 8.00006 7.12011 7.97372 7.07322 7.92684C7.02634 7.87996 7 7.81637 7 7.75006C7 7.68376 7.02634 7.62017 7.07322 7.57329C7.12011 7.5264 7.1837 7.50006 7.25 7.50006C7.31631 7.50006 7.37989 7.5264 7.42678 7.57329C7.47366 7.62017 7.5 7.68376 7.5 7.75006C7.5 7.81637 7.47366 7.87996 7.42678 7.92684C7.37989 7.97372 7.3163 8.00006 7.25 8.00006Z" stroke="var(--darkBlue)" />
                                                </svg>
                                                <p className='flex-item sub-txt-title'>Distance</p>
                                              </div>
                                              <p className='flex-item sub-txt-value'>{optionalExercise.parameter.distance.value ? optionalExercise.parameter.distance.value : 0} {optionalExercise.parameter.distance.unit ? optionalExercise.parameter.distance.unit : "KM"}</p>
                                            </div>,
                                            optionalExercise.parameter.unit == "number" && <div className='d-flex m-t-12 m-b-14'>
                                              <div className='d-flex' style={{ width: "120px" }}>
                                                <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path d="M1.20041 2.6999C1.20041 2.62034 1.23202 2.54403 1.28828 2.48777C1.34454 2.43151 1.42084 2.3999 1.50041 2.3999H10.5004C10.58 2.3999 10.6563 2.43151 10.7125 2.48777C10.7688 2.54403 10.8004 2.62034 10.8004 2.6999C10.8004 2.77947 10.7688 2.85577 10.7125 2.91203C10.6563 2.9683 10.58 2.9999 10.5004 2.9999H1.50041C1.42084 2.9999 1.34454 2.9683 1.28828 2.91203C1.23202 2.85577 1.20041 2.77947 1.20041 2.6999ZM1.20041 5.6999C1.20041 5.62034 1.23202 5.54403 1.28828 5.48777C1.34454 5.43151 1.42084 5.3999 1.50041 5.3999H10.5004C10.58 5.3999 10.6563 5.43151 10.7125 5.48777C10.7688 5.54403 10.8004 5.62034 10.8004 5.6999C10.8004 5.77947 10.7688 5.85577 10.7125 5.91203C10.6563 5.9683 10.58 5.9999 10.5004 5.9999H1.50041C1.42084 5.9999 1.34454 5.9683 1.28828 5.91203C1.23202 5.85577 1.20041 5.77947 1.20041 5.6999ZM4.55321 7.7999C4.18541 7.7999 3.89741 8.1329 3.89741 8.4815C3.89741 8.56107 3.8658 8.63737 3.80954 8.69363C3.75328 8.7499 3.67697 8.7815 3.59741 8.7815C3.51784 8.7815 3.44154 8.7499 3.38528 8.69363C3.32902 8.63737 3.29741 8.56107 3.29741 8.4815C3.29741 7.8491 3.80861 7.1999 4.55321 7.1999C4.99121 7.1999 5.41061 7.4057 5.64341 7.7663C5.88581 8.1407 5.89661 8.6315 5.60921 9.1241C5.46281 9.3743 5.26121 9.5651 5.06081 9.7241C4.96121 9.8039 4.85741 9.8777 4.75901 9.9479L4.71701 9.9779C4.63241 10.0379 4.55261 10.0943 4.47521 10.1525C4.21181 10.3523 4.02101 10.5413 3.94061 10.7999H5.49641C5.57597 10.7999 5.65228 10.8315 5.70854 10.8878C5.7648 10.944 5.79641 11.0203 5.79641 11.0999C5.79641 11.1795 5.7648 11.2558 5.70854 11.312C5.65228 11.3683 5.57597 11.3999 5.49641 11.3999H3.59681C3.51724 11.3999 3.44094 11.3683 3.38468 11.312C3.32842 11.2558 3.29681 11.1795 3.29681 11.0999C3.29681 10.3829 3.71141 9.9779 4.11281 9.6743C4.19801 9.6101 4.28621 9.5471 4.37021 9.4883L4.41101 9.4583C4.50881 9.3893 4.60061 9.3227 4.68701 9.2543C4.86101 9.1163 4.99781 8.9801 5.09021 8.8211C5.28101 8.4959 5.24141 8.2499 5.13941 8.0927C5.02841 7.9211 4.81001 7.7999 4.55261 7.7999H4.55321ZM7.24301 7.9619C7.16101 8.03544 7.10116 8.1304 7.07021 8.2361C7.05962 8.27418 7.0416 8.3098 7.0172 8.34089C6.9928 8.37199 6.96249 8.39796 6.92802 8.41731C6.89356 8.43666 6.8556 8.449 6.81635 8.45363C6.77709 8.45827 6.73731 8.4551 6.69928 8.44431C6.66126 8.43352 6.62574 8.41532 6.59477 8.39075C6.5638 8.36619 6.53799 8.33575 6.51882 8.30118C6.49965 8.26661 6.4875 8.2286 6.48307 8.18932C6.47864 8.15004 6.48202 8.11027 6.49301 8.0723C6.53861 7.9109 6.64181 7.6925 6.84461 7.5125C7.05341 7.3277 7.34921 7.1999 7.74521 7.1999C8.55161 7.1999 9.00941 7.7903 9.00941 8.3183C9.00941 8.5295 8.96861 8.8541 8.75081 9.1301C8.70761 9.1841 8.65901 9.2351 8.60501 9.2813C8.68601 9.3413 8.76221 9.4157 8.82641 9.5063C8.94401 9.6725 9.00941 9.8777 9.00941 10.1183C9.00941 10.5563 8.86301 10.8923 8.60261 11.1143C8.35061 11.3273 8.03261 11.3999 7.74521 11.3999C7.47401 11.3999 7.20941 11.3543 6.98201 11.2097C6.74921 11.0615 6.59261 10.8329 6.49601 10.5389C6.48376 10.5014 6.479 10.4619 6.48202 10.4226C6.48504 10.3833 6.49577 10.345 6.5136 10.3098C6.53143 10.2747 6.55601 10.2434 6.58593 10.2177C6.61586 10.1921 6.65054 10.1726 6.68801 10.1603C6.72547 10.1481 6.76499 10.1433 6.80429 10.1463C6.84359 10.1493 6.88192 10.1601 6.91707 10.1779C6.95223 10.1957 6.98353 10.2203 7.00919 10.2502C7.03484 10.2801 7.05436 10.3148 7.06661 10.3523C7.13081 10.5485 7.21541 10.6475 7.30421 10.7039C7.39841 10.7639 7.53461 10.7999 7.74521 10.7999C7.94081 10.7999 8.10401 10.7495 8.21381 10.6559C8.31521 10.5707 8.40941 10.4159 8.40941 10.1183C8.41417 10.0244 8.38873 9.93147 8.33681 9.8531C8.28738 9.78786 8.22183 9.73658 8.14661 9.7043C7.96841 9.6203 7.74101 9.5999 7.58501 9.5999C7.50544 9.5999 7.42914 9.5683 7.37288 9.51203C7.31662 9.45577 7.28501 9.37947 7.28501 9.2999C7.28501 9.22034 7.31662 9.14403 7.37288 9.08777C7.42914 9.03151 7.50544 8.9999 7.58501 8.9999C8.00801 8.9999 8.19161 8.8697 8.27981 8.7581C8.37881 8.6333 8.40941 8.4665 8.40941 8.3183C8.40941 8.1257 8.22461 7.7999 7.74521 7.7999C7.48721 7.7999 7.33541 7.8797 7.24301 7.9619ZM1.80701 8.6189C1.65492 8.78467 1.48396 8.93207 1.29761 9.0581C1.26495 9.08143 1.22794 9.09797 1.18878 9.10673C1.14962 9.1155 1.10909 9.11632 1.06961 9.10915C1.03012 9.10197 0.992474 9.08695 0.958898 9.06496C0.925323 9.04297 0.8965 9.01447 0.874136 8.98115C0.851772 8.94783 0.836323 8.91035 0.828701 8.87095C0.82108 8.83155 0.821442 8.79102 0.829766 8.75175C0.83809 8.71249 0.854207 8.6753 0.877163 8.64238C0.900119 8.60946 0.929446 8.58148 0.963409 8.5601C1.40321 8.2655 1.73681 7.7921 1.81421 7.4363C1.81421 7.4363 1.88021 7.1999 2.09021 7.1999C2.39141 7.1999 2.40761 7.4999 2.40761 7.4999V11.0999C2.40761 11.1795 2.376 11.2558 2.31974 11.312C2.26348 11.3683 2.18717 11.3999 2.10761 11.3999C2.02804 11.3999 1.95174 11.3683 1.89548 11.312C1.83922 11.2558 1.80761 11.1795 1.80761 11.0999V8.6189H1.80701ZM9.60041 8.6999C9.60041 8.62034 9.63202 8.54403 9.68828 8.48777C9.74454 8.43151 9.82084 8.3999 9.90041 8.3999H10.5004C10.58 8.3999 10.6563 8.43151 10.7125 8.48777C10.7688 8.54403 10.8004 8.62034 10.8004 8.6999C10.8004 8.77947 10.7688 8.85577 10.7125 8.91203C10.6563 8.9683 10.58 8.9999 10.5004 8.9999H9.90041C9.82084 8.9999 9.74454 8.9683 9.68828 8.91203C9.63202 8.85577 9.60041 8.77947 9.60041 8.6999Z" fill="var(--darkBlue)" />
                                                </svg>
                                                <p className='flex-item sub-txt-title'>Count</p>
                                              </div>
                                              <p className='flex-item sub-txt-value'>{optionalExercise.parameter.count ? optionalExercise.parameter.count : 0}</p>
                                            </div>,
                                            optionalExercise.parameter.unit == "time" && <div className='d-flex m-t-12 m-b-14'>
                                              <div className='d-flex' style={{ width: "120px" }}>
                                                <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <g clip-path="url(#clip0_683_1515)">
                                                    <path d="M6 11.25C4.96165 11.25 3.94662 10.9421 3.08326 10.3652C2.2199 9.78834 1.54699 8.9684 1.14963 8.00909C0.752275 7.04978 0.648307 5.99418 0.85088 4.97578C1.05345 3.95738 1.55347 3.02192 2.28769 2.28769C3.02192 1.55347 3.95738 1.05345 4.97578 0.85088C5.99418 0.648307 7.04978 0.752275 8.00909 1.14963C8.9684 1.54699 9.78834 2.2199 10.3652 3.08326C10.9421 3.94662 11.25 4.96165 11.25 6C11.25 7.39239 10.6969 8.72775 9.71231 9.71231C8.72775 10.6969 7.39239 11.25 6 11.25ZM6 1.5C5.10999 1.5 4.23996 1.76392 3.49994 2.25839C2.75992 2.75286 2.18314 3.45566 1.84254 4.27793C1.50195 5.10019 1.41284 6.00499 1.58647 6.87791C1.7601 7.75082 2.18869 8.55265 2.81802 9.18198C3.44736 9.81132 4.24918 10.2399 5.1221 10.4135C5.99501 10.5872 6.89981 10.4981 7.72208 10.1575C8.54434 9.81686 9.24715 9.24009 9.74162 8.50007C10.2361 7.76005 10.5 6.89002 10.5 6C10.5 4.80653 10.0259 3.66194 9.18198 2.81802C8.33807 1.97411 7.19348 1.5 6 1.5Z" fill="var(--darkBlue)" />
                                                    <path d="M7.72125 8.25L5.625 6.15375V2.625H6.375V5.8425L8.25 7.72125L7.72125 8.25Z" fill="var(--darkBlue)" />
                                                  </g>
                                                  <defs>
                                                    <clipPath id="clip0_683_1515">
                                                      <rect width="12" height="12" fill="white" />
                                                    </clipPath>
                                                  </defs>
                                                </svg>
                                                <p className='flex-item sub-txt-title'>Duration</p>
                                              </div>
                                              <p className='flex-item sub-txt-value'>{optionalExercise.parameter.duration.hour ? optionalExercise.parameter.duration.hour : 0} hr {optionalExercise.parameter.duration.min ? optionalExercise.parameter.duration.min : 0} min</p>
                                            </div>
                                          ]
                                        ]
                                      }),
                                      (exercise.optionalExercises.length == 0) && (
                                        <div onClick={()=>handleAddOptionalExerise(0,"mainexercise")} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                          <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Optional Exercise</p>
                                        </div>
                                      ),
                                      (exercise.optionalExercises.length == 1) && (
                                        <div onClick={()=>handleAddOptionalExerise(1,"mainexercise")} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                          <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add More</p>
                                        </div>
                                      )
                                    ]
                                  }
                                </div>
                              )
                            }),
                            dayPlanner.workout.length < 10 && (
                              <div onClick={handleAddExercise} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-t-20" style={{ width: "160px", background: "#ffffff", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <p className="flex-item">Add More Exercise(s)</p>
                              </div>
                            )
                        ]
                      }
                    </div>
                  )
                }

                <div className="bottom-action-button">
                  <div onClick={isButtonLock ? null : (props.isEdit ? EditPlanner : CreatePlanner)}  className={`member-button-global ${isButtonLock ? "member-button-global-inactive" : ""} btn-center d-flex`}>
                    <p className="flex-item" style={{fontWeight:"700", fontSize:"16px", color:"var(--darkBlue)"}}>{props.isEdit ? "Edit Planner" : "Create Planner"}</p>
                  </div>
                </div>
              </div>
            ]
          }
          {
            currentWindow == "warm-up" && [
              // <div className="d-flex w-full global-modal-header-container">
              //   {/* <div className="d-flex desktop-modal-close-button m-r-12 right-slider">
              //     <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              //       <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
              //     </svg>
              //   </div> */}
              //   <p className="flex-item modal-header-text m-t-6">Warm Up</p>
              // </div>,
              <div className='w-full p-l-12 m-b-6 m-t-20'>
                <p className="flex-item fs-22 font-weight-700 color-red m-t-6" style={{lineHeight:"22px"}}>Warm Up</p>
                <p className='fs-10'>Add all warmup exercises here</p>
              </div>,
              <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ overflow: "auto", height:"86%" }}>
                {
                  workoutPlanner.warmup.map((exercise, index) => {
                    return (
                      <div className='planner-exercise-container m-b-12' style={{ position: 'relative', backgroundColor: selectedExerciseIndex == index ? "#ffffff" : "#f5f5f5" }} onClick={handleSelectExercise(index)}>
                        <div className='d-flex w-full space-between'>
                          <div className='d-flex' style={{ width: "80%" }}>
                            <p className='planner-exercise-name fs-18' style={{ maxWidth: "75%" }}>{(exercise.content && exercise.content._id) ? getShortString(exercise.content.name,15) : "Select Exercise"}</p>
                            <svg className='m-l-16 m-t-2' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(exercise.content && exercise.content._id) ? "#5D883C" : "#E0E0E0"} />
                              <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                            </svg>
                          </div>

                          {
                            exercise.content._id && selectedExerciseIndex == index && (
                              <div className='d-flex'>
                                <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                  <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                  </svg>
                                </div>
                                <div className='m-r-20 d-flex'>
                                  <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content)} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                  </svg>
                                </div>
                              </div>
                            )
                          }

                          {
                            exercise && !exercise.content._id  && (
                              <div onClick={toggleExerciseContentManageWindow(-1, {}, index)} className={`global-button-container d-flex flex-item p-l-12 p-r-12`} style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                              </div>
                            )
                          }

                          {
                            index == 0 && exercise && exercise.content._id && (
                              <svg onClick={removeExercise(index)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                              </svg>
                            )
                          }

                          {
                            index > 0 && (
                              <svg onClick={removeExercise(index)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                              </svg>
                            )
                          }
                          

                        </div>

                        {
                          (selectedExerciseIndex == index && exercise.content._id) && [
                            <div className='exercise-container-saperator' />,
                            exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{fontWeight: 'bold'}}>Optional</p>,
                            exercise.optionalExercises.map((optionalExercise, opindex) => {
                              return (
                                <div className='d-flex w-full space-between m-b-16'>
                                  <div className='d-flex' style={{ width: "80%" }}>
                                    <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise._id) ? optionalExercise.name : "Select Exercise"}</p>
                                    <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise._id) ? "#5D883C" : "#E0E0E0"} />
                                      <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                    </svg>
                                  </div>
                                  <div className='d-flex'>
                                    {
                                      optionalExercise._id && [
                                        <div onClick={toggleVideoPlayer.bind(this, optionalExercise)} className='d-flex planner-play-exercise m-r-20'>
                                          <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                          </svg>
                                        </div>,
                                        <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise)} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                        </svg>
                                      ]
                                    }


                                    {
                                      !optionalExercise._id && (
                                        <div onClick={toggleExerciseContentManageWindow(opindex, {})} className="global-button-container d-flex flex-item p-l-12 p-r-12" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                          <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                        </div>
                                      )
                                    }

                                    <svg onClick={handleRemoveOptionalExercise(opindex)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                      <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                    </svg>
                                  </div>
                                </div>
                              )
                            }),
                            (exercise.optionalExercises.length == 0) && (
                              <div onClick={()=>handleAddOptionalExerise(0)} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Optional Exercise</p>
                              </div>
                            ),
                            (exercise.optionalExercises.length == 1) && (
                              <div onClick={()=>handleAddOptionalExerise(1)} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add More</p>
                              </div>
                            )
                          ]
                        }
                      </div>
                    )
                  })
                }
                {
                  workoutPlanner.warmup.length < 10 && (
                    <div onClick={handleAddExercise} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-t-20" style={{ width: "160px", background: "#ffffff", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                      <p className="flex-item">Add More Exercise(s)</p>
                    </div>
                  )
                }

              </div>,
              <div className='bottom-action-button'>
                {/* <div onClick={toggleBackToPrevWindow.bind(this)} className="d-flex" style={{ cursor: 'pointer' }}>
                  <div className="flex-item d-flex bell-menu-container m-r-12 right-slider" style={{
                    boxShadow: '0px 0px 4px  rgba(0,0,0,0.25)'
                  }}>
                    <svg className='flex-item stroke-svg' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" strokeWidth="2" stroke-linecap="round" />
                    </svg>
                  </div>
                  <p className='flex-item fs-16' style={{ fontWeight: 600 }}>Back to Home</p>
                </div> */}

                <div className='d-flex'>
                  <div className='d-flex flex-item' style={{margin: "0 0 0 auto"}}>
                    <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`} style={{background:"#f2f2f2", width:"120px"}}>
                      <p className='flex-item fs-16' style={{ fontWeight: 600 }}>Close</p>
                    </div>
                    {
                      workoutPlanner.warmup.length > 0 && workoutPlanner.warmup[0].content && workoutPlanner.warmup[0].content._id && [
                        <div className='m-l-12'/>,
                        <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`} style={{background:"#ffffff", width:"300px"}}>
                          <p className='flex-item fs-16' style={{ fontWeight: 600, whiteSpace:"nowrap" }}>Save & Continue</p>
                        </div>
                      ]
                    }
                  </div>
                </div>

              </div>
            ]
          }
          {
            currentWindow == "cool-down" && [
              <div className='w-full p-l-12 m-b-6 m-t-20'>
                <p className="flex-item fs-22 font-weight-600 color-blue m-t-6" style={{lineHeight:"22px"}}>Cool Down</p>
                <p className='fs-10'>Add all cooldown exercises here</p>
              </div>,
              <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ overflow: "auto", height:"86%" }}>
                {
                  workoutPlanner.cooldown.map((exercise, index) => {
                    return (
                      <div className='planner-exercise-container m-b-12' style={{ position: 'relative', backgroundColor: selectedExerciseIndex == index ? "#ffffff" : "#f5f5f5" }} onClick={handleSelectExercise(index)}>
                        <div className='d-flex w-full space-between'>
                          <div className='d-flex' style={{ width: "80%" }}>
                            <p className='planner-exercise-name fs-18' style={{ maxWidth: "75%", fontWeight: 'bold' }}>{(exercise.content && exercise.content._id) ? getShortString(exercise.content.name,15) : "Select Exercise"}</p>
                            <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(exercise.content && exercise.content._id) ? "#5D883C" : "#E0E0E0"} />
                              <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                            </svg>
                          </div>

                          {
                            exercise.content._id && selectedExerciseIndex == index && (
                              <div className='d-flex'>
                                <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                  <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                  </svg>
                                </div>
                                {/* <div className='m-r-20 d-flex'>
                                  <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content)} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                  </svg>
                                </div>
 */}

                              </div>
                            )
                          }

                          {
                            exercise && !exercise.content._id && (
                              <div onClick={toggleExerciseContentManageWindow(-1, {}, index)} className={`global-button-container d-flex flex-item p-l-12 p-r-12`} style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                              </div>
                            )
                          }

                          {
                            index == 0 && exercise && exercise.content._id && (
                              <svg onClick={removeExercise(index)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                              </svg>
                            )
                          }

                          {
                            index > 0 && (
                              <svg onClick={removeExercise(index)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                              </svg>
                            )
                          }
                        </div>

                        {
                          (selectedExerciseIndex == index && exercise.content._id) && [
                            <div className='exercise-container-saperator' />,
                            exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{
                              fontWeight: 'bold'
                            }}>Optional</p>,
                            exercise.optionalExercises.map((optionalExercise, opindex) => {
                              return (
                                <div className='d-flex w-full space-between m-b-16'>
                                  <div className='d-flex' style={{ width: "80%" }}>
                                    <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise._id) ? optionalExercise.name : "Select Exercise"}</p>
                                    <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise._id) ? "#5D883C" : "#E0E0E0"} />
                                      <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                    </svg>
                                  </div>
                                  <div className='d-flex'>
                                    {
                                      optionalExercise._id && [
                                        <div onClick={toggleVideoPlayer.bind(this, optionalExercise)} className='d-flex planner-play-exercise m-r-20'>
                                          <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                          </svg>
                                        </div>,
                                        <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise)} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                        </svg>
                                      ]
                                    }


                                    {
                                      !optionalExercise._id && (
                                        <div onClick={toggleExerciseContentManageWindow(opindex, {})} className="global-button-container d-flex flex-item p-l-12 p-r-12" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                          <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                        </div>
                                      )
                                    }

                                    <svg onClick={handleRemoveOptionalExercise(opindex)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                      <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                    </svg>
                                  </div>
                                </div>
                              )
                            }),
                            (exercise.optionalExercises.length == 0) && (
                              <div onClick={()=>handleAddOptionalExerise(0)} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Optional Exercise</p>
                              </div>
                            ),
                            (exercise.optionalExercises.length == 1) && (
                              <div onClick={()=>handleAddOptionalExerise(1)} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add More</p>
                              </div>
                            )
                          ]
                        }
                      </div>
                    )
                  })
                }
                {
                  workoutPlanner.cooldown.length < 10 && (
                    <div onClick={handleAddExercise} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-t-20" style={{ width: "160px", background: "#ffffff", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                      <p className="flex-item">Add More Exercise(s)</p>
                    </div>
                  )
                }
              </div>,
              <div className='bottom-action-button'>
                {/* <div onClick={toggleBackToPrevWindow.bind(this)} className="d-flex" style={{ cursor: 'pointer' }}>
                  <div className="flex-item d-flex bell-menu-container m-r-12" style={{
                    boxShadow: '0px 0px 4px  rgba(0,0,0,0.25)'
                  }}>
                    <svg className='flex-item stroke-svg' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" strokeWidth="2" stroke-linecap="round" />
                    </svg>
                  </div>
                  <p className='flex-item fs-16' style={{ fontWeight: 600 }}>Back to Home</p>
                </div> */}
                <div className='d-flex'>
                  <div className='d-flex flex-item' style={{margin: "0 0 0 auto"}}>
                    <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`} style={{background:"#f2f2f2", width:"120px"}}>
                      <p className='flex-item fs-16' style={{ fontWeight: 600 }}>Close</p>
                    </div>
                    {
                      workoutPlanner.cooldown.length > 0 && workoutPlanner.cooldown[0].content && workoutPlanner.cooldown[0].content._id && [
                        <div className='m-l-12'/>,
                        <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`} style={{background:"#ffffff", width:"300px"}}>
                          <p className='flex-item fs-16' style={{ fontWeight: 600, whiteSpace:"nowrap" }}>Save & Continue</p>
                        </div>
                      ]
                    }
                  </div>
                </div>
              </div>
            ]
          }
          {
            currentWindow == "weekdays-exercise" && [
              <div className="global-modal-scroll-container m-t-0" style={{ overflow: "auto", height:!isEditActive &&dayStorage.Days.filter(data=>workoutPlanner.weekdays.findIndex(d2=>d2.dayName==data.name)==-1).length>0?"100%":'86%' }}>
                <div className="w-full m-b-12" style={{borderBottom:"1px dashed #9a9a9a"}}>
                  <div className='d-flex space-between'>
                    <div className='flex-item' style={{textAlign:"left"}}>
                      <p className='fs-20 color-red font-weight-700'>{(isEditActive && dayStorage.Days.filter(d=>d.isSelected).length)?"Edit "+ (dayStorage.Days.filter(d=>d.isSelected)[0].name == "Mon" ? "Monday" : dayStorage.Days.filter(d=>d.isSelected)[0].name == "Tue" ? "Tuesday" : dayStorage.Days.filter(d=>d.isSelected)[0].name == "Wed" ? "Wednesday" : dayStorage.Days.filter(d=>d.isSelected)[0].name == "Thu" ? "Thursday" : dayStorage.Days.filter(d=>d.isSelected)[0].name == "Fri" ? "Friday" : dayStorage.Days.filter(d=>d.isSelected)[0].name == "Sat" ? "Saturday" : dayStorage.Days.filter(d=>d.isSelected)[0].name) :`Day's of workout`}</p>
                      <p className='day-workout-sub-txt'>{isEditActive?'Updating day exercises':'You can select multiple days & add workout'}</p>
                    </div>
                    <div className='d-flex m-r-8' style={{alignSelf:"flex-start"}}>
                      {/* {
                        workoutPlanner.weekdays.length > 1 && (
                          <div onClick={()=>handleWeekDayDeleteMode()} className='flex-item d-flex desktop-modal-close-button' style={{background : workoutDayDeleteEnabled ? "var(--darkBlue)" : ""}}>
                            <svg className='flex-item' width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill={workoutDayDeleteEnabled ? "#ffffff" : "#C1C1C1"}/>
                            </svg>
                          </div>
                        )
                      } */}
                      {/* {
                        workoutPlanner.weekdays.length < 6 && (
                          <div onClick={()=>handleAddWorkoutWeekDays(workoutPlanner.weekdays.length)} className='flex-item d-flex desktop-modal-close-button m-l-12'>
                            <svg className='flex-item' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8 17C8 17.2652 8.10536 17.5196 8.29289 17.7071C8.48043 17.8946 8.73478 18 9 18C9.26522 18 9.51957 17.8946 9.70711 17.7071C9.89464 17.5196 10 17.2652 10 17V10H17C17.2652 10 17.5196 9.89464 17.7071 9.70711C17.8946 9.51957 18 9.26522 18 9C18 8.73478 17.8946 8.48043 17.7071 8.29289C17.5196 8.10536 17.2652 8 17 8H10V1C10 0.734784 9.89464 0.48043 9.70711 0.292893C9.51957 0.105357 9.26522 0 9 0C8.73478 0 8.48043 0.105357 8.29289 0.292893C8.10536 0.48043 8 0.734784 8 1V8H1C0.734784 8 0.48043 8.10536 0.292893 8.29289C0.105357 8.48043 0 8.73478 0 9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H8V17Z" fill="var(--darkBlue)"/>
                            </svg>
                          </div>
                        )
                      } */}
                    </div>
                  </div>
                  {!isEditActive && dayStorage.Days.filter(data=>workoutPlanner.weekdays.findIndex(d2=>d2.dayName==data.name)==-1).length>0 && <div className='d-flex-wrap m-t-20'>
                    {
                      dayStorage.Days.filter(data=>workoutPlanner.weekdays.findIndex(d2=>d2.dayName==data.name)==-1).map((data, index) => {
                        return(
                            <div onClick={() => handleSelectPlannerDay("workout", data.name)} className={`${data.isSelected ? "day-chips day-chips-active" : "day-chips"} d-flex cursor-pointer m-r-10 m-b-16`} style={{width:"58px", height: "30px", padding: "0"}}>
                              <p className='flex-item' style={{margin:"0 auto"}}>{data.name}</p>
                            </div>
                          )
                        }
                      )
                    }
                  </div>}
                  {
                    dayStorage.Days.length < 6 && (
                      <p className='days-note-txt' style={{textAlign:"left"}}>*Note - You can add up to 6 days</p>
                    )
                  }
                </div>
                {
                  dayStorage.Days.filter(data => data.isSelected == true).length > 0 && (
                    <div className='w-full'>
                    <p className='fs-18 m-b-8' style={{color:"var(--darkBlue)", fontWeight:"700"}}>Plan workout for {" "} 
                      {dayStorage.Days[0].isSelected && dayStorage.Days.slice(1, 5).findIndex(item => item.isSelected == true) !== -1  ? "Mon, " 
                      : dayStorage.Days[0].isSelected ? "Mon" 
                      : null} 
                      
                      {dayStorage.Days[1].isSelected && 
                      dayStorage.Days.slice(2, 6).findIndex(item => item.isSelected == true) !== -1 && 
                      dayStorage.Days.slice(2, 6).filter(item => item.isSelected == true).length > 1 ? "Tue, " 
                      : dayStorage.Days[1].isSelected && 
                      dayStorage.Days.slice(2, 6).findIndex(item => item.isSelected == true) !== -1 && 
                      dayStorage.Days.slice(2, 6).filter(item => item.isSelected == true).length == 1 ? "Tue & " 
                      : dayStorage.Days[1].isSelected ? "Tue" :
                      null}

                      {dayStorage.Days[2].isSelected && 
                      dayStorage.Days.slice(3, 6).findIndex(item => item.isSelected == true) !== -1 && 
                      dayStorage.Days.slice(3, 6).filter(item => item.isSelected == true).length > 1 ? "Wed, " 
                      : dayStorage.Days[2].isSelected && 
                      dayStorage.Days.slice(3, 6).findIndex(item => item.isSelected == true) !== -1 && 
                      dayStorage.Days.slice(3, 6).filter(item => item.isSelected == true).length == 1 ? "Wed & " 
                      : dayStorage.Days[2].isSelected ? "Wed" :
                      null} 

                      {dayStorage.Days[3].isSelected && 
                      dayStorage.Days.slice(4, 6).findIndex(item => item.isSelected == true) !== -1 && 
                      dayStorage.Days.slice(4, 6).filter(item => item.isSelected == true).length > 1 ? "Thu, " 
                      : dayStorage.Days[3].isSelected && 
                      dayStorage.Days.slice(4, 6).findIndex(item => item.isSelected == true) !== -1 && 
                      dayStorage.Days.slice(4, 6).filter(item => item.isSelected == true).length == 1 ? "Thu & " 
                      : dayStorage.Days[3].isSelected ? "Thu" :
                      null} 

                      {dayStorage.Days[4].isSelected && 
                      dayStorage.Days.slice(5, 6).findIndex(item => item.isSelected == true) !== -1 && 
                      dayStorage.Days.slice(5, 6).filter(item => item.isSelected == true).length > 1 ? "Fri, " 
                      : dayStorage.Days[4].isSelected && 
                      dayStorage.Days.slice(5, 6).findIndex(item => item.isSelected == true) !== -1 && 
                      dayStorage.Days.slice(5, 6).filter(item => item.isSelected == true).length == 1 ? "Fri & " 
                      : dayStorage.Days[4].isSelected ? "Fri" :
                      null} 

                      {dayStorage.Days[5].isSelected && "Sat"}
                      </p>

                      <div onClick={toggleInputFields("exercise-display-name")} className={`${(currentElementId == "exercise-display-name" || dayStorage.displayName) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-display-name" || dayStorage.displayName) ? "1px solid var(--darkBlue)" : "" }}>
                        <div className="flex-item d-flex">
                          <svg className='m-r-4 flex-item' width={(currentElementId == "exercise-display-name" || dayStorage.displayName) ? "12" : "18"} height={(currentElementId == "exercise-display-name" || dayStorage.displayName) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.955 6.969L16.267 6.281L17.17 5.332L13.817 1.979L12.868 2.882L12.155 2.169L13.767 0.507L18.617 5.357L16.955 6.969ZM0.543 13.806L2.155 12.194L2.868 12.907L1.958 13.811L5.338 17.191L6.242 16.281L6.955 16.994L5.343 18.606L0.543 13.806ZM15.707 11.171L17.709 9.169L9.98 1.44L7.978 3.442L15.707 11.171ZM9.13 17.748L11.151 15.721L3.428 7.998L1.401 10.019L9.13 17.748ZM8.865 12.032L11.999 8.904L10.245 7.15L7.117 10.284L8.865 12.032ZM12.578 15.74L9.13 19.15L0 10.019L3.409 6.571L6.403 9.571L9.538 6.436L6.557 3.442L9.999 0L19.149 9.15L15.707 12.592L12.713 9.612L9.578 12.746L12.578 15.74Z" fill={(currentElementId == "exercise-display-name" || dayStorage.displayName) ? "var(--darkBlue)" : "#6d6d6d"}/>
                          </svg>
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-display-name" || dayStorage.displayName) ? "10px" : "14px", color: (currentElementId == "exercise-display-name" || dayStorage.displayName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Workout Display Name *</p>
                        </div>
                        <input id="exercise-display-name" value={dayStorage.displayName} onInput={handleWeekDayWorkoutDisplayName} className={`${(currentElementId == "exercise-display-name" || dayStorage.displayName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Enter Name" style={{ textTransform: 'capitalize' }} />
                      </div>

                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable" type="ITEM">
                          {(provided) => (
                            <div className='w-full' {...provided.droppableProps} ref={provided.innerRef}>
                              {
                                dayStorage.exercises.map((exercise, index) => {
                                  return (
                                    <Draggable key={"exercise-id-" + index} draggableId={"exercise-id-" + index} index={index}>
                                       {(provided) => (
                                          <div draggable="true" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            <div className='planner-exercise-container m-b-12' onClick={handleSelectExercise(index)} style={{ position: 'relative', backgroundColor: selectedExerciseIndex == index ? "#ffffff" : "#f5f5f5" }}>
                                              <div className='d-flex w-full space-between'>
                                                <div className='d-flex' style={{ width: "80%" }}>
                                                  <svg style={{transform: (!exercise.isDropdownOpen) ? 'rotate(0deg)' : 'rotate(180deg)' }} className='flex-item m-r-12' width="16" height="11" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.00098 1L6.50098 6.5L12.501 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                                  </svg>
                                                  <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{exercise.content.name ? getShortString(exercise.content.name,15) : "Select Exercise"}</p>
                                                  <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={exercise.content._id ? "#5d883c" : "#E0E0E0"} />
                                                    <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                                  </svg>
                                                </div>

                                                {
                                                  (exercise.content._id && selectedExerciseIndex == index) && (
                                                    <div className='d-flex'>
                                                      <div onClick={toggleVideoPlayer.bind(this, exercise.content)} className='planner-play-exercise d-flex  m-r-20'>
                                                        <svg className='flex-item' width="16" height="16" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                                        </svg>
                                                      </div>
                                                      <div className='m-r-20 d-flex'>
                                                        <svg onClick={toggleExerciseContentManageWindow(-1, exercise.content)} className='flex-item' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                                        </svg>
                                                      </div>
                                                    </div>
                                                  )
                                                }

                                                {
                                                  exercise && !exercise.content._id && (
                                                    <div onClick={toggleExerciseContentManageWindow(-1, {}, index)} className={`global-button-container d-flex flex-item p-l-12 p-r-12`} style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                                      <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                                    </div>
                                                  )
                                                }

                                                {index>0 && <svg onClick={event=>{ removeDayExercise(index); event.stopPropagation()}} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                                  <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                                </svg>}
                                                
                                              </div>

                                              {
                                                (selectedExerciseIndex == index && exercise.isDropdownOpen && exercise.parameter && exercise.parameter.isParameterAdded) && [
                                                  (exercise.parameter.unit == "weight") && [
                                                    <div className='d-flex m-t-12 m-b-8'>
                                                      <div className='d-flex' style={{ width: "120px" }}>
                                                        <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <g clip-path="url(#clip0_683_1507)">
                                                            <path d="M10.5 10.5V2.25H7.5V10.5H6V5.25H3V10.5H1.5V0.75H0.75V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H11.25V10.5H10.5ZM8.25 3H9.75V6.75H8.25V3ZM3.75 6H5.25V8.25H3.75V6Z" fill="var(--darkBlue)" />
                                                          </g>
                                                          <defs>
                                                            <clipPath id="clip0_683_1507">
                                                              <rect width="12" height="12" fill="white" />
                                                            </clipPath>
                                                          </defs>
                                                        </svg>
                                                        <p className='flex-item sub-txt-title'>Set</p>
                                                      </div>
                                                      <p className='flex-item sub-txt-value'>{exercise.parameter.set ? exercise.parameter.set.length : 0}</p>
                                                    </div>],
                                                    (exercise.parameter.unit == "distance") && <div className='d-flex m-t-12'>
                                                      <div className='d-flex' style={{ width: "120px" }}>
                                                        <svg className='flex-item m-r-8 svg-fill' width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <path d="M4.34105 4.84112L4.34107 4.8411C4.65572 4.52642 4.86999 4.12551 4.95679 3.68906C4.98559 3.54423 4.99993 3.39764 5 3.25139C4.99998 3.3978 4.98566 3.54455 4.95685 3.68954C4.87012 4.12593 4.65597 4.52681 4.34145 4.84151C4.34142 4.84154 4.34139 4.84157 4.34137 4.84159L2.75041 6.43255L2.75002 6.43215L3.10355 6.07862L4.34105 4.84112ZM2.39645 6.07862L2.68855 6.37072L1.15864 4.84159C1.15861 4.84157 1.15858 4.84154 1.15855 4.84151C1.15852 4.84148 1.15849 4.84145 1.15846 4.84142C0.843996 4.52674 0.629872 4.12589 0.543157 3.68954C0.514343 3.54455 0.500027 3.3978 0.500001 3.25139C0.500078 3.39764 0.514415 3.54423 0.543218 3.68906C0.630016 4.12551 0.844285 4.52642 1.15893 4.8411L1.15895 4.84112L2.39645 6.07862ZM8.695 9.48788L7.31336 10.8688L7.60355 10.5786L8.84105 9.34112L8.84107 9.3411C9.15572 9.02642 9.36999 8.62551 9.45679 8.18906C9.48192 8.06268 9.49604 7.93497 9.49928 7.80731C9.49605 7.93497 9.48196 8.06267 9.45685 8.18904C9.37011 8.62547 9.15593 9.02638 8.84136 9.34109L8.695 9.48753V9.48788ZM5.65895 9.34112L6.771 10.4532L5.65864 9.34109C5.34408 9.02638 5.12989 8.62547 5.04316 8.18904C5.01436 8.04413 5.00004 7.89747 5 7.75114C5.00006 7.89748 5.0144 8.04415 5.04322 8.18906C5.13002 8.62551 5.34429 9.02642 5.65893 9.3411L5.65895 9.34112ZM2.75 3.50006C2.6837 3.50006 2.62011 3.47372 2.57322 3.42684C2.52634 3.37996 2.5 3.31637 2.5 3.25006C2.5 3.18376 2.52634 3.12017 2.57322 3.07329C2.62011 3.0264 2.6837 3.00006 2.75 3.00006C2.81631 3.00006 2.87989 3.0264 2.92678 3.07329C2.97366 3.12017 3 3.18376 3 3.25006C3 3.31637 2.97366 3.37996 2.92678 3.42684C2.87989 3.47372 2.81631 3.50006 2.75 3.50006ZM7.25 8.00006C7.1837 8.00006 7.12011 7.97372 7.07322 7.92684C7.02634 7.87996 7 7.81637 7 7.75006C7 7.68376 7.02634 7.62017 7.07322 7.57329C7.12011 7.5264 7.1837 7.50006 7.25 7.50006C7.31631 7.50006 7.37989 7.5264 7.42678 7.57329C7.47366 7.62017 7.5 7.68376 7.5 7.75006C7.5 7.81637 7.47366 7.87996 7.42678 7.92684C7.37989 7.97372 7.3163 8.00006 7.25 8.00006Z" stroke="var(--darkBlue)" />
                                                        </svg>
                                                        <p className='flex-item sub-txt-title'>Distance</p>
                                                      </div>
                                                      <p className='flex-item sub-txt-value'>{(exercise.parameter.distance && exercise.parameter.distance.value) ? exercise.parameter.distance.value : 0} {(exercise.parameter.distance && exercise.parameter.distance.unit) ? exercise.parameter.distance.unit : "Km"}</p>
                                                    </div>,
                                                    (exercise.parameter.unit == "number") && <div className='d-flex m-t-12'>
                                                      <div className='d-flex' style={{ width: "120px" }}>
                                                        <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                          <path d="M1.20041 2.6999C1.20041 2.62034 1.23202 2.54403 1.28828 2.48777C1.34454 2.43151 1.42084 2.3999 1.50041 2.3999H10.5004C10.58 2.3999 10.6563 2.43151 10.7125 2.48777C10.7688 2.54403 10.8004 2.62034 10.8004 2.6999C10.8004 2.77947 10.7688 2.85577 10.7125 2.91203C10.6563 2.9683 10.58 2.9999 10.5004 2.9999H1.50041C1.42084 2.9999 1.34454 2.9683 1.28828 2.91203C1.23202 2.85577 1.20041 2.77947 1.20041 2.6999ZM1.20041 5.6999C1.20041 5.62034 1.23202 5.54403 1.28828 5.48777C1.34454 5.43151 1.42084 5.3999 1.50041 5.3999H10.5004C10.58 5.3999 10.6563 5.43151 10.7125 5.48777C10.7688 5.54403 10.8004 5.62034 10.8004 5.6999C10.8004 5.77947 10.7688 5.85577 10.7125 5.91203C10.6563 5.9683 10.58 5.9999 10.5004 5.9999H1.50041C1.42084 5.9999 1.34454 5.9683 1.28828 5.91203C1.23202 5.85577 1.20041 5.77947 1.20041 5.6999ZM4.55321 7.7999C4.18541 7.7999 3.89741 8.1329 3.89741 8.4815C3.89741 8.56107 3.8658 8.63737 3.80954 8.69363C3.75328 8.7499 3.67697 8.7815 3.59741 8.7815C3.51784 8.7815 3.44154 8.7499 3.38528 8.69363C3.32902 8.63737 3.29741 8.56107 3.29741 8.4815C3.29741 7.8491 3.80861 7.1999 4.55321 7.1999C4.99121 7.1999 5.41061 7.4057 5.64341 7.7663C5.88581 8.1407 5.89661 8.6315 5.60921 9.1241C5.46281 9.3743 5.26121 9.5651 5.06081 9.7241C4.96121 9.8039 4.85741 9.8777 4.75901 9.9479L4.71701 9.9779C4.63241 10.0379 4.55261 10.0943 4.47521 10.1525C4.21181 10.3523 4.02101 10.5413 3.94061 10.7999H5.49641C5.57597 10.7999 5.65228 10.8315 5.70854 10.8878C5.7648 10.944 5.79641 11.0203 5.79641 11.0999C5.79641 11.1795 5.7648 11.2558 5.70854 11.312C5.65228 11.3683 5.57597 11.3999 5.49641 11.3999H3.59681C3.51724 11.3999 3.44094 11.3683 3.38468 11.312C3.32842 11.2558 3.29681 11.1795 3.29681 11.0999C3.29681 10.3829 3.71141 9.9779 4.11281 9.6743C4.19801 9.6101 4.28621 9.5471 4.37021 9.4883L4.41101 9.4583C4.50881 9.3893 4.60061 9.3227 4.68701 9.2543C4.86101 9.1163 4.99781 8.9801 5.09021 8.8211C5.28101 8.4959 5.24141 8.2499 5.13941 8.0927C5.02841 7.9211 4.81001 7.7999 4.55261 7.7999H4.55321ZM7.24301 7.9619C7.16101 8.03544 7.10116 8.1304 7.07021 8.2361C7.05962 8.27418 7.0416 8.3098 7.0172 8.34089C6.9928 8.37199 6.96249 8.39796 6.92802 8.41731C6.89356 8.43666 6.8556 8.449 6.81635 8.45363C6.77709 8.45827 6.73731 8.4551 6.69928 8.44431C6.66126 8.43352 6.62574 8.41532 6.59477 8.39075C6.5638 8.36619 6.53799 8.33575 6.51882 8.30118C6.49965 8.26661 6.4875 8.2286 6.48307 8.18932C6.47864 8.15004 6.48202 8.11027 6.49301 8.0723C6.53861 7.9109 6.64181 7.6925 6.84461 7.5125C7.05341 7.3277 7.34921 7.1999 7.74521 7.1999C8.55161 7.1999 9.00941 7.7903 9.00941 8.3183C9.00941 8.5295 8.96861 8.8541 8.75081 9.1301C8.70761 9.1841 8.65901 9.2351 8.60501 9.2813C8.68601 9.3413 8.76221 9.4157 8.82641 9.5063C8.94401 9.6725 9.00941 9.8777 9.00941 10.1183C9.00941 10.5563 8.86301 10.8923 8.60261 11.1143C8.35061 11.3273 8.03261 11.3999 7.74521 11.3999C7.47401 11.3999 7.20941 11.3543 6.98201 11.2097C6.74921 11.0615 6.59261 10.8329 6.49601 10.5389C6.48376 10.5014 6.479 10.4619 6.48202 10.4226C6.48504 10.3833 6.49577 10.345 6.5136 10.3098C6.53143 10.2747 6.55601 10.2434 6.58593 10.2177C6.61586 10.1921 6.65054 10.1726 6.68801 10.1603C6.72547 10.1481 6.76499 10.1433 6.80429 10.1463C6.84359 10.1493 6.88192 10.1601 6.91707 10.1779C6.95223 10.1957 6.98353 10.2203 7.00919 10.2502C7.03484 10.2801 7.05436 10.3148 7.06661 10.3523C7.13081 10.5485 7.21541 10.6475 7.30421 10.7039C7.39841 10.7639 7.53461 10.7999 7.74521 10.7999C7.94081 10.7999 8.10401 10.7495 8.21381 10.6559C8.31521 10.5707 8.40941 10.4159 8.40941 10.1183C8.41417 10.0244 8.38873 9.93147 8.33681 9.8531C8.28738 9.78786 8.22183 9.73658 8.14661 9.7043C7.96841 9.6203 7.74101 9.5999 7.58501 9.5999C7.50544 9.5999 7.42914 9.5683 7.37288 9.51203C7.31662 9.45577 7.28501 9.37947 7.28501 9.2999C7.28501 9.22034 7.31662 9.14403 7.37288 9.08777C7.42914 9.03151 7.50544 8.9999 7.58501 8.9999C8.00801 8.9999 8.19161 8.8697 8.27981 8.7581C8.37881 8.6333 8.40941 8.4665 8.40941 8.3183C8.40941 8.1257 8.22461 7.7999 7.74521 7.7999C7.48721 7.7999 7.33541 7.8797 7.24301 7.9619ZM1.80701 8.6189C1.65492 8.78467 1.48396 8.93207 1.29761 9.0581C1.26495 9.08143 1.22794 9.09797 1.18878 9.10673C1.14962 9.1155 1.10909 9.11632 1.06961 9.10915C1.03012 9.10197 0.992474 9.08695 0.958898 9.06496C0.925323 9.04297 0.8965 9.01447 0.874136 8.98115C0.851772 8.94783 0.836323 8.91035 0.828701 8.87095C0.82108 8.83155 0.821442 8.79102 0.829766 8.75175C0.83809 8.71249 0.854207 8.6753 0.877163 8.64238C0.900119 8.60946 0.929446 8.58148 0.963409 8.5601C1.40321 8.2655 1.73681 7.7921 1.81421 7.4363C1.81421 7.4363 1.88021 7.1999 2.09021 7.1999C2.39141 7.1999 2.40761 7.4999 2.40761 7.4999V11.0999C2.40761 11.1795 2.376 11.2558 2.31974 11.312C2.26348 11.3683 2.18717 11.3999 2.10761 11.3999C2.02804 11.3999 1.95174 11.3683 1.89548 11.312C1.83922 11.2558 1.80761 11.1795 1.80761 11.0999V8.6189H1.80701ZM9.60041 8.6999C9.60041 8.62034 9.63202 8.54403 9.68828 8.48777C9.74454 8.43151 9.82084 8.3999 9.90041 8.3999H10.5004C10.58 8.3999 10.6563 8.43151 10.7125 8.48777C10.7688 8.54403 10.8004 8.62034 10.8004 8.6999C10.8004 8.77947 10.7688 8.85577 10.7125 8.91203C10.6563 8.9683 10.58 8.9999 10.5004 8.9999H9.90041C9.82084 8.9999 9.74454 8.9683 9.68828 8.91203C9.63202 8.85577 9.60041 8.77947 9.60041 8.6999Z" fill="var(--darkBlue)" />
                                                        </svg>
                                                        <p className='flex-item sub-txt-title'>Count</p>
                                                      </div>
                                                      <p className='flex-item sub-txt-value'>{exercise.parameter.count ? exercise.parameter.count : 0}</p>
                                                    </div>,
                                                    (exercise.parameter.unit == "time") && <div className='d-flex m-t-12'>
                                                    <div className='d-flex' style={{ width: "120px" }}>
                                                      <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_683_1515)">
                                                          <path d="M6 11.25C4.96165 11.25 3.94662 10.9421 3.08326 10.3652C2.2199 9.78834 1.54699 8.9684 1.14963 8.00909C0.752275 7.04978 0.648307 5.99418 0.85088 4.97578C1.05345 3.95738 1.55347 3.02192 2.28769 2.28769C3.02192 1.55347 3.95738 1.05345 4.97578 0.85088C5.99418 0.648307 7.04978 0.752275 8.00909 1.14963C8.9684 1.54699 9.78834 2.2199 10.3652 3.08326C10.9421 3.94662 11.25 4.96165 11.25 6C11.25 7.39239 10.6969 8.72775 9.71231 9.71231C8.72775 10.6969 7.39239 11.25 6 11.25ZM6 1.5C5.10999 1.5 4.23996 1.76392 3.49994 2.25839C2.75992 2.75286 2.18314 3.45566 1.84254 4.27793C1.50195 5.10019 1.41284 6.00499 1.58647 6.87791C1.7601 7.75082 2.18869 8.55265 2.81802 9.18198C3.44736 9.81132 4.24918 10.2399 5.1221 10.4135C5.99501 10.5872 6.89981 10.4981 7.72208 10.1575C8.54434 9.81686 9.24715 9.24009 9.74162 8.50007C10.2361 7.76005 10.5 6.89002 10.5 6C10.5 4.80653 10.0259 3.66194 9.18198 2.81802C8.33807 1.97411 7.19348 1.5 6 1.5Z" fill="var(--darkBlue)" />
                                                          <path d="M7.72125 8.25L5.625 6.15375V2.625H6.375V5.8425L8.25 7.72125L7.72125 8.25Z" fill="var(--darkBlue)" />
                                                        </g>
                                                        <defs>
                                                          <clipPath id="clip0_683_1515">
                                                            <rect width="12" height="12" fill="white" />
                                                          </clipPath>
                                                        </defs>
                                                      </svg>
                                                      <p className='flex-item sub-txt-title'>Duration</p>
                                                    </div>
                                                    <p className='flex-item sub-txt-value'>{(exercise.parameter.duration && exercise.parameter.duration.hour) ? exercise.parameter.duration.hour : 0} hr {(exercise.parameter.duration && exercise.parameter.duration.min) ? exercise.parameter.duration.min : 0} min</p>
                                                  </div>
                                                ]
                                              }
                                              {
                                                (selectedExerciseIndex > -1 && selectedExerciseIndex == index && exercise.content && exercise.content._id) && [
                                                  <div className='exercise-container-saperator' />,
                                                  exercise.optionalExercises && exercise.optionalExercises.length > 0 && <p className='m-b-8 fs-18' style={{
                                                    fontWeight: 'bold'
                                                  }}>Optional</p>,
                                                  exercise.optionalExercises && exercise.optionalExercises.map((optionalExercise, opindex) => {
                                                    return [
                                                      <div className='d-flex w-full space-between m-b-16' onClick={e => {
                                                        toggleWeekDayDropdown(index, opindex)
                                                        e.stopPropagation()
                                                      }}>
                                                        <div className='d-flex' style={{ width: "80%" }}>
                                                          <svg style={{
                                                            transform: optionalExercise.isDropdownOpen ? "rotate(0deg)" : "rotate(180deg)"
                                                          }} className='flex-item m-r-12' width="16" height="11" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M1.00098 1L6.50098 6.5L12.501 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                                          </svg>
                                                          <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{(optionalExercise.content && optionalExercise.content._id) ? optionalExercise.content.name : "Select Exercise"}</p>
                                                          <svg className='m-l-16 m-t-4' width="16" height="16" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <circle cx="5" cy="5" r="5" transform="matrix(1 0 0 -1 0 10)" fill={(optionalExercise.content && optionalExercise.content._id) ? "#5d883c" : "#E0E0E0"} />
                                                            <path d="M2.60587 6.10396L4.15165 7.43789L7.60778 2.95203" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                                          </svg>
                                                        </div>
                                                        <div className='d-flex'>
                                                          {
                                                            optionalExercise.content && optionalExercise.content._id && [
                                                              <div onClick={toggleVideoPlayer.bind(this, optionalExercise.content)} className='d-flex planner-play-exercise m-r-20'>
                                                                <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                  <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                                                </svg>
                                                              </div>,
                                                              <svg onClick={toggleExerciseContentManageWindow(opindex, optionalExercise.content)} className='flex-item m-r-20' width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9.64578 1.57491C9.82726 1.38764 10.0442 1.23834 10.2839 1.1357C10.5237 1.03307 10.7814 0.979162 11.0422 0.977112C11.303 0.975061 11.5615 1.02491 11.8028 1.12376C12.0442 1.22261 12.2634 1.36848 12.4478 1.55288C12.6322 1.73728 12.7781 1.95652 12.8769 2.19784C12.9758 2.43916 13.0256 2.69774 13.0236 2.95851C13.0215 3.21928 12.9676 3.47704 12.865 3.71678C12.7624 3.95651 12.6131 4.17344 12.4258 4.35491L11.6558 5.12491L8.87578 2.34491L9.64578 1.57491V1.57491ZM8.34578 2.87491L2.25228 8.96841C2.03228 9.18841 1.87228 9.46141 1.78828 9.76141L1.01478 12.5239C0.996907 12.588 0.996382 12.6556 1.01326 12.7199C1.03013 12.7842 1.0638 12.8429 1.11081 12.8899C1.15782 12.9369 1.21649 12.9706 1.2808 12.9874C1.3451 13.0043 1.41274 13.0038 1.47678 12.9859L4.23878 12.2124C4.53875 12.1285 4.81203 11.9687 5.03228 11.7484L11.1263 5.65541L8.34628 2.87541L8.34578 2.87491Z" fill="var(--darkBlue)" />
                                                              </svg>
                                                            ]
                                                          }


                                                          {
                                                            optionalExercise.content && !optionalExercise.content._id && (
                                                              <div onClick={toggleExerciseContentManageWindow(opindex, {})} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-r-20" style={{ width: "100px", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                                                <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">Add</p>
                                                              </div>
                                                            )
                                                          }

                                                          <svg onClick={handleRemoveOptionalWeekDayExercise(opindex)} className='flex-item m-l-20' width="30" height="30" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <rect x="5.49805" y="6.90308" width="2" height="15" rx="1" transform="rotate(-45 5.49805 6.90308)" fill="#6D6D6D" />
                                                            <rect x="16.0518" y="5.4502" width="2" height="15" rx="1" transform="rotate(44.5058 16.0518 5.4502)" fill="#6D6D6D" />
                                                          </svg>
                                                        </div>
                                                      </div>,
                                                      (optionalExercise.isDropdownOpen && optionalExercise.parameter && optionalExercise.parameter.isParameterAdded) && [
                                                        optionalExercise.parameter && optionalExercise.parameter.unit == "weight" && [
                                                          <div className='d-flex m-t-12 m-b-12'>
                                                            <div className='d-flex' style={{ width: "120px" }}>
                                                              <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_683_1507)">
                                                                  <path d="M10.5 10.5V2.25H7.5V10.5H6V5.25H3V10.5H1.5V0.75H0.75V10.5C0.75 10.6989 0.829018 10.8897 0.96967 11.0303C1.11032 11.171 1.30109 11.25 1.5 11.25H11.25V10.5H10.5ZM8.25 3H9.75V6.75H8.25V3ZM3.75 6H5.25V8.25H3.75V6Z" fill="var(--darkBlue)" />
                                                                </g>
                                                                <defs>
                                                                  <clipPath id="clip0_683_1507">
                                                                    <rect width="12" height="12" fill="white" />
                                                                  </clipPath>
                                                                </defs>
                                                              </svg>
                                                              <p className='flex-item sub-txt-title'>Set</p>
                                                            </div>
                                                            <p className='flex-item sub-txt-value'>{optionalExercise.parameter.set ? optionalExercise.parameter.set.length : 0}</p>
                                                          </div>],
                                                        optionalExercise.parameter.unit == "distance" && <div className='d-flex m-t-12 m-b-14'>
                                                          <div className='d-flex' style={{ width: "120px" }}>
                                                            <svg className='flex-item m-r-8 svg-fill' width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path d="M4.34105 4.84112L4.34107 4.8411C4.65572 4.52642 4.86999 4.12551 4.95679 3.68906C4.98559 3.54423 4.99993 3.39764 5 3.25139C4.99998 3.3978 4.98566 3.54455 4.95685 3.68954C4.87012 4.12593 4.65597 4.52681 4.34145 4.84151C4.34142 4.84154 4.34139 4.84157 4.34137 4.84159L2.75041 6.43255L2.75002 6.43215L3.10355 6.07862L4.34105 4.84112ZM2.39645 6.07862L2.68855 6.37072L1.15864 4.84159C1.15861 4.84157 1.15858 4.84154 1.15855 4.84151C1.15852 4.84148 1.15849 4.84145 1.15846 4.84142C0.843996 4.52674 0.629872 4.12589 0.543157 3.68954C0.514343 3.54455 0.500027 3.3978 0.500001 3.25139C0.500078 3.39764 0.514415 3.54423 0.543218 3.68906C0.630016 4.12551 0.844285 4.52642 1.15893 4.8411L1.15895 4.84112L2.39645 6.07862ZM8.695 9.48788L7.31336 10.8688L7.60355 10.5786L8.84105 9.34112L8.84107 9.3411C9.15572 9.02642 9.36999 8.62551 9.45679 8.18906C9.48192 8.06268 9.49604 7.93497 9.49928 7.80731C9.49605 7.93497 9.48196 8.06267 9.45685 8.18904C9.37011 8.62547 9.15593 9.02638 8.84136 9.34109L8.695 9.48753V9.48788ZM5.65895 9.34112L6.771 10.4532L5.65864 9.34109C5.34408 9.02638 5.12989 8.62547 5.04316 8.18904C5.01436 8.04413 5.00004 7.89747 5 7.75114C5.00006 7.89748 5.0144 8.04415 5.04322 8.18906C5.13002 8.62551 5.34429 9.02642 5.65893 9.3411L5.65895 9.34112ZM2.75 3.50006C2.6837 3.50006 2.62011 3.47372 2.57322 3.42684C2.52634 3.37996 2.5 3.31637 2.5 3.25006C2.5 3.18376 2.52634 3.12017 2.57322 3.07329C2.62011 3.0264 2.6837 3.00006 2.75 3.00006C2.81631 3.00006 2.87989 3.0264 2.92678 3.07329C2.97366 3.12017 3 3.18376 3 3.25006C3 3.31637 2.97366 3.37996 2.92678 3.42684C2.87989 3.47372 2.81631 3.50006 2.75 3.50006ZM7.25 8.00006C7.1837 8.00006 7.12011 7.97372 7.07322 7.92684C7.02634 7.87996 7 7.81637 7 7.75006C7 7.68376 7.02634 7.62017 7.07322 7.57329C7.12011 7.5264 7.1837 7.50006 7.25 7.50006C7.31631 7.50006 7.37989 7.5264 7.42678 7.57329C7.47366 7.62017 7.5 7.68376 7.5 7.75006C7.5 7.81637 7.47366 7.87996 7.42678 7.92684C7.37989 7.97372 7.3163 8.00006 7.25 8.00006Z" stroke="var(--darkBlue)" />
                                                            </svg>
                                                            <p className='flex-item sub-txt-title'>Distance</p>
                                                          </div>
                                                          <p className='flex-item sub-txt-value'>{optionalExercise.parameter.distance.value ? optionalExercise.parameter.distance.value : 0} {optionalExercise.parameter.distance.unit ? optionalExercise.parameter.distance.unit : "KM"}</p>
                                                        </div>,
                                                        optionalExercise.parameter.unit == "number" && <div className='d-flex m-t-12 m-b-14'>
                                                          <div className='d-flex' style={{ width: "120px" }}>
                                                            <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <path d="M1.20041 2.6999C1.20041 2.62034 1.23202 2.54403 1.28828 2.48777C1.34454 2.43151 1.42084 2.3999 1.50041 2.3999H10.5004C10.58 2.3999 10.6563 2.43151 10.7125 2.48777C10.7688 2.54403 10.8004 2.62034 10.8004 2.6999C10.8004 2.77947 10.7688 2.85577 10.7125 2.91203C10.6563 2.9683 10.58 2.9999 10.5004 2.9999H1.50041C1.42084 2.9999 1.34454 2.9683 1.28828 2.91203C1.23202 2.85577 1.20041 2.77947 1.20041 2.6999ZM1.20041 5.6999C1.20041 5.62034 1.23202 5.54403 1.28828 5.48777C1.34454 5.43151 1.42084 5.3999 1.50041 5.3999H10.5004C10.58 5.3999 10.6563 5.43151 10.7125 5.48777C10.7688 5.54403 10.8004 5.62034 10.8004 5.6999C10.8004 5.77947 10.7688 5.85577 10.7125 5.91203C10.6563 5.9683 10.58 5.9999 10.5004 5.9999H1.50041C1.42084 5.9999 1.34454 5.9683 1.28828 5.91203C1.23202 5.85577 1.20041 5.77947 1.20041 5.6999ZM4.55321 7.7999C4.18541 7.7999 3.89741 8.1329 3.89741 8.4815C3.89741 8.56107 3.8658 8.63737 3.80954 8.69363C3.75328 8.7499 3.67697 8.7815 3.59741 8.7815C3.51784 8.7815 3.44154 8.7499 3.38528 8.69363C3.32902 8.63737 3.29741 8.56107 3.29741 8.4815C3.29741 7.8491 3.80861 7.1999 4.55321 7.1999C4.99121 7.1999 5.41061 7.4057 5.64341 7.7663C5.88581 8.1407 5.89661 8.6315 5.60921 9.1241C5.46281 9.3743 5.26121 9.5651 5.06081 9.7241C4.96121 9.8039 4.85741 9.8777 4.75901 9.9479L4.71701 9.9779C4.63241 10.0379 4.55261 10.0943 4.47521 10.1525C4.21181 10.3523 4.02101 10.5413 3.94061 10.7999H5.49641C5.57597 10.7999 5.65228 10.8315 5.70854 10.8878C5.7648 10.944 5.79641 11.0203 5.79641 11.0999C5.79641 11.1795 5.7648 11.2558 5.70854 11.312C5.65228 11.3683 5.57597 11.3999 5.49641 11.3999H3.59681C3.51724 11.3999 3.44094 11.3683 3.38468 11.312C3.32842 11.2558 3.29681 11.1795 3.29681 11.0999C3.29681 10.3829 3.71141 9.9779 4.11281 9.6743C4.19801 9.6101 4.28621 9.5471 4.37021 9.4883L4.41101 9.4583C4.50881 9.3893 4.60061 9.3227 4.68701 9.2543C4.86101 9.1163 4.99781 8.9801 5.09021 8.8211C5.28101 8.4959 5.24141 8.2499 5.13941 8.0927C5.02841 7.9211 4.81001 7.7999 4.55261 7.7999H4.55321ZM7.24301 7.9619C7.16101 8.03544 7.10116 8.1304 7.07021 8.2361C7.05962 8.27418 7.0416 8.3098 7.0172 8.34089C6.9928 8.37199 6.96249 8.39796 6.92802 8.41731C6.89356 8.43666 6.8556 8.449 6.81635 8.45363C6.77709 8.45827 6.73731 8.4551 6.69928 8.44431C6.66126 8.43352 6.62574 8.41532 6.59477 8.39075C6.5638 8.36619 6.53799 8.33575 6.51882 8.30118C6.49965 8.26661 6.4875 8.2286 6.48307 8.18932C6.47864 8.15004 6.48202 8.11027 6.49301 8.0723C6.53861 7.9109 6.64181 7.6925 6.84461 7.5125C7.05341 7.3277 7.34921 7.1999 7.74521 7.1999C8.55161 7.1999 9.00941 7.7903 9.00941 8.3183C9.00941 8.5295 8.96861 8.8541 8.75081 9.1301C8.70761 9.1841 8.65901 9.2351 8.60501 9.2813C8.68601 9.3413 8.76221 9.4157 8.82641 9.5063C8.94401 9.6725 9.00941 9.8777 9.00941 10.1183C9.00941 10.5563 8.86301 10.8923 8.60261 11.1143C8.35061 11.3273 8.03261 11.3999 7.74521 11.3999C7.47401 11.3999 7.20941 11.3543 6.98201 11.2097C6.74921 11.0615 6.59261 10.8329 6.49601 10.5389C6.48376 10.5014 6.479 10.4619 6.48202 10.4226C6.48504 10.3833 6.49577 10.345 6.5136 10.3098C6.53143 10.2747 6.55601 10.2434 6.58593 10.2177C6.61586 10.1921 6.65054 10.1726 6.68801 10.1603C6.72547 10.1481 6.76499 10.1433 6.80429 10.1463C6.84359 10.1493 6.88192 10.1601 6.91707 10.1779C6.95223 10.1957 6.98353 10.2203 7.00919 10.2502C7.03484 10.2801 7.05436 10.3148 7.06661 10.3523C7.13081 10.5485 7.21541 10.6475 7.30421 10.7039C7.39841 10.7639 7.53461 10.7999 7.74521 10.7999C7.94081 10.7999 8.10401 10.7495 8.21381 10.6559C8.31521 10.5707 8.40941 10.4159 8.40941 10.1183C8.41417 10.0244 8.38873 9.93147 8.33681 9.8531C8.28738 9.78786 8.22183 9.73658 8.14661 9.7043C7.96841 9.6203 7.74101 9.5999 7.58501 9.5999C7.50544 9.5999 7.42914 9.5683 7.37288 9.51203C7.31662 9.45577 7.28501 9.37947 7.28501 9.2999C7.28501 9.22034 7.31662 9.14403 7.37288 9.08777C7.42914 9.03151 7.50544 8.9999 7.58501 8.9999C8.00801 8.9999 8.19161 8.8697 8.27981 8.7581C8.37881 8.6333 8.40941 8.4665 8.40941 8.3183C8.40941 8.1257 8.22461 7.7999 7.74521 7.7999C7.48721 7.7999 7.33541 7.8797 7.24301 7.9619ZM1.80701 8.6189C1.65492 8.78467 1.48396 8.93207 1.29761 9.0581C1.26495 9.08143 1.22794 9.09797 1.18878 9.10673C1.14962 9.1155 1.10909 9.11632 1.06961 9.10915C1.03012 9.10197 0.992474 9.08695 0.958898 9.06496C0.925323 9.04297 0.8965 9.01447 0.874136 8.98115C0.851772 8.94783 0.836323 8.91035 0.828701 8.87095C0.82108 8.83155 0.821442 8.79102 0.829766 8.75175C0.83809 8.71249 0.854207 8.6753 0.877163 8.64238C0.900119 8.60946 0.929446 8.58148 0.963409 8.5601C1.40321 8.2655 1.73681 7.7921 1.81421 7.4363C1.81421 7.4363 1.88021 7.1999 2.09021 7.1999C2.39141 7.1999 2.40761 7.4999 2.40761 7.4999V11.0999C2.40761 11.1795 2.376 11.2558 2.31974 11.312C2.26348 11.3683 2.18717 11.3999 2.10761 11.3999C2.02804 11.3999 1.95174 11.3683 1.89548 11.312C1.83922 11.2558 1.80761 11.1795 1.80761 11.0999V8.6189H1.80701ZM9.60041 8.6999C9.60041 8.62034 9.63202 8.54403 9.68828 8.48777C9.74454 8.43151 9.82084 8.3999 9.90041 8.3999H10.5004C10.58 8.3999 10.6563 8.43151 10.7125 8.48777C10.7688 8.54403 10.8004 8.62034 10.8004 8.6999C10.8004 8.77947 10.7688 8.85577 10.7125 8.91203C10.6563 8.9683 10.58 8.9999 10.5004 8.9999H9.90041C9.82084 8.9999 9.74454 8.9683 9.68828 8.91203C9.63202 8.85577 9.60041 8.77947 9.60041 8.6999Z" fill="var(--darkBlue)" />
                                                            </svg>
                                                            <p className='flex-item sub-txt-title'>Count</p>
                                                          </div>
                                                          <p className='flex-item sub-txt-value'>{optionalExercise.parameter.count ? optionalExercise.parameter.count : 0}</p>
                                                        </div>,
                                                        optionalExercise.parameter.unit == "time" && <div className='d-flex m-t-12 m-b-14'>
                                                          <div className='d-flex' style={{ width: "120px" }}>
                                                            <svg className='flex-item m-r-8 svg-fill' width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                              <g clip-path="url(#clip0_683_1515)">
                                                                <path d="M6 11.25C4.96165 11.25 3.94662 10.9421 3.08326 10.3652C2.2199 9.78834 1.54699 8.9684 1.14963 8.00909C0.752275 7.04978 0.648307 5.99418 0.85088 4.97578C1.05345 3.95738 1.55347 3.02192 2.28769 2.28769C3.02192 1.55347 3.95738 1.05345 4.97578 0.85088C5.99418 0.648307 7.04978 0.752275 8.00909 1.14963C8.9684 1.54699 9.78834 2.2199 10.3652 3.08326C10.9421 3.94662 11.25 4.96165 11.25 6C11.25 7.39239 10.6969 8.72775 9.71231 9.71231C8.72775 10.6969 7.39239 11.25 6 11.25ZM6 1.5C5.10999 1.5 4.23996 1.76392 3.49994 2.25839C2.75992 2.75286 2.18314 3.45566 1.84254 4.27793C1.50195 5.10019 1.41284 6.00499 1.58647 6.87791C1.7601 7.75082 2.18869 8.55265 2.81802 9.18198C3.44736 9.81132 4.24918 10.2399 5.1221 10.4135C5.99501 10.5872 6.89981 10.4981 7.72208 10.1575C8.54434 9.81686 9.24715 9.24009 9.74162 8.50007C10.2361 7.76005 10.5 6.89002 10.5 6C10.5 4.80653 10.0259 3.66194 9.18198 2.81802C8.33807 1.97411 7.19348 1.5 6 1.5Z" fill="var(--darkBlue)" />
                                                                <path d="M7.72125 8.25L5.625 6.15375V2.625H6.375V5.8425L8.25 7.72125L7.72125 8.25Z" fill="var(--darkBlue)" />
                                                              </g>
                                                              <defs>
                                                                <clipPath id="clip0_683_1515">
                                                                  <rect width="12" height="12" fill="white" />
                                                                </clipPath>
                                                              </defs>
                                                            </svg>
                                                            <p className='flex-item sub-txt-title'>Duration</p>
                                                          </div>
                                                          <p className='flex-item sub-txt-value'>{optionalExercise.parameter.duration.hour ? optionalExercise.parameter.duration.hour : 0} hr {optionalExercise.parameter.duration.min ? optionalExercise.parameter.duration.min : 0} min</p>
                                                        </div>
                                                      ]
                                                    ]
                                                  }),
                                                  (exercise.optionalExercises && exercise.optionalExercises.length < 2) && <div onClick={handleAddOptionalWeekdayExercise} className="global-button-container d-flex flex-item p-l-20 p-r-20" style={{ width: "fit-content", background: '#055075', boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                                                    <p style={{ color: '#ffffff', fontSize: 14, fontWeight: 600 }} className="flex-item">{exercise.optionalExercises.length == 0 ? "Optional Exercise" : "Add More"}</p>
                                                  </div>
                                                ]
                                              }
                                            </div>
                                          </div>
                                       )}
                                    </Draggable>
                                  )
                                })
                              }
                            </div>
                          )}
                          </Droppable>
                        </DragDropContext>
                      {
                        dayStorage.exercises.length < 30 && (
                          <div onClick={handleAddDayExercises} className="global-button-container d-flex flex-item p-l-12 p-r-12 m-t-20" style={{ width: "160px", background: "#ffffff", boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)" }}>
                            <p className="flex-item">Add More Exercise(s)</p>
                          </div>
                        )
                      }
                    </div>
                  )
                }

                {
                  dayStorage.Days.filter(data => data.isSelected == true).length == 0 && workoutPlanner.weekdays.filter(data => data.dayName.length > 0).length > 0 && (
                    <div className='w-full'>
                      <p p className='fs-16 m-b-8' style={{color:"var(--darkBlue)", fontWeight:"600"}}>Workout Planned</p>
                      {
                        workoutPlanner.weekdays.map(data => {
                          return(
                            <div className='planned-workout-days-container d-flex space-between m-b-14'>
                              <div className='flex-item'>
                                <p className='day-txt m-b-6'>{data.dayName == "Mon" ? "Monday" : data.dayName == "Tue" ? "Tuesday" : data.dayName == "Wed" ? "Wednesday" : data.dayName == "Thu" ? "Thursday" : data.dayName == "Fri" ? "Friday" : data.dayName == "Sat" ? "Saturday" : data.dayName }</p>
                                <p className='day-name m-b-2'>{data.displayName}</p>
                                <p className='total-exercises-txt'>{data.exercises.length} Exercises</p>
                              </div>
                              <div className='d-flex m-t-6' style={{alignSelf:"flex-start"}}>
                                <svg onClick={handleDayRemove(data.dayName)} className='flex-item cursor-pointer m-r-12 global-fill-svg' width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.98857 18C2.48114 18 2.04686 17.8193 1.68571 17.4578C1.32381 17.0971 1.14286 16.6634 1.14286 16.1566V2.02029H0.571429C0.409143 2.02029 0.273524 1.9655 0.164571 1.85593C0.0556191 1.74635 0.000761905 1.61053 0 1.44845C0 1.28713 0.0548572 1.15168 0.164571 1.04211C0.274286 0.933291 0.409905 0.878884 0.571429 0.878884H4.57143C4.57143 0.642993 4.65905 0.43754 4.83429 0.262524C5.00952 0.0875079 5.21524 0 5.45143 0H10.5486C10.7848 0 10.9905 0.0875079 11.1657 0.262524C11.341 0.43754 11.4286 0.642993 11.4286 0.878884H15.4286C15.5909 0.878884 15.7265 0.933672 15.8354 1.04325C15.9451 1.15282 16 1.28865 16 1.45073C16 1.61205 15.9451 1.7475 15.8354 1.85707C15.7265 1.96588 15.5909 2.02029 15.4286 2.02029H14.8571V16.1566C14.8571 16.6634 14.6762 17.0971 14.3143 17.4578C13.9531 17.8193 13.5189 18 13.0114 18H2.98857ZM13.7143 2.02029H2.28571V16.1566C2.28571 16.3613 2.35162 16.5295 2.48343 16.6611C2.61524 16.7928 2.78362 16.8586 2.98857 16.8586H13.0114C13.2164 16.8586 13.3848 16.7928 13.5166 16.6611C13.6484 16.5295 13.7143 16.3613 13.7143 16.1566V2.02029ZM6.06629 14.5758C6.22857 14.5758 6.36419 14.521 6.47314 14.4114C6.58286 14.3018 6.63771 14.1664 6.63771 14.0051V4.87381C6.63771 4.71173 6.58286 4.57628 6.47314 4.46747C6.36343 4.35866 6.22743 4.30387 6.06514 4.30311C5.90286 4.30311 5.76724 4.35789 5.65829 4.46747C5.54933 4.57705 5.49486 4.71249 5.49486 4.87381V14.0051C5.49486 14.1672 5.54971 14.3026 5.65943 14.4114C5.76914 14.5202 5.90476 14.575 6.06629 14.5758ZM9.93486 14.5758C10.0971 14.5758 10.2328 14.521 10.3417 14.4114C10.4507 14.3018 10.5051 14.1664 10.5051 14.0051V4.87381C10.5051 4.71173 10.4503 4.57628 10.3406 4.46747C10.2309 4.35866 10.0952 4.30387 9.93372 4.30311C9.77143 4.30311 9.63581 4.35789 9.52686 4.46747C9.41714 4.57705 9.36229 4.71249 9.36229 4.87381V14.0051C9.36229 14.1672 9.41714 14.3026 9.52686 14.4114C9.63657 14.5202 9.77257 14.575 9.93486 14.5758Z" fill="#9a9a9a"/>
                                </svg>
                                <svg onClick={()=>handleSelectPlannerDay("workout", data.dayName,true)} className='flex-item cursor-pointer m-r-12 global-fill-svg' width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M16.1845 0.815819C15.9259 0.557174 15.6189 0.352005 15.2809 0.212026C14.943 0.0720466 14.5808 0 14.2151 0C13.8493 0 13.4871 0.0720466 13.1492 0.212026C12.8113 0.352005 12.5042 0.557174 12.2456 0.815819L1.77261 11.2893C1.46096 11.601 1.2343 11.9877 1.1153 12.4127L0.0195523 16.326C-0.00576464 16.4167 -0.00650882 16.5125 0.0173963 16.6036C0.0413014 16.6947 0.0889962 16.7778 0.155594 16.8444C0.222191 16.911 0.305297 16.9587 0.396395 16.9826C0.487494 17.0065 0.583311 17.0058 0.674027 16.9804L4.58671 15.8847C5.01165 15.7658 5.39879 15.5394 5.71079 15.2274L16.1845 4.75392C16.7067 4.23165 17 3.52338 17 2.78487C17 2.04636 16.7067 1.33809 16.1845 0.815819ZM12.9971 1.56661C13.3202 1.2436 13.7584 1.06217 14.2153 1.06224C14.6722 1.0623 15.1103 1.24386 15.4334 1.56696C15.7564 1.89007 15.9378 2.32825 15.9377 2.78512C15.9377 3.24199 15.7561 3.68012 15.433 4.00313L14.3422 5.09319L11.9063 2.65667L12.9971 1.56661ZM11.1555 3.40817L13.5921 5.84469L4.95928 14.4766C4.77643 14.6595 4.54957 14.7922 4.30056 14.8619L1.29663 15.7027L2.13739 12.6995C2.20725 12.4506 2.33994 12.2237 2.52271 12.0408L11.1555 3.40817Z" fill="#9a9a9a"/>
                                </svg>
                                <svg onClick={() => handleDayWorkoutCopyTo(data.dayName)} className='flex-item cursor-pointer global-stroke-svg' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12.25 4.375C12.25 3.3265 12.25 2.80225 12.079 2.38938C11.9659 2.1162 11.8001 1.868 11.5911 1.65894C11.382 1.44988 11.1338 1.28408 10.8606 1.171C10.4478 1 9.9235 1 8.875 1H5.5C3.37825 1 2.3185 1 1.65925 1.65925C1 2.3185 1 3.37825 1 5.5V8.875C1 9.9235 1 10.4478 1.171 10.8606C1.28408 11.1338 1.44988 11.382 1.65894 11.5911C1.868 11.8001 2.1162 11.9659 2.38938 12.079C2.80225 12.25 3.3265 12.25 4.375 12.25" stroke="#9a9a9a"/>
                                  <path d="M16.75 7.75H10C8.75736 7.75 7.75 8.75736 7.75 10V16.75C7.75 17.9926 8.75736 19 10 19H16.75C17.9926 19 19 17.9926 19 16.75V10C19 8.75736 17.9926 7.75 16.75 7.75Z" stroke="#9a9a9a"/>
                                </svg>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  )
                }
              </div>,
              <div className='bottom-action-button'>
                <div className='d-flex'>
                  <div className='d-flex flex-item' style={{margin: "0 0 0 auto"}}>
                    {
                      dayStorage.Days.filter(data => data.isSelected == true).length == 0 && workoutPlanner.weekdays.length == 0 && (
                        <div onClick={toggleBackToPrevWindow} className={`member-button-global btn-center d-flex`} style={{background:"#f2f2f2", width:"200px"}}>
                          <p className='flex-item fs-16' style={{ fontWeight: 700 }}>Cancel</p>
                        </div>
                      )
                    }
                    {
                      dayStorage.Days.filter(data => data.isSelected == true).length == 0 && workoutPlanner.weekdays.length > 0 && (
                        <div onClick={toggleBackToPrevWindow} className={`member-button-global btn-center d-flex`} style={{width:"200px"}}>
                          <p className='flex-item fs-16' style={{ fontWeight: 700 }}>Done</p>
                        </div>
                      )
                    }
                    {
                      dayStorage.Days.filter(data => data.isSelected == true).length > 0 && (
                        <div onClick={handleRevertExercises} className={`member-button-global btn-center d-flex`} style={{background:"#f2f2f2", width:"200px"}}>
                          <p className='flex-item fs-16' style={{ fontWeight: 700 }}>Cancel</p>
                        </div>
                      )
                    }
                    {
                      dayStorage.displayName && dayStorage.exercises.length > 0 && dayStorage.exercises[0].content && dayStorage.exercises[0].content._id && dayStorage.Days.filter(data => data.isSelected == true).length > 0 && [
                        <div className='m-l-12'/>,
                        <div onClick={handleAddWorkouts} className={`member-button-global btn-center d-flex`} style={{width:"auto"}}>
                          <p className='flex-item fs-16 d-flex' style={{ fontWeight: 700, color:"#E33A34", whiteSpace:"nowrap" }}><span className='p-r-6'>{isEditActive?"Update":"Add Workout to"}</span>{handleSelectedDays("long")} {dayStorage.Days[5].isSelected && "Sat"} {isEditActive&&' Workout'}</p>
                        </div>
                      ]
                    }
                    {/* {
                      workoutPlanner.weekdays.length > 0 && workoutPlanner.weekdays[selectedWeekDay].exercises && workoutPlanner.weekdays[selectedWeekDay].exercises.length > 0 && workoutPlanner.weekdays[selectedWeekDay].exercises[0].content && workoutPlanner.weekdays[selectedWeekDay].exercises[0].content._id && [
                        <div className='m-l-12'/>,
                        <div onClick={toggleBackToPrevWindow.bind(this)} className={`member-button-global btn-center d-flex`}>
                          <p className='flex-item fs-16' style={{ fontWeight: 600, whiteSpace:"nowrap" }}>Save & Continue</p>
                        </div>
                      ]
                    } */}
                  </div>
                </div>
              </div>
            ]
          }
          {
            (currentWindow == "weekdays-exercise" || currentWindow == "selected-nutrition-content") && copyFrom.length > 0 && (
              <div onClick={() => handleDayWorkoutCopyTo("")} className='day-copy-to-modal d-flex'>
                <div onClick={e => e.stopPropagation()} className='day-copy-to-container flex-item'>
                  <div className='d-flex'>
                    <svg className='flex-item m-r-12' width="26" height="33" viewBox="0 0 26 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M25.631 9.73077L16.3548 0.372308C16.1191 0.134213 15.7994 0.000296242 15.4658 0H11.3226C10.0992 0 8.92585 0.490315 8.06076 1.36308C7.19568 2.23585 6.70968 3.41957 6.70968 4.65385V6.76923H4.6129C3.38949 6.76923 2.21617 7.25955 1.35109 8.13231C0.486001 9.00508 0 10.1888 0 11.4231V28.3462C0 29.5804 0.486001 30.7642 1.35109 31.6369C2.21617 32.5097 3.38949 33 4.6129 33H16.3548C17.5783 33 18.7516 32.5097 19.6167 31.6369C20.4817 30.7642 20.9677 29.5804 20.9677 28.3462V26.2308H21.3871C22.6105 26.2308 23.7838 25.7405 24.6489 24.8677C25.514 23.9949 26 22.8112 26 21.5769V10.5769C25.9868 10.2581 25.855 9.95599 25.631 9.73077ZM16.7742 4.33231L21.7058 9.30769H16.7742V4.33231ZM18.4516 28.3462C18.4516 28.9072 18.2307 29.4452 17.8375 29.842C17.4443 30.2387 16.9109 30.4615 16.3548 30.4615H4.6129C4.0568 30.4615 3.52348 30.2387 3.13026 29.842C2.73704 29.4452 2.51613 28.9072 2.51613 28.3462V11.4231C2.51613 10.862 2.73704 10.324 3.13026 9.92727C3.52348 9.53056 4.0568 9.30769 4.6129 9.30769H6.70968V21.5769C6.70968 22.8112 7.19568 23.9949 8.06076 24.8677C8.92585 25.7405 10.0992 26.2308 11.3226 26.2308H18.4516V28.3462ZM21.3871 23.6923H11.3226C10.7665 23.6923 10.2332 23.4694 9.83994 23.0727C9.44672 22.676 9.22581 22.138 9.22581 21.5769V4.65385C9.22581 4.09281 9.44672 3.55475 9.83994 3.15804C10.2332 2.76133 10.7665 2.53846 11.3226 2.53846H14.2581V10.5769C14.2624 10.9122 14.3963 11.2325 14.6313 11.4696C14.8663 11.7066 15.1838 11.8418 15.5161 11.8462H23.4839V21.5769C23.4839 22.138 23.263 22.676 22.8697 23.0727C22.4765 23.4694 21.9432 23.6923 21.3871 23.6923Z" fill="#A9A9A9"/>
                    </svg>
                    <p className='copy-from-txt flex-item'>Copy <span style={{color:"var(--darkBlue)"}}>{copyFrom}</span> workout to</p>
                  </div>
                  <div className='d-flex-wrap m-t-40' style={{justifyContent:"center"}}>
                    {
                      copyTo.map((data, index) => {
                        if(data.day !== copyFrom){
                          return(
                            <div onClick={() => handleCopyTo(index)} className={`${data.isSelected == true ? "day-chips day-chips-active" : "day-chips"} d-flex cursor-pointer m-r-10 m-b-16`} style={{width:"auto", height: "30px", padding: "0 20px"}}>
                              <p className='flex-item'>{data.day}</p>
                            </div>
                          )
                        }
                      })
                    }
                  </div>

                  {
                    copyTo.filter(data => data.isSelected == true).length > 0 && (
                      <div className='d-flex m-t-40'>
                        <div onClick={()=>handlePasteTo()} className={`member-button-global btn-center d-flex p-l-60 p-r-60`} style={{margin:"0 auto"}}>
                          <p className='flex-item fs-16' style={{ fontWeight: 600 }}>Continue</p>
                        </div>
                      </div>
                    )
                  }
                </div>
              </div>
            )
          }

          {
            currentWindow == "add-exercise" && [
              <div className="d-flex w-full p-l-12 p-r-12 m-b-12 space-between">
                <div className='flex-item d-flex'>
                  <div onClick={toggleBackToPrevWindow.bind(this)} className="d-flex desktop-modal-close-button m-r-12">
                    <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                    </svg>
                  </div>
                  <p className="flex-item modal-header-text">Content</p>
                </div>
                <div className='d-flex space-between flex-item'>
                  <div id="search-container" className='global-search-box flex-item' style={{ background: "#f5f5f5", width: "80%" }}>
                    <svg id="search-icon" className='flex-item m-b-3' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_1637_1318)">
                        <path d="M11.7429 10.344C12.7112 9.0227 13.1449 7.3845 12.9572 5.75716C12.7695 4.12982 11.9743 2.63335 10.7307 1.56714C9.48701 0.50093 7.88665 -0.0563875 6.24973 0.00668566C4.61282 0.0697588 3.06008 0.748571 1.90217 1.90732C0.744249 3.06606 0.0665484 4.61929 0.00464653 6.25624C-0.0572553 7.8932 0.501207 9.49317 1.56831 10.7361C2.6354 11.9789 4.13244 12.7731 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0004C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.50001C12.0009 7.22228 11.8586 7.93748 11.5822 8.60477C11.3058 9.27206 10.9007 9.87837 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87837 1.69596 9.27206 1.41956 8.60477C1.14316 7.93748 1.0009 7.22228 1.0009 6.50001C1.0009 5.04132 1.58036 3.64237 2.61181 2.61092C3.64326 1.57947 5.04221 1.00001 6.5009 1.00001C7.95959 1.00001 9.35853 1.57947 10.39 2.61092C11.4214 3.64237 12.0009 5.04132 12.0009 6.50001Z" fill="#6D6D6D" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1637_1318">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <input id="search-content" onChange={_.debounce(handleContentSearchKey, 1000)} className='flex-item' style={{ background: "#f5f5f5" }} type="text" placeholder="Search Content" />
                  </div>
                  <div onClick={() => toggleContentFilter("main-filter")} className='global-round-btn d-flex flex-item' style={{ background: "#f5f5f5" }}>
                    <svg className='flex-item fill-svg' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15 4H12.95C12.7 2.85 11.7 2 10.5 2C9.3 2 8.3 2.85 8.05 4H1V5H8.05C8.3 6.15 9.3 7 10.5 7C11.7 7 12.7 6.15 12.95 5H15V4ZM10.5 6C9.65 6 9 5.35 9 4.5C9 3.65 9.65 3 10.5 3C11.35 3 12 3.65 12 4.5C12 5.35 11.35 6 10.5 6ZM1 12H3.05C3.3 13.15 4.3 14 5.5 14C6.7 14 7.7 13.15 7.95 12H15V11H7.95C7.7 9.85 6.7 9 5.5 9C4.3 9 3.3 9.85 3.05 11H1V12ZM5.5 10C6.35 10 7 10.65 7 11.5C7 12.35 6.35 13 5.5 13C4.65 13 4 12.35 4 11.5C4 10.65 4.65 10 5.5 10Z" fill="#6D6D6D" />
                    </svg>
                  </div>
                </div>
              </div>,
              <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" onScroll={handleScroll} style={{ overflow: "auto", height:"94%" }}>
                {
                  Contents.map((content) => {
                    if (selectedContent && selectedContent._id == content._id) {
                      return (
                        <div className='planner-exercise-container m-b-12'>
                          <div className='w-full'>
                            <div className={`d-flex w-full space-between ${selectedContent.contentType === 'mainexercise'&&'m-b-12'}`}>
                              <div className='d-flex' style={{ width: "80%" }}>
                                <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.75 3.64583C1.75 3.14303 1.94974 2.66081 2.30528 2.30528C2.66081 1.94974 3.14303 1.75 3.64583 1.75H10.3542C10.857 1.75 11.3392 1.94974 11.6947 2.30528C12.0503 2.66081 12.25 3.14303 12.25 3.64583V10.3542C12.25 10.857 12.0503 11.3392 11.6947 11.6947C11.3392 12.0503 10.857 12.25 10.3542 12.25H3.64583C3.14303 12.25 2.66081 12.0503 2.30528 11.6947C1.94974 11.3392 1.75 10.857 1.75 10.3542V3.64583ZM3.64583 2.625C3.37509 2.625 3.11544 2.73255 2.924 2.924C2.73255 3.11544 2.625 3.37509 2.625 3.64583V10.3542C2.625 10.9177 3.08233 11.375 3.64583 11.375H7.875V2.625H3.64583ZM10.3542 11.375C10.6249 11.375 10.8846 11.2674 11.076 11.076C11.2674 10.8846 11.375 10.6249 11.375 10.3542V9.33333H8.75V11.375H10.3542ZM11.375 8.45833V5.54167H8.75V8.45833H11.375ZM11.375 4.66667V3.64583C11.375 3.37509 11.2674 3.11544 11.076 2.924C10.8846 2.73255 10.6249 2.625 10.3542 2.625H8.75V4.66667H11.375ZM3.5 8.02083C3.5 7.9048 3.54609 7.79352 3.62814 7.71147C3.71019 7.62943 3.82147 7.58333 3.9375 7.58333H6.5625C6.67853 7.58333 6.78981 7.62943 6.87186 7.71147C6.95391 7.79352 7 7.9048 7 8.02083C7 8.13687 6.95391 8.24814 6.87186 8.33019C6.78981 8.41224 6.67853 8.45833 6.5625 8.45833H3.9375C3.82147 8.45833 3.71019 8.41224 3.62814 8.33019C3.54609 8.24814 3.5 8.13687 3.5 8.02083ZM4.22917 3.79167C3.82667 3.79167 3.5 4.11833 3.5 4.52083V5.97917C3.5 6.38167 3.82667 6.70833 4.22917 6.70833H6.27083C6.67333 6.70833 7 6.38167 7 5.97917V4.52083C7 4.11833 6.67333 3.79167 6.27083 3.79167H4.22917ZM4.375 5.83333V4.66667H6.125V5.83333H4.375ZM3.5 9.77083C3.5 9.6548 3.54609 9.54352 3.62814 9.46147C3.71019 9.37943 3.82147 9.33333 3.9375 9.33333H6.5625C6.67853 9.33333 6.78981 9.37943 6.87186 9.46147C6.95391 9.54352 7 9.6548 7 9.77083C7 9.88687 6.95391 9.99815 6.87186 10.0802C6.78981 10.1622 6.67853 10.2083 6.5625 10.2083H3.9375C3.82147 10.2083 3.71019 10.1622 3.62814 10.0802C3.54609 9.99815 3.5 9.88687 3.5 9.77083Z" fill="var(--darkBlue)" />
                                </svg>
                                <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{content.name}</p>
                              </div>
                              <div className='d-flex'>
                                <div onClick={toggleVideoPlayer.bind(this, content)} className='d-flex planner-play-exercise m-r-20'>
                                  <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                  </svg>
                                </div>
                                <svg className='flex-item' width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="6" cy="6" r="6" transform="matrix(1 0 0 -1 0 12)" fill="#5D883C" />
                                  <path d="M3.12646 7.3249L4.9814 8.92561L9.12875 3.54259" stroke="white" stroke-width="0.5" stroke-linecap="round" />
                                </svg>
                              </div>
                              </div>
                          </div>
                    
                          {
                            (selectedContent && selectedContent._id && selectedContent.contentType === 'mainexercise' && selectedContent.exerciseUnit == "weight") && [
                              <div className='d-flex-wrap m-b-16 p-t-16'>
                                {
                                  exerciseDetails.set.map((data, index) => {
                                    return(
                                      <div onMouseOver={()=> handleDeleteSet(index)} onMouseLeave={() => handleDeleteSet(-1)} onClick={() => handleSelectedSet(index)} className={`member-button-global btn-center d-flex m-r-12`} style={{background: selectedSet == index ? "var(--darkBlue)" : "#ffffff", position:"relative"}}>
                                        <p className="flex-item" style={{color: selectedSet == index ? "#ffffff" : "#000000", fontSize:"12px"}}>Set {index +1}</p>
                                        {
                                          isSetIndexDeleteEnabled == index && index>0 && (
                                            <svg onClick={() => handleSetAction("delete", index)} className='flex-item m-l-16' style={{position:"absolute", top: 0, right: 0, margin: "-8px -8px 0 0"}} width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <circle cx="10.5" cy="10.5" r="10.5" fill="#939393"/>
                                              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5092 11.5469L14.7343 15.772C14.8751 15.908 15.0638 15.9833 15.2596 15.9816C15.4554 15.9799 15.6428 15.9014 15.7812 15.7629C15.9197 15.6244 15.9983 15.4371 16 15.2413C16.0017 15.0454 15.9264 14.8568 15.7903 14.7159L11.5653 10.4908L15.7903 6.26574C15.9264 6.12488 16.0017 5.93622 16 5.74039C15.9983 5.54456 15.9197 5.35723 15.7812 5.21876C15.6428 5.08028 15.4554 5.00173 15.2596 5.00003C15.0638 4.99833 14.8751 5.07361 14.7343 5.20966L10.5092 9.43474L6.2841 5.20966C6.1426 5.07697 5.95503 5.00454 5.76108 5.00769C5.56713 5.01084 5.38201 5.08932 5.2449 5.22653C5.10779 5.36374 5.02943 5.54892 5.02642 5.74287C5.02341 5.93682 5.09597 6.12434 5.22876 6.26574L9.45309 10.4908L5.22801 14.7159C5.15668 14.7848 5.09978 14.8672 5.06064 14.9583C5.02149 15.0495 5.00089 15.1475 5.00003 15.2466C4.99917 15.3458 5.01806 15.4442 5.05562 15.5359C5.09317 15.6277 5.14863 15.7111 5.21875 15.7812C5.28888 15.8514 5.37227 15.9068 5.46406 15.9444C5.55585 15.9819 5.6542 16.0008 5.75337 16C5.85254 15.9991 5.95054 15.9785 6.04166 15.9394C6.13279 15.9002 6.2152 15.8433 6.2841 15.772L10.5092 11.5469Z" fill="white"/>
                                            </svg>
                                          )
                                        }
                                      </div>
                                    )
                                  })
                                }
                                {
                                  exerciseDetails.set.length < 5 && (
                                    <div onClick={() => handleSetAction("add")} className='d-flex desktop-modal-close-button m-r-12'>
                                      <svg className='flex-item' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.52494 8.51015L14.5001 8.51015C14.6959 8.50675 14.8825 8.42657 15.0198 8.2869C15.1571 8.14722 15.234 7.95922 15.234 7.76339C15.234 7.56755 15.1571 7.37955 15.0198 7.23987C14.8825 7.1002 14.6959 7.02003 14.5001 7.01662L8.52494 7.01662L8.52494 1.04146C8.52154 0.84565 8.44136 0.659013 8.30169 0.521745C8.16201 0.384476 7.97401 0.307558 7.77818 0.307558C7.58234 0.307558 7.39434 0.384476 7.25466 0.521744C7.11499 0.659013 7.03481 0.845649 7.03141 1.04146L7.03141 7.01662L1.05624 7.01662C0.862367 7.02285 0.678519 7.10427 0.543602 7.24364C0.408685 7.38301 0.333284 7.5694 0.333352 7.76338C0.333421 7.95736 0.408954 8.1437 0.543969 8.28297C0.678985 8.42225 0.86289 8.50353 1.05677 8.50962L7.03141 8.51015L7.03141 14.4853C7.02969 14.5845 7.04773 14.683 7.08448 14.7751C7.12124 14.8672 7.17597 14.9511 7.24548 15.0218C7.315 15.0925 7.3979 15.1487 7.48936 15.1871C7.58082 15.2254 7.679 15.2452 7.77817 15.2452C7.87735 15.2452 7.97553 15.2254 8.06699 15.1871C8.15845 15.1487 8.24135 15.0925 8.31087 15.0218C8.38038 14.9511 8.43511 14.8672 8.47186 14.7751C8.50862 14.683 8.52666 14.5845 8.52494 14.4853L8.52494 8.51015Z" fill="#4D4D4D"/>
                                      </svg>
                                    </div>
                                  )
                                }
                              </div>,
                              exerciseDetails.set && exerciseDetails.set[selectedSet] && (
                                <>
                                <div onClick={toggleInputFields('exercise-reps')} className={`${(currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "member-global-input-field w-full m-b-20 flex-item" : "member-global-input-field w-full m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "1px solid var(--darkBlue)" : "" }}>
                                  <div className="flex-item d-flex">
                                    <svg className="flex-item m-r-8" width={(currentElementId == 'exercise-reps' || exerciseDetails.set[selectedSet].reps) ? "12" : "18"} height={(currentElementId == 'exercise-reps' || exerciseDetails.set[selectedSet].reps) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8.65032 5.25014H11.5993C11.6349 5.25015 11.6698 5.26032 11.6999 5.27944C11.73 5.29857 11.7539 5.32586 11.7691 5.35812C11.7842 5.39039 11.7898 5.42629 11.7852 5.46162C11.7807 5.49696 11.7661 5.53026 11.7433 5.55764L10.2688 7.32764C10.2512 7.34874 10.2292 7.36572 10.2043 7.37737C10.1794 7.38902 10.1523 7.39506 10.1248 7.39506C10.0973 7.39506 10.0702 7.38902 10.0453 7.37737C10.0204 7.36572 9.99842 7.34874 9.98082 7.32764L8.50632 5.55764C8.48352 5.53026 8.46899 5.49696 8.46443 5.46162C8.45987 5.42629 8.46548 5.39039 8.48059 5.35812C8.4957 5.32586 8.51969 5.29857 8.54975 5.27944C8.57981 5.26032 8.61469 5.25015 8.65032 5.25014ZM0.40032 6.75014H3.34932C3.38495 6.75013 3.41983 6.73996 3.44989 6.72084C3.47995 6.70172 3.50394 6.67442 3.51905 6.64216C3.53416 6.60989 3.53977 6.57399 3.53521 6.53866C3.53065 6.50332 3.51612 6.47002 3.49332 6.44264L2.01882 4.67264C2.00122 4.65154 1.9792 4.63456 1.95432 4.62291C1.92944 4.61126 1.9023 4.60522 1.87482 4.60522C1.84734 4.60522 1.8202 4.61126 1.79532 4.62291C1.77044 4.63456 1.74842 4.65154 1.73082 4.67264L0.25632 6.44264C0.233519 6.47002 0.218988 6.50332 0.214431 6.53866C0.209874 6.57399 0.215478 6.60989 0.230587 6.64216C0.245697 6.67442 0.269686 6.70172 0.299746 6.72084C0.329806 6.73996 0.364693 6.75013 0.40032 6.75014Z" fill={(currentElementId == 'exercise-reps' || exerciseDetails.set[selectedSet].reps) ? "var(--darkBlue)" : "#6d6d6d"} />
                                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00025 2.25005C4.83625 2.25005 3.79525 2.7803 3.1075 3.61355C3.07679 3.65336 3.03839 3.68658 2.99458 3.71125C2.95077 3.73591 2.90245 3.75152 2.85249 3.75714C2.80253 3.76275 2.75195 3.75827 2.70376 3.74394C2.65557 3.72962 2.61075 3.70575 2.57197 3.67376C2.53319 3.64177 2.50123 3.60231 2.47801 3.55772C2.45478 3.51313 2.44076 3.46433 2.43677 3.41421C2.43279 3.36409 2.43892 3.31369 2.45481 3.26599C2.4707 3.21829 2.49601 3.17427 2.52925 3.13655C3.07839 2.4717 3.80694 1.97856 4.62825 1.71579C5.44955 1.45303 6.32905 1.43169 7.16213 1.65432C7.99521 1.87695 8.74682 2.33418 9.32756 2.97162C9.9083 3.60906 10.2937 4.39989 10.438 5.25005H9.67525C9.50209 4.40316 9.04178 3.64205 8.37215 3.09541C7.70252 2.54878 6.86466 2.25016 6.00025 2.25005ZM2.32525 6.75005C2.46723 7.44352 2.80251 8.08267 3.29236 8.59366C3.7822 9.10465 4.40662 9.46662 5.09347 9.63777C5.78032 9.80891 6.50158 9.78224 7.17392 9.56083C7.84626 9.33943 8.44223 8.93232 8.893 8.38655C8.92371 8.34675 8.96211 8.31352 9.00592 8.28886C9.04973 8.26419 9.09805 8.24859 9.14801 8.24297C9.19797 8.23735 9.24855 8.24184 9.29674 8.25616C9.34493 8.27048 9.38975 8.29435 9.42853 8.32634C9.46731 8.35833 9.49927 8.3978 9.52249 8.44239C9.54572 8.48698 9.55974 8.53578 9.56372 8.5859C9.56771 8.63601 9.56158 8.68642 9.54569 8.73412C9.5298 8.78182 9.50449 8.82583 9.47125 8.86355C8.92211 9.52841 8.19356 10.0215 7.37225 10.2843C6.55095 10.5471 5.67145 10.5684 4.83837 10.3458C4.00529 10.1232 3.25368 9.66593 2.67294 9.02849C2.0922 8.39105 1.70678 7.60021 1.5625 6.75005H2.32525Z" fill={(currentElementId == 'exercise-reps' || exerciseDetails.set[selectedSet].reps) ? "var(--darkBlue)" : "#6d6d6d"} />
                                    </svg>
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "10px" : "14px", color: (currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "var(--darkBlue)" : "", transition: "180ms" }}>Repetation</p>
                                  </div>
                                  <input id="exercise-reps" value={exerciseDetails.set[selectedSet].reps} onChange={handleSetReps} className={`${(currentElementId == "exercise-reps" || exerciseDetails.set[selectedSet].reps) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                                </div>
                                <div className='d-flex space-between'>
                                  <div onClick={toggleInputFields('exercise-weight')} className={`${(currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                    <div className="flex-item d-flex">
                                      <svg className='flex-item m-r-8' width={(currentElementId == 'exercise-weight' || exerciseDetails.set[selectedSet].weight.value) ? "12" : "18"} height={(currentElementId == 'exercise-weight' || exerciseDetails.set[selectedSet].weight.value) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 0C5.10273 0 4.36364 0.739091 4.36364 1.63636C4.36364 1.82836 4.404 2.00945 4.46618 2.18182H1.73891L1.65327 2.62527L0.0169092 10.8071L0 10.8578V12H12V10.8578L11.9831 10.8071L10.3467 2.62527L10.2611 2.18182H7.53382C7.59934 2.00731 7.63403 1.82275 7.63636 1.63636C7.63636 0.739091 6.89727 0 6 0ZM6 1.09091C6.30709 1.09091 6.54545 1.32982 6.54545 1.63636C6.54545 1.94345 6.30655 2.18182 6 2.18182C5.69291 2.18182 5.45455 1.94291 5.45455 1.63636C5.45455 1.32927 5.69345 1.09091 6 1.09091ZM2.62473 3.27273H9.37527L10.9091 10.9091H1.09091L2.62473 3.27273Z" fill={(currentElementId == 'exercise-weight' || exerciseDetails.set[selectedSet].weight.value) ? "var(--darkBlue)" : "#6d6d6d"} />
                                      </svg>
                                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "10px" : "14px", color: (currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "var(--darkBlue)" : "", transition: "180ms" }}>Weight</p>
                                    </div>
                                    <input id="exercise-weight" value={exerciseDetails.set[selectedSet].weight.value} className={`${(currentElementId == "exercise-weight" || exerciseDetails.set[selectedSet].weight.value) ? "active-input-field" : "inactive-input-field"}`} type="number" onChange={handleChangeExerciseDetails("weight.value")} />
                                  </div>
                                  <div onClick={toggleInputFields('weight-unit')} className={`${(currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                    <div className="flex-item d-flex">
                                      <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "10px" : "14px", color: (currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "var(--darkBlue)" : "", transition: "180ms" }}>Unit</p>
                                    </div>
                                    <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                      <svg className="flex-item" style={{ transform: exerciseWeightUnitTypeDropdownOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                      </svg>
                                    </div>
                                    <input id="weight-unit" className={`${(currentElementId == "weight-unit" || exerciseDetails.set[selectedSet].weight.unit) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Unit" value={exerciseDetails.set[selectedSet].weight.unit} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
                                    {
                                      exerciseWeightUnitTypeDropdownOpen && (
                                        <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                          <div onClick={getSelectedWeightUnit.bind(this, "Kg")} className="global-input-field-arrow-dropdown-item">
                                            <p className="flex-item">Kg</p>
                                          </div>
                                          <div onClick={getSelectedWeightUnit.bind(this, "Lbs")} className="global-input-field-arrow-dropdown-item">
                                            <p className="flex-item">Lbs</p>
                                          </div>
                                        </div>
                                      )
                                    }
                                  </div>
                                </div>
                                </>
                              )
                             
                            ]
                          }
                          {
                            (selectedContent && selectedContent._id && selectedContent.contentType === 'mainexercise' && selectedContent.exerciseUnit == "distance") && (
                              <div className='d-flex space-between'>
                                <div onClick={toggleInputFields('exercise-distance')} className={`${(currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                  <div className="flex-item d-flex">
                                    <svg className='flex-item m-r-8' width={(currentElementId == 'exercise-distance' || exerciseDetails.distance.value) ? "12" : "18"} height={(currentElementId == 'exercise-distance' || exerciseDetails.distance.value) ? "16" : "18"} style={{ transition: "180ms" }} viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M4.34105 4.84112L4.34107 4.8411C4.65572 4.52642 4.86999 4.12551 4.95679 3.68906C4.98559 3.54423 4.99993 3.39764 5 3.25139C4.99998 3.3978 4.98566 3.54455 4.95685 3.68954C4.87012 4.12593 4.65597 4.52681 4.34145 4.84151C4.34142 4.84154 4.34139 4.84157 4.34137 4.84159L2.75041 6.43255L2.75002 6.43215L3.10355 6.07862L4.34105 4.84112ZM2.39645 6.07862L2.68855 6.37072L1.15864 4.84159C1.15861 4.84157 1.15858 4.84154 1.15855 4.84151C1.15852 4.84148 1.15849 4.84145 1.15846 4.84142C0.843996 4.52674 0.629872 4.12589 0.543157 3.68954C0.514343 3.54455 0.500027 3.3978 0.500001 3.25139C0.500078 3.39764 0.514415 3.54423 0.543218 3.68906C0.630016 4.12551 0.844285 4.52642 1.15893 4.8411L1.15895 4.84112L2.39645 6.07862ZM8.695 9.48788L7.31336 10.8688L7.60355 10.5786L8.84105 9.34112L8.84107 9.3411C9.15572 9.02642 9.36999 8.62551 9.45679 8.18906C9.48192 8.06268 9.49604 7.93497 9.49928 7.80731C9.49605 7.93497 9.48196 8.06267 9.45685 8.18904C9.37011 8.62547 9.15593 9.02638 8.84136 9.34109L8.695 9.48753V9.48788ZM5.65895 9.34112L6.771 10.4532L5.65864 9.34109C5.34408 9.02638 5.12989 8.62547 5.04316 8.18904C5.01436 8.04413 5.00004 7.89747 5 7.75114C5.00006 7.89748 5.0144 8.04415 5.04322 8.18906C5.13002 8.62551 5.34429 9.02642 5.65893 9.3411L5.65895 9.34112ZM2.75 3.50006C2.6837 3.50006 2.62011 3.47372 2.57322 3.42684C2.52634 3.37996 2.5 3.31637 2.5 3.25006C2.5 3.18376 2.52634 3.12017 2.57322 3.07329C2.62011 3.0264 2.6837 3.00006 2.75 3.00006C2.81631 3.00006 2.87989 3.0264 2.92678 3.07329C2.97366 3.12017 3 3.18376 3 3.25006C3 3.31637 2.97366 3.37996 2.92678 3.42684C2.87989 3.47372 2.81631 3.50006 2.75 3.50006ZM7.25 8.00006C7.1837 8.00006 7.12011 7.97372 7.07322 7.92684C7.02634 7.87996 7 7.81637 7 7.75006C7 7.68376 7.02634 7.62017 7.07322 7.57329C7.12011 7.5264 7.1837 7.50006 7.25 7.50006C7.31631 7.50006 7.37989 7.5264 7.42678 7.57329C7.47366 7.62017 7.5 7.68376 7.5 7.75006C7.5 7.81637 7.47366 7.87996 7.42678 7.92684C7.37989 7.97372 7.3163 8.00006 7.25 8.00006Z" stroke={(currentElementId == 'exercise-distance' || exerciseDetails.distance.value) ? "var(--darkBlue)" : "#6d6d6d"} />
                                    </svg>
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "10px" : "14px", color: (currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "var(--darkBlue)" : "", transition: "180ms" }}>Distance</p>
                                  </div>
                                  <input onChange={handleChangeExerciseDetails("distance.value")} id="exercise-distance" value={exerciseDetails.distance.value} className={`${(currentElementId == "exercise-distance" || exerciseDetails.distance.value) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                                </div>
                                <div onClick={toggleInputFields('distance-unit')} className={`${(currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "1px solid var(--darkBlue)" : "", width: "48%" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "10px" : "14px", color: (currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "var(--darkBlue)" : "", transition: "180ms" }}>Unit</p>
                                  </div>
                                  <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                                    <svg className="flex-item" style={{ transform: exerciseDistanceUnitTypeDropdownOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                                    </svg>
                                  </div>
                                  <input id="distance-unit" className={`${(currentElementId == "distance-unit" || exerciseDetails.distance.unit) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Unit" value={exerciseDetails.distance.unit} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
                                  {
                                    exerciseDistanceUnitTypeDropdownOpen && (
                                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1">
                                        <div onClick={getSelectedDistanceUnit.bind(this, "Kg")} className="global-input-field-arrow-dropdown-item">
                                          <p className="flex-item">Kg</p>
                                        </div>
                                        <div onClick={getSelectedDistanceUnit.bind(this, "Lbs")} className="global-input-field-arrow-dropdown-item">
                                          <p className="flex-item">Lbs</p>
                                        </div>
                                      </div>
                                    )
                                  }
                                </div>
                              </div>
                            )
                          }
                          {
                            (selectedContent && selectedContent._id && selectedContent.contentType === 'mainexercise' && selectedContent.exerciseUnit == "number") && (
                              <div onClick={toggleInputFields('exercise-count')} className={`${(currentElementId == "exercise-count" || exerciseDetails.count) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "exercise-count" || exerciseDetails.count) ? "1px solid var(--darkBlue)" : "" }}>
                                <div className="flex-item d-flex">
                                  <svg className="flex-item m-r-8" width={(currentElementId == 'exercise-count' || exerciseDetails.count) ? "12" : "18"} height={(currentElementId == 'exercise-count' || exerciseDetails.count) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.20041 0.700024C1.20041 0.620459 1.23202 0.544153 1.28828 0.487892C1.34454 0.431632 1.42084 0.400024 1.50041 0.400024H10.5004C10.58 0.400024 10.6563 0.431632 10.7125 0.487892C10.7688 0.544153 10.8004 0.620459 10.8004 0.700024C10.8004 0.779589 10.7688 0.855895 10.7125 0.912156C10.6563 0.968417 10.58 1.00002 10.5004 1.00002H1.50041C1.42084 1.00002 1.34454 0.968417 1.28828 0.912156C1.23202 0.855895 1.20041 0.779589 1.20041 0.700024ZM1.20041 3.70002C1.20041 3.62046 1.23202 3.54415 1.28828 3.48789C1.34454 3.43163 1.42084 3.40002 1.50041 3.40002H10.5004C10.58 3.40002 10.6563 3.43163 10.7125 3.48789C10.7688 3.54415 10.8004 3.62046 10.8004 3.70002C10.8004 3.77959 10.7688 3.8559 10.7125 3.91216C10.6563 3.96842 10.58 4.00002 10.5004 4.00002H1.50041C1.42084 4.00002 1.34454 3.96842 1.28828 3.91216C1.23202 3.8559 1.20041 3.77959 1.20041 3.70002ZM4.55321 5.80002C4.18541 5.80002 3.89741 6.13302 3.89741 6.48162C3.89741 6.56119 3.8658 6.6375 3.80954 6.69376C3.75328 6.75002 3.67697 6.78162 3.59741 6.78162C3.51784 6.78162 3.44154 6.75002 3.38528 6.69376C3.32902 6.6375 3.29741 6.56119 3.29741 6.48162C3.29741 5.84922 3.80861 5.20002 4.55321 5.20002C4.99121 5.20002 5.41061 5.40582 5.64341 5.76642C5.88581 6.14082 5.89661 6.63162 5.60921 7.12422C5.46281 7.37442 5.26121 7.56523 5.06081 7.72423C4.96121 7.80403 4.85741 7.87782 4.75901 7.94802L4.71701 7.97802C4.63241 8.03802 4.55261 8.09442 4.47521 8.15262C4.21181 8.35242 4.02101 8.54142 3.94061 8.80002H5.49641C5.57597 8.80002 5.65228 8.83163 5.70854 8.88789C5.7648 8.94415 5.79641 9.02046 5.79641 9.10003C5.79641 9.17959 5.7648 9.2559 5.70854 9.31216C5.65228 9.36842 5.57597 9.40002 5.49641 9.40002H3.59681C3.51724 9.40002 3.44094 9.36842 3.38468 9.31216C3.32842 9.2559 3.29681 9.17959 3.29681 9.10003C3.29681 8.38302 3.71141 7.97802 4.11281 7.67443C4.19801 7.61023 4.28621 7.54722 4.37021 7.48842L4.41101 7.45842C4.50881 7.38942 4.60061 7.32282 4.68701 7.25442C4.86101 7.11642 4.99781 6.98022 5.09021 6.82122C5.28101 6.49602 5.24141 6.25002 5.13941 6.09282C5.02841 5.92122 4.81001 5.80002 4.55261 5.80002H4.55321ZM7.24301 5.96202C7.16101 6.03556 7.10116 6.13052 7.07021 6.23622C7.05962 6.27431 7.0416 6.30992 7.0172 6.34102C6.9928 6.37211 6.96249 6.39808 6.92802 6.41743C6.89356 6.43678 6.8556 6.44912 6.81635 6.45376C6.77709 6.45839 6.73731 6.45522 6.69928 6.44443C6.66126 6.43364 6.62574 6.41544 6.59477 6.39087C6.5638 6.36631 6.53799 6.33587 6.51882 6.3013C6.49965 6.26674 6.4875 6.22872 6.48307 6.18944C6.47864 6.15016 6.48202 6.11039 6.49301 6.07242C6.53861 5.91103 6.64181 5.69262 6.84461 5.51262C7.05341 5.32782 7.34921 5.20002 7.74521 5.20002C8.55161 5.20002 9.00941 5.79042 9.00941 6.31842C9.00941 6.52962 8.96861 6.85422 8.75081 7.13022C8.70761 7.18422 8.65901 7.23522 8.60501 7.28142C8.68601 7.34142 8.76221 7.41582 8.82641 7.50642C8.94401 7.67262 9.00941 7.87782 9.00941 8.11842C9.00941 8.55643 8.86301 8.89242 8.60261 9.11442C8.35061 9.32743 8.03261 9.40002 7.74521 9.40002C7.47401 9.40002 7.20941 9.35443 6.98201 9.20983C6.74921 9.06163 6.59261 8.83302 6.49601 8.53903C6.48376 8.50156 6.479 8.46205 6.48202 8.42274C6.48504 8.38344 6.49577 8.34512 6.5136 8.30996C6.53143 8.2748 6.55601 8.2435 6.58593 8.21785C6.61586 8.19219 6.65054 8.17268 6.68801 8.16042C6.72547 8.14817 6.76499 8.14342 6.80429 8.14644C6.84359 8.14946 6.88192 8.16019 6.91707 8.17801C6.95223 8.19584 6.98353 8.22042 7.00919 8.25035C7.03484 8.28027 7.05436 8.31496 7.06661 8.35242C7.13081 8.54862 7.21541 8.64762 7.30421 8.70403C7.39841 8.76402 7.53461 8.80002 7.74521 8.80002C7.94081 8.80002 8.10401 8.74963 8.21381 8.65602C8.31521 8.57082 8.40941 8.41603 8.40941 8.11842C8.41417 8.02454 8.38873 7.93159 8.33681 7.85323C8.28738 7.78798 8.22183 7.7367 8.14661 7.70442C7.96841 7.62042 7.74101 7.60002 7.58501 7.60002C7.50544 7.60002 7.42914 7.56842 7.37288 7.51216C7.31662 7.4559 7.28501 7.37959 7.28501 7.30002C7.28501 7.22046 7.31662 7.14415 7.37288 7.08789C7.42914 7.03163 7.50544 7.00002 7.58501 7.00002C8.00801 7.00002 8.19161 6.86982 8.27981 6.75822C8.37881 6.63342 8.40941 6.46662 8.40941 6.31842C8.40941 6.12582 8.22461 5.80002 7.74521 5.80002C7.48721 5.80002 7.33541 5.87983 7.24301 5.96202ZM1.80701 6.61902C1.65492 6.78479 1.48396 6.93219 1.29761 7.05822C1.26495 7.08155 1.22794 7.09809 1.18878 7.10686C1.14962 7.11562 1.10909 7.11644 1.06961 7.10927C1.03012 7.10209 0.992474 7.08707 0.958898 7.06508C0.925323 7.0431 0.8965 7.0146 0.874136 6.98127C0.851772 6.94795 0.836323 6.91047 0.828701 6.87107C0.82108 6.83167 0.821442 6.79114 0.829766 6.75188C0.83809 6.71262 0.854207 6.67543 0.877163 6.64251C0.900119 6.60959 0.929446 6.58161 0.963409 6.56023C1.40321 6.26562 1.73681 5.79222 1.81421 5.43642C1.81421 5.43642 1.88021 5.20002 2.09021 5.20002C2.39141 5.20002 2.40761 5.50002 2.40761 5.50002V9.10003C2.40761 9.17959 2.376 9.2559 2.31974 9.31216C2.26348 9.36842 2.18717 9.40002 2.10761 9.40002C2.02804 9.40002 1.95174 9.36842 1.89548 9.31216C1.83922 9.2559 1.80761 9.17959 1.80761 9.10003V6.61902H1.80701ZM9.60041 6.70002C9.60041 6.62046 9.63202 6.54415 9.68828 6.48789C9.74454 6.43163 9.82084 6.40002 9.90041 6.40002H10.5004C10.58 6.40002 10.6563 6.43163 10.7125 6.48789C10.7688 6.54415 10.8004 6.62046 10.8004 6.70002C10.8004 6.77959 10.7688 6.8559 10.7125 6.91216C10.6563 6.96842 10.58 7.00002 10.5004 7.00002H9.90041C9.82084 7.00002 9.74454 6.96842 9.68828 6.91216C9.63202 6.8559 9.60041 6.77959 9.60041 6.70002Z" fill={(currentElementId == 'exercise-count' || exerciseDetails.count) ? "var(--darkBlue)" : "#6d6d6d"} />
                                  </svg>
                                  <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "exercise-count" || exerciseDetails.count) ? "10px" : "14px", color: (currentElementId == "exercise-count" || exerciseDetails.count) ? "var(--darkBlue)" : "", transition: "180ms" }}>Count</p>
                                </div>
                                <input id="exercise-count" value={exerciseDetails.count} onChange={handleChangeExerciseDetails("count")} className={`${(currentElementId == "exercise-count" || exerciseDetails.count) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                              </div>
                            )
                          }
                          {
                            (selectedContent && selectedContent._id&& selectedContent.contentType === 'mainexercise' && selectedContent.exerciseUnit == "time") && [
                              <div className='d-flex m-b-12'>
                                <svg className='flex-item m-r-6' width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.09625 7.625L5 5.52875V2H5.75V5.2175L7.625 7.09625L7.09625 7.625Z" fill="#2B2B2B" />
                                  <path d="M5.25 10.5C4.21165 10.5 3.19662 10.1921 2.33326 9.61522C1.4699 9.03834 0.796995 8.2184 0.399635 7.25909C0.00227474 6.29978 -0.101693 5.24418 0.10088 4.22578C0.303452 3.20738 0.803466 2.27192 1.53769 1.53769C2.27192 0.803466 3.20738 0.303452 4.22578 0.10088C5.24418 -0.101693 6.29978 0.00227474 7.25909 0.399635C8.2184 0.796995 9.03834 1.4699 9.61522 2.33326C10.1921 3.19662 10.5 4.21165 10.5 5.25C10.5 6.64239 9.94688 7.97775 8.96231 8.96231C7.97775 9.94688 6.64239 10.5 5.25 10.5ZM5.25 0.750002C4.35999 0.750002 3.48996 1.01392 2.74994 1.50839C2.00992 2.00286 1.43314 2.70566 1.09254 3.52793C0.75195 4.35019 0.662835 5.25499 0.836469 6.12791C1.0101 7.00082 1.43869 7.80265 2.06802 8.43198C2.69736 9.06132 3.49918 9.4899 4.3721 9.66354C5.24501 9.83717 6.14981 9.74805 6.97208 9.40746C7.79434 9.06686 8.49715 8.49009 8.99162 7.75007C9.48608 7.01005 9.75 6.14002 9.75 5.25C9.75 4.05653 9.2759 2.91194 8.43198 2.06802C7.58807 1.22411 6.44348 0.750002 5.25 0.750002Z" fill="#2B2B2B" />
                                </svg>
                                <p className='flex-item'>Duration</p>
                              </div>,
                              <div className='d-flex space-between'>
                                <div onClick={toggleInputFields('duration-hour')} className={`${(currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "1px solid var(--darkBlue)" : "", width: "45%" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "10px" : "14px", color: (currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "var(--darkBlue)" : "", transition: "180ms" }}>Hour</p>
                                  </div>
                                  <input id="duration-hour" value={exerciseDetails.duration.hour} onChange={handleChangeExerciseDetails("duration.hour")} className={`${(currentElementId == "duration-hour" || exerciseDetails.duration.hour) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                                </div>
                                <svg className='flex-item' width="6" height="20" viewBox="0 0 6 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="3" cy="3" r="3" fill="#9A9A9A" />
                                  <circle cx="3" cy="17" r="3" fill="#9A9A9A" />
                                </svg>
                                <div onClick={toggleInputFields('duration-min')} className={`${(currentElementId == "duration-min" || exerciseDetails.duration.min) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "duration-min" || exerciseDetails.duration.min) ? "1px solid var(--darkBlue)" : "", width: "45%" }}>
                                  <div className="flex-item d-flex">
                                    <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "duration-min" || exerciseDetails.duration.min) ? "10px" : "14px", color: (currentElementId == "duration-min" || exerciseDetails.duration.min) ? "var(--darkBlue)" : "", transition: "180ms" }}>Min</p>
                                  </div>
                                  <input onChange={handleChangeExerciseDetails("duration.min")} id="duration-min" value={exerciseDetails.duration.min} className={`${(currentElementId == "duration-min" || exerciseDetails.duration.min) ? "active-input-field" : "inactive-input-field"}`} type="number" />
                                </div>
                              </div>
                            ]
                          }
                        </div>
                      )
                    } else {
                      return (
                        <div onClick={handleSelectContent(content)} className='planner-exercise-container m-b-12' style={{ paddingBottom: "3px", boxShadow: "none" }}>
                          <div className='d-flex w-full space-between m-b-12'>
                            <div className='d-flex' style={{ width: "80%" }}>
                              <svg className='flex-item m-r-8' width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.75 3.64583C1.75 3.14303 1.94974 2.66081 2.30528 2.30528C2.66081 1.94974 3.14303 1.75 3.64583 1.75H10.3542C10.857 1.75 11.3392 1.94974 11.6947 2.30528C12.0503 2.66081 12.25 3.14303 12.25 3.64583V10.3542C12.25 10.857 12.0503 11.3392 11.6947 11.6947C11.3392 12.0503 10.857 12.25 10.3542 12.25H3.64583C3.14303 12.25 2.66081 12.0503 2.30528 11.6947C1.94974 11.3392 1.75 10.857 1.75 10.3542V3.64583ZM3.64583 2.625C3.37509 2.625 3.11544 2.73255 2.924 2.924C2.73255 3.11544 2.625 3.37509 2.625 3.64583V10.3542C2.625 10.9177 3.08233 11.375 3.64583 11.375H7.875V2.625H3.64583ZM10.3542 11.375C10.6249 11.375 10.8846 11.2674 11.076 11.076C11.2674 10.8846 11.375 10.6249 11.375 10.3542V9.33333H8.75V11.375H10.3542ZM11.375 8.45833V5.54167H8.75V8.45833H11.375ZM11.375 4.66667V3.64583C11.375 3.37509 11.2674 3.11544 11.076 2.924C10.8846 2.73255 10.6249 2.625 10.3542 2.625H8.75V4.66667H11.375ZM3.5 8.02083C3.5 7.9048 3.54609 7.79352 3.62814 7.71147C3.71019 7.62943 3.82147 7.58333 3.9375 7.58333H6.5625C6.67853 7.58333 6.78981 7.62943 6.87186 7.71147C6.95391 7.79352 7 7.9048 7 8.02083C7 8.13687 6.95391 8.24814 6.87186 8.33019C6.78981 8.41224 6.67853 8.45833 6.5625 8.45833H3.9375C3.82147 8.45833 3.71019 8.41224 3.62814 8.33019C3.54609 8.24814 3.5 8.13687 3.5 8.02083ZM4.22917 3.79167C3.82667 3.79167 3.5 4.11833 3.5 4.52083V5.97917C3.5 6.38167 3.82667 6.70833 4.22917 6.70833H6.27083C6.67333 6.70833 7 6.38167 7 5.97917V4.52083C7 4.11833 6.67333 3.79167 6.27083 3.79167H4.22917ZM4.375 5.83333V4.66667H6.125V5.83333H4.375ZM3.5 9.77083C3.5 9.6548 3.54609 9.54352 3.62814 9.46147C3.71019 9.37943 3.82147 9.33333 3.9375 9.33333H6.5625C6.67853 9.33333 6.78981 9.37943 6.87186 9.46147C6.95391 9.54352 7 9.6548 7 9.77083C7 9.88687 6.95391 9.99815 6.87186 10.0802C6.78981 10.1622 6.67853 10.2083 6.5625 10.2083H3.9375C3.82147 10.2083 3.71019 10.1622 3.62814 10.0802C3.54609 9.99815 3.5 9.88687 3.5 9.77083Z" fill="var(--darkBlue)" />
                              </svg>
                              <p className='planner-exercise-name' style={{ maxWidth: "75%" }}>{content.name}</p>
                            </div>
                            <div className='d-flex'>
                              <div onClick={toggleVideoPlayer.bind(this, content)} className='d-flex planner-play-exercise m-r-20'>
                                <svg className='flex-item' width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.31397 3.11455C8.02765 3.48914 8.02765 4.51086 7.31397 4.88545L2.21572 7.56134C1.54985 7.91083 0.750977 7.4279 0.750977 6.67589V1.32411C0.750977 0.572099 1.54985 0.0891727 2.21572 0.438662L7.31397 3.11455Z" fill="#FF7A00" />
                                </svg>
                              </div>
                              <svg className='flex-item' width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="5.5" fill="white" stroke="#E0E0E0" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      )
                    }

                  })
                }
                {isContentLoader && <div className="loader-5 center"><span></span></div>}
                {
                  selectedContent && selectedContent._id && (
                    <div className='bottom-action-button'>
                      {
                        (sortByContentType == "mainexercise" && plannerType == 'weekday') ? (
                          <div onClick={addDayExerciseContent} className={`member-button-global ${!selectedContent ? "member-button-global-inactive" : ""} btn-center  d-flex`}>
                            <p className="flex-item">Add Content</p>
                          </div>
                        ) : (
                          <div onClick={addExerciseContent} className={`member-button-global ${!selectedContent ? "member-button-global-inactive" : ""} btn-center  d-flex`}>
                            <p className="flex-item">Add Content</p>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </div>,
              <div className='w-full'>
                {
                  isContentFilter == "main-filter" && (
                    <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                      <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                        <div className='flex-item d-flex m-b-20'>
                          <div onClick={() => toggleContentFilter("main-filter")} className="d-flex desktop-modal-close-button m-r-12">
                            <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                            </svg>
                          </div>
                          <p className="flex-item modal-header-text">Filter Content</p>
                        </div>
                        <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                          <div className='w-full'>
                          <p className='filter-heading-text m-b-12'>Access Right</p>
                          <div className="w-full d-flex m-b-8">
                              <div onClick={handleAccessRight.bind(this, "")} className='d-flex w-half p-r-12'>
                                  <input type="radio" name="access-right" checked={!sortByAccessRight} className='flex-item cursor-pointer m-r-6' />
                                  <p className='filter-type-text'>All</p>
                              </div>
                              <div onClick={handleAccessRight.bind(this, "private")} className='d-flex w-half'>
                                  <input type="radio" name="access-right" checked={sortByAccessRight == "private"} className='flex-item cursor-pointer m-r-6' />
                                  <p className='filter-type-text'>Private</p>
                              </div>
                          </div>
                          <div onClick={handleAccessRight.bind(this, "public")} className='d-flex w-full m-b-20 gym-filter-type'>
                              <input type="radio" name="access-right" checked={sortByAccessRight == "public"} className='flex-item cursor-pointer m-r-6' />
                              <p className='filter-type-text'>Public</p>
                          </div>


                            <p className='filter-heading-text m-b-12 m-t-20'>Content Role</p>
                            <div className="w-full d-flex m-b-8">
                              <div onClick={handleContentRole.bind(this, "All")} className='d-flex w-half p-r-12'>
                                <input type="radio" name="content-role" checked={ContentRole == "All"} className='flex-item cursor-pointer m-r-6' />
                                <p className='filter-type-text'>All</p>
                              </div>
                              <div onClick={handleContentRole.bind(this, "gym")} className='d-flex w-half gym-filter-type'>
                                <input type="radio" name="content-role" checked={ContentRole == "gym"} className='flex-item cursor-pointer m-r-6' />
                                <p className='filter-type-text'>Gym Content</p>
                              </div>
                            </div>

                            <div className="w-full d-flex m-b-8">
                              <div onClick={handleContentRole.bind(this, "my")} className='d-flex w-half p-r-12'>
                                <input type="radio" name="content-role" checked={ContentRole == "my"} className='flex-item cursor-pointer m-r-6' />
                                <p className='filter-type-text'>My Content</p>
                              </div>
                              <div onClick={handleContentRole.bind(this, "branch")} className='d-flex w-half p-r-12'>
                                <input type="radio" name="content-role" checked={ContentRole == "branch"} className='flex-item cursor-pointer m-r-6' />
                                <p className='filter-type-text'>Branch Content</p>
                              </div>
                            </div>
                            <div onClick={handleContentRole.bind(this, "instafit")} className='d-flex w-half'>
                              <input type="radio" name="content-role" checked={ContentRole == "instafit"} className='flex-item cursor-pointer m-r-6' />
                              <p className='filter-type-text'>Workout Plus Content</p>
                            </div>

                            {
                              selectedGym && [
                                <div className='d-flex'>
                                  <div className='d-flex m-t-20'>
                                    <p className='filter-heading-text m-r-12 flex-item'>Selected Gym</p>
                                    <svg onClick={toggleContentFilter.bind(this, "gym")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                    </svg>
                                    <span className="m-l-4 m-r-4 flex-item"></span>
                                    <svg role={`button`} onClick={handleClearGym} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                    </svg>
                                  </div>
                                </div>,
                                <div className="d-flex w-full m-t-8">
                                  {
                                    selectedGym.logoFileID ? (
                                      <img className="flex-item m-r-8 branch-gym-logo" style={{ width: 40, height: 40 }} src={`${config.API_URL}${config.prefixStream}/media/file/${selectedGym.logoFileID}`} />
                                    ) : (
                                      <div className="d-flex flex-item m-r-8 branch-gym-logo" style={{ background: selectedGym.logoPlaceholderColor ? selectedGym.logoPlaceholderColor : "#5d883c" }}>
                                        <p className="flex-item" style={{ margin: '0 auto', color: '#ffffff' }}>{`${selectedGym.name}`.trim()[0]}</p>
                                      </div>
                                    )
                                  }
                                  <div className="flex-item">
                                    <p className="branch-gym-name">{selectedGym.name}</p>
                                    <p className="branch-gym-email">{selectedGym.email}</p>
                                  </div>
                                </div>
                              ]
                            }

                            {
                              (selectedGym && branchIDs.length == 0) && [
                                <div onClick={toggleContentFilter.bind(this, "branch")} className='member-button-global btn-center d-flex m-t-16' style={{ width: "46%" }}>
                                  <p className='flex-item'>Select Branch</p>
                                </div>
                              ]
                            }

                            {
                              branchIDs.length > 0 && [
                                <div className='d-flex'>
                                  <div className='d-flex m-t-20'>
                                    <p className='filter-heading-text m-r-12 flex-item'>Selected Branch</p>
                                    <svg onClick={toggleContentFilter.bind(this, "branch")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                    </svg>
                                    <span className="m-l-4 m-r-4 flex-item"></span>
                                    <svg role={`button`} onClick={handleClearBranch} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                    </svg>
                                  </div>
                                </div>,
                                <div className="w-full m-t-8">
                                  <p className="branch-gym-name">{`${branchIDs.length} Branch(s) Selected`}</p>
                                </div>
                              ]
                            }

                            {
                              (sortExerciseTypeIDs.length > 0) && [
                                <div className='d-flex'>
                                  <div className='d-flex m-t-20 m-b-8'>
                                    <p className='filter-heading-text m-r-12 flex-item'>Exercise Type</p>
                                    <svg onClick={toggleContentFilter.bind(this, "exercise-type")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                    </svg>
                                    <span className="m-l-4 m-r-4 flex-item"></span>
                                    <svg onClick={clearExerciseTypes} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                    </svg>
                                  </div>
                                </div>,
                                <p className="flex-item">{`${sortExerciseTypeIDs.length} Exercise Type(s) Selected`}</p>
                              ]
                            }


                            {
                              (sortTargetMuscleIDs.length > 0) && [
                                <div className='d-flex'>
                                  <div className='d-flex m-t-20 m-b-8'>
                                    <p className='filter-heading-text m-r-12 flex-item'>Muscle Type</p>
                                    <svg onClick={toggleContentFilter.bind(this, "muscle-type")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                    </svg>
                                    <span className="m-l-4 m-r-4 flex-item"></span>
                                    <svg onClick={clearTargetMuscles} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                    </svg>
                                  </div>
                                </div>,
                                <p className="flex-item">{`${sortTargetMuscleIDs.length} Muscle Type(s) Selected`}</p>
                              ]
                            }

                            {
                              sortExerciseLevelIDs.length > 0 && [
                                <div className='d-flex'>
                                  <div className='d-flex m-t-20 m-b-8'>
                                    <p className='filter-heading-text m-r-12 flex-item'>Exercise Level</p>
                                    <svg onClick={toggleContentFilter.bind(this, "exercise-level")} className='flex-item' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.6448 1.57501C9.82628 1.38773 10.0432 1.23843 10.2829 1.1358C10.5227 1.03316 10.7804 0.979254 11.0412 0.977203C11.302 0.975152 11.5606 1.025 11.8019 1.12385C12.0432 1.2227 12.2624 1.36857 12.4468 1.55297C12.6312 1.73737 12.7771 1.95661 12.876 2.19793C12.9748 2.43925 13.0247 2.69783 13.0226 2.9586C13.0206 3.21938 12.9666 3.47713 12.864 3.71687C12.7614 3.95661 12.6121 4.17353 12.4248 4.35501L11.6548 5.12501L8.8748 2.34501L9.6448 1.57501V1.57501ZM8.3448 2.87501L2.2513 8.96851C2.0313 9.18851 1.8713 9.46151 1.7873 9.76151L1.0138 12.524C0.995931 12.588 0.995405 12.6557 1.01228 12.72C1.02916 12.7843 1.06282 12.843 1.10983 12.89C1.15685 12.937 1.21551 12.9707 1.27982 12.9875C1.34413 13.0044 1.41176 13.0039 1.4758 12.986L4.2378 12.2125C4.53777 12.1286 4.81105 11.9688 5.0313 11.7485L11.1253 5.65551L8.3453 2.87551L8.3448 2.87501Z" fill="var(--darkBlue)" />
                                    </svg>
                                    <span className="m-l-4 m-r-4 flex-item"></span>
                                    <svg onClick={clearExerciseLevels} className="flex-item" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M9.42402 4.79883H8.57852C8.50117 4.79883 8.43789 4.86211 8.43789 4.93946V9.77871C8.43789 9.82442 8.45898 9.8666 8.4959 9.89297L11.4016 12.0147C11.4648 12.0604 11.5527 12.048 11.5984 11.9848L12.1012 11.2992C12.1486 11.2342 12.1346 11.1463 12.0713 11.1023L9.56465 9.29004V4.93946C9.56465 4.86211 9.50137 4.79883 9.42402 4.79883ZM13.2877 6.12071L16.0439 6.79395C16.1318 6.81504 16.218 6.74824 16.218 6.6586L16.232 3.81973C16.232 3.70196 16.0967 3.63516 16.0053 3.70899L13.235 5.87285C13.214 5.88905 13.1981 5.91083 13.189 5.93568C13.1799 5.96054 13.1779 5.98746 13.1835 6.01335C13.189 6.03924 13.2017 6.06305 13.2201 6.08204C13.2386 6.10103 13.262 6.11444 13.2877 6.12071ZM16.2355 11.4135L15.2389 11.0707C15.2041 11.0588 15.1661 11.061 15.1329 11.0767C15.0997 11.0925 15.074 11.1206 15.0613 11.1551C15.0279 11.2447 14.9928 11.3326 14.9559 11.4205C14.643 12.1605 14.1947 12.8268 13.6217 13.398C13.055 13.9665 12.3834 14.4196 11.6441 14.7322C10.8783 15.056 10.0551 15.2222 9.22363 15.2209C8.3834 15.2209 7.56953 15.0574 6.80312 14.7322C6.06386 14.4196 5.39227 13.9665 4.82559 13.398C4.2543 12.8268 3.80605 12.1605 3.49141 11.4205C3.1694 10.6543 3.00443 9.83117 3.00625 9C3.00625 8.15977 3.16973 7.34414 3.49492 6.57774C3.80781 5.8377 4.25605 5.17149 4.8291 4.6002C5.39579 4.03175 6.06737 3.57866 6.80664 3.26602C7.56953 2.94082 8.38516 2.77735 9.22539 2.77735C10.0656 2.77735 10.8795 2.94082 11.6459 3.26602C12.3852 3.57866 13.0568 4.03175 13.6234 4.6002C13.8027 4.78125 13.9715 4.96934 14.1262 5.16797L15.1773 4.34531C13.7939 2.57696 11.6406 1.43965 9.22187 1.44141C5.01016 1.44317 1.62812 4.86387 1.67031 9.07735C1.7125 13.217 5.07871 16.5586 9.22539 16.5586C12.4861 16.5586 15.2635 14.4914 16.3217 11.5963C16.348 11.5225 16.3094 11.4398 16.2355 11.4135Z" fill="var(--darkBlue)" />
                                    </svg>
                                  </div>
                                </div>,
                                <p className="flex-item">{`${sortExerciseLevelIDs.length} Exercise Level Selected`}</p>
                              ]
                            }

                            <div className="w-full m-t-20 d-flex-wrap">
                              {
                                ((ContentRole == "gym" || ContentRole == "branch") && !selectedGym) && <div onClick={toggleContentFilter.bind(this, "gym")} className='member-button-global btn-center d-flex' style={{ width: "46%", margin: "2%" }}>
                                  <p className='flex-item'>Add Gym</p>
                                </div>
                              }

                              {!sortExerciseTypeIDs.length && <div onClick={toggleContentFilter.bind(this, "exercise-type")} className='member-button-global btn-center d-flex' style={{ width: "46%", margin: "2%" }}>
                                <p className='flex-item'>Exercise Type</p>
                              </div>}

                              {!sortTargetMuscleIDs.length && <div onClick={toggleContentFilter.bind(this, "muscle-type")} className='member-button-global btn-center w-half d-flex' style={{ width: "46%", margin: "2%" }}>
                                <p className='flex-item'>Muscle Type</p>
                              </div>}

                              {!sortExerciseLevelIDs.length && <div onClick={toggleContentFilter.bind(this, "exercise-level")} className='member-button-global btn-center d-flex' style={{ width: "46%", margin: "2%" }}>
                                <p className='flex-item'>Exercise Level</p>
                              </div>}

                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  )
                }

                {
                  isContentFilter == "exercise-type" && (
                    <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                      <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                        <div className='flex-item d-flex m-b-20'>
                          <div onClick={() => toggleContentFilter("exercise-type")} className="d-flex desktop-modal-close-button m-r-12">
                            <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                            </svg>
                          </div>
                          <p className="flex-item modal-header-text">Filter Content</p>
                        </div>
                        <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                          <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                            <p className="flex-item modal-header-text">Exercise Type</p>

                          </div>
                          <div className='search-gym-modal-scroll'>
                            <div className="d-flex-wrap w-full m-t-12">
                              {
                                exerciseTypes.map(data => {
                                  return (
                                    <div onClick={handleTempIDs(data._id)} className={`global-button-container ${tempIDs.findIndex(id => id == data._id) != -1 && `global-button-container-active`} d-flex flex-item p-l-12 p-r-12 m-r-16 m-b-16`}>
                                      <p className='flex-item'>{data.name}</p>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                          <div className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                            <div className="flex-item d-flex">
                              <div onClick={toggleContentFilter.bind(this)} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                                <p className='flex-item'>Cancel</p>
                              </div>
                              {
                                tempIDs.length > 0 && <div onClick={confirmTempSelectionIDs} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 14px" }}>
                                  <p className='flex-item'>Add</p>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

                {
                  isContentFilter == "muscle-type" && (
                    <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                      <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                        <div className='flex-item d-flex m-b-20'>
                          <div onClick={() => toggleContentFilter("muscle-type")} className="d-flex desktop-modal-close-button m-r-12">
                            <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                            </svg>
                          </div>
                          <p className="flex-item modal-header-text">Filter Content</p>
                        </div>
                        <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                          <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                            <p className="flex-item modal-header-text">Muscle Type</p>

                          </div>
                          <div className='search-gym-modal-scroll'>
                            <div className="d-flex-wrap w-full m-t-12">
                              {
                                targetMuscles.map(data => {
                                  return (
                                    <div onClick={handleTempIDs(data._id)} className={`global-button-container ${tempIDs.findIndex(id => id == data._id) != -1 && `global-button-container-active`} d-flex flex-item p-l-12 p-r-12 m-r-16 m-b-16`}>
                                      <p className='flex-item'>{data.name}</p>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                          <div className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                            <div className="flex-item d-flex">
                              <div onClick={toggleContentFilter.bind(this)} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                                <p className='flex-item'>Cancel</p>
                              </div>
                              {
                                tempIDs.length > 0 &&
                                <div onClick={confirmTempSelectionIDs} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 14px" }}>
                                  <p className='flex-item'>Add</p>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

                {
                  isContentFilter == "exercise-level" && (
                    <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                      <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                        <div className='flex-item d-flex m-b-20'>
                          <div onClick={() => toggleContentFilter("exercise-level")} className="d-flex desktop-modal-close-button m-r-12">
                            <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                            </svg>
                          </div>
                          <p className="flex-item modal-header-text">Filter Content</p>
                        </div>
                        <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                          <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                            <p className="flex-item modal-header-text">Exercise Level</p>
                          </div>
                          <div className='search-gym-modal-scroll'>
                            <div className="d-flex-wrap w-full m-t-12">
                              {
                                exerciseLevels.map(data => {
                                  return (
                                    <div onClick={handleTempIDs(data._id)} className={`global-button-container ${tempIDs.findIndex(id => id == data._id) != -1 && `global-button-container-active`} d-flex flex-item p-l-12 p-r-12 m-r-16 m-b-16`}>
                                      <p className='flex-item'>{data.name}</p>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                          <div className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                            <div className="flex-item d-flex">
                              <div onClick={toggleContentFilter.bind(this)} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                                <p className='flex-item'>Cancel</p>
                              </div>
                              {
                                tempIDs.length > 0 &&
                                <div onClick={confirmTempSelectionIDs} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 14px" }}>
                                  <p className='flex-item'>Add</p>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

                {
                  isContentFilter == "branch" && (
                    <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                      <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                        <div className='flex-item d-flex m-b-20'>
                          <div onClick={() => toggleContentFilter("branch")} className="d-flex desktop-modal-close-button m-r-12">
                            <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                            </svg>
                          </div>
                          <p className="flex-item modal-header-text">Filter Content</p>
                        </div>
                        <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                          <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                            <p className="flex-item modal-header-text">Select Branch</p>
                            <div id="search-container-gym" className='global-search-box flex-item' style={{ background: "#f5f5f5", width: "50%" }}>
                              <svg id="search-icon-gym" className='flex-item m-b-3' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1637_1318)">
                                  <path d="M11.7429 10.344C12.7112 9.0227 13.1449 7.3845 12.9572 5.75716C12.7695 4.12982 11.9743 2.63335 10.7307 1.56714C9.48701 0.50093 7.88665 -0.0563875 6.24973 0.00668566C4.61282 0.0697588 3.06008 0.748571 1.90217 1.90732C0.744249 3.06606 0.0665484 4.61929 0.00464653 6.25624C-0.0572553 7.8932 0.501207 9.49317 1.56831 10.7361C2.6354 11.9789 4.13244 12.7731 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0004C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.50001C12.0009 7.22228 11.8586 7.93748 11.5822 8.60477C11.3058 9.27206 10.9007 9.87837 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87837 1.69596 9.27206 1.41956 8.60477C1.14316 7.93748 1.0009 7.22228 1.0009 6.50001C1.0009 5.04132 1.58036 3.64237 2.61181 2.61092C3.64326 1.57947 5.04221 1.00001 6.5009 1.00001C7.95959 1.00001 9.35853 1.57947 10.39 2.61092C11.4214 3.64237 12.0009 5.04132 12.0009 6.50001Z" fill="#6D6D6D" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1637_1318">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <input id="search-branch-input" onChange={_.debounce(handleBranchSearch, 1000)} className='flex-item' type="text" placeholder="Search" style={{ background: "#f5f5f5" }} />
                            </div>
                          </div>
                          <div className='search-gym-modal-scroll' onScroll={handleBranchScroll}>
                            <div className="d-flex-wrap w-full m-t-12">
                              {
                                Branches.map(data => {
                                  return (
                                    <div onClick={handleTempIDs(data._id)} className={`global-button-container ${tempIDs.findIndex(id => id == data._id) != -1 && `global-button-container-active`} d-flex flex-item p-l-12 p-r-12 m-r-16 m-b-16`}>
                                      <p className='flex-item'>{data.name}</p>
                                    </div>
                                  )
                                })
                              }
                            </div>
                            {isBrachSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                          </div>
                          <div className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                            <div className="flex-item d-flex">
                              <div onClick={toggleContentFilter.bind(this)} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                                <p className='flex-item'>Cancel</p>
                              </div>
                              {
                                tempIDs.length > 0 &&
                                <div onClick={confirmTempSelectionIDs} className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 14px" }}>
                                  <p className='flex-item'>Add</p>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

                {
                  isContentFilter == "gym" && (
                    <div className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                      <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "90%", minHeight: "90%", borderBottomRightRadius: "8px" }}>
                        <div className='flex-item d-flex m-b-20'>
                          <div onClick={() => toggleContentFilter("gym")} className="d-flex desktop-modal-close-button m-r-12">
                            <svg className='flex-item' width="8" height="15" viewBox="0 0 8 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.5 1L1 7.5L7.5 14.5" stroke="#6D6D6D" stroke-linecap="round" />
                            </svg>
                          </div>
                          <p className="flex-item modal-header-text">Filter Content</p>
                        </div>
                        <div onClick={e => e.stopPropagation()} className="w-full" style={{ textAlign: "left", alignItems: "flex-start", justifyContent: "left", float: "left", position: "relative", height: "36em", overflowY: "auto" }}>
                          <div className="d-flex w-full space-between global-modal-header-container" style={{ borderRadius: "8px 8px 0 0" }}>
                            <p className="flex-item modal-header-text">Select Gym</p>
                            <div id="search-container-gym" className='global-search-box flex-item' style={{ background: "#f5f5f5", width: "50%" }}>
                              <svg id="search-icon-gym" className='flex-item m-b-3' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1637_1318)">
                                  <path d="M11.7429 10.344C12.7112 9.0227 13.1449 7.3845 12.9572 5.75716C12.7695 4.12982 11.9743 2.63335 10.7307 1.56714C9.48701 0.50093 7.88665 -0.0563875 6.24973 0.00668566C4.61282 0.0697588 3.06008 0.748571 1.90217 1.90732C0.744249 3.06606 0.0665484 4.61929 0.00464653 6.25624C-0.0572553 7.8932 0.501207 9.49317 1.56831 10.7361C2.6354 11.9789 4.13244 12.7731 5.75992 12.9596C7.38739 13.1461 9.02528 12.7112 10.3459 11.742H10.3449C10.3749 11.782 10.4069 11.82 10.4429 11.857L14.2929 15.707C14.4804 15.8946 14.7348 16.0001 15 16.0002C15.2653 16.0003 15.5198 15.895 15.7074 15.7075C15.895 15.52 16.0005 15.2656 16.0006 15.0004C16.0007 14.7351 15.8954 14.4806 15.7079 14.293L11.8579 10.443C11.8221 10.4068 11.7837 10.3734 11.7429 10.343V10.344ZM12.0009 6.50001C12.0009 7.22228 11.8586 7.93748 11.5822 8.60477C11.3058 9.27206 10.9007 9.87837 10.39 10.3891C9.87926 10.8998 9.27295 11.3049 8.60566 11.5813C7.93837 11.8577 7.22317 12 6.5009 12C5.77863 12 5.06343 11.8577 4.39614 11.5813C3.72885 11.3049 3.12253 10.8998 2.61181 10.3891C2.10109 9.87837 1.69596 9.27206 1.41956 8.60477C1.14316 7.93748 1.0009 7.22228 1.0009 6.50001C1.0009 5.04132 1.58036 3.64237 2.61181 2.61092C3.64326 1.57947 5.04221 1.00001 6.5009 1.00001C7.95959 1.00001 9.35853 1.57947 10.39 2.61092C11.4214 3.64237 12.0009 5.04132 12.0009 6.50001Z" fill="#6D6D6D" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1637_1318">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              <input id="search-gym-input" onChange={_.debounce(handleGymSearch, 1000)} className='flex-item' type="text" placeholder="Search Gym" style={{ background: "#f5f5f5" }} />
                            </div>
                          </div>
                          <div className='search-gym-modal-scroll' onScroll={handleGymScroll}>
                            {
                              Gyms.map(data => {
                                return (
                                  <div onClick={handleSelectGym(data)} className="d-flex suggestion-list-items">
                                    {
                                      data.logoFileID ? (
                                        <img className="flex-item branch-gym-user-profile m-r-8" src={`${config.API_URL}${config.prefixStream}/media/file/${data.logoFileID}`} />
                                      ) : (
                                        <div className='d-flex flex-item branch-gym-user-profile m-r-8' style={{
                                          backgroundColor: data.logoPlaceholderColor ? data.logoPlaceholderColor : "#5d883c"
                                        }}>
                                          <p className='flex-item fs-14' style={{
                                            margin: '0 auto',
                                            color: "#ffffff"
                                          }}>{`${data.name}`.trim()[0]}</p>
                                        </div>
                                      )
                                    }
                                    <div className="flex-item">
                                      <p className="branch-gym-user-name m-b-1">{data.name}</p>
                                      <p className="branch-gym-details-value">{data.email}</p>
                                    </div>
                                  </div>
                                )
                              })
                            }
                            {isGymSpinnerLoader && <div className="loader-5 center"><span></span></div>}
                          </div>
                          <div onClick={toggleContentFilter.bind(this)} className='flex-item w-full p-r-12 p-b-12 p-t-12' style={{ position: "absolute", bottom: 0, right: 0, left: 0, background: "rgba(255, 255, 255, 0.90)", borderRadius: "0 0 8px 8px" }}>
                            <div className='member-button-global btn-center d-flex' style={{ width: "100px", margin: "0 0 0 auto" }}>
                              <p className='flex-item'>Cancel</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                }

              </div>
            ]
          }

          {
            currentWindow == "add-nutrition-planner" && (
              <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ padding: window.innerWidth > 767 ? "4px 12px 40px 12px" : "12px" }}>
                {!isEditActive ? [<div className='d-flex w-full m-b-12'>
                  <div className='d-flex margin-auto'>
                    {
                      dayStorage.Days.filter(d=>nutritionPlanner.findIndex(data=>data.dayName == d.name) == -1).map((data, index) => {
                        return(
                            <div onClick={() => handleSelectPlannerDay("nutrition", data.name)} className={`${data.isSelected ? "day-chips day-chips-active" : "day-chips"} ${dayStorage.Days.length != index + 1 && "m-r-10"} d-flex cursor-pointer` } style={{width:"50px", height: "30px", padding: "0"}}>
                              <p className='flex-item' style={{margin:"0 auto"}}>{data.name}</p>
                            </div>
                          )
                        }
                      )
                    }
                  </div>
                </div>,
                <div className='d-flex w-full'>
                  <div className='d-flex margin-auto'>
                    <svg className='flex-item m-r-8' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 5.8H9.0064M9 12.2V8.2M17 9C17 13.4184 13.4184 17 9 17C4.5816 17 1 13.4184 1 9C1 4.5816 4.5816 1 9 1C13.4184 1 17 4.5816 17 9Z" stroke="#B6B6B6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p className='flex-item color-grey-07'>You can select multiple days & plan for nutrition</p>
                  </div>
                </div>]:(
                    <div className="w-full global-modal-header-container" style={{backgroundColor:'white'}}>
                      <div className='d-flex space-between'>
                        <div className='flex-item' style={{textAlign:"left"}}>
                          <p className='day-workout-txt'>{"Edit "+(dayStorage.Days.find(d=>d.isSelected)?dayStorage.Days.find(d=>d.isSelected).name:"") }</p>
                          <p className='day-workout-sub-txt m-t-4'>{'Updating nutrition'}</p>
                        </div>
                        <div className='d-flex m-r-8' style={{alignSelf:"flex-start"}}>
                      
                        </div>
                      </div>
                  </div>
              
                )}
                <div className='d-flex w-full m-t-12 m-b-20'>
                  <p className='flex-item margin-auto fs-18 font-weight-600 color-red d-flex m-b-12'>Planning For <span className='flex-item m-l-5'>{handleSelectedDays("long")}</span></p>
                </div>
                {
                  nutritionCarrier.map((data, parentIndex) => {
                    return(
                      <div className='nutrition-meal-add-container w-full m-b-8'>
                        <div className='d-flex w-full'>
                          <div onClick={toggleInputFields("meal-name")} className={`${(currentElementId == "meal-name" || data.mealName) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-r-12`} style={{ border: (currentElementId == "meal-name" || data.mealName) ? "1px solid var(--darkBlue)" : "", width: "55%"}}>
                            <div className="flex-item d-flex">
                              <svg className='m-r-4 flex-item' width={(currentElementId == "meal-name" || data.mealName) ? "12" : "18"} height={(currentElementId == "meal-name" || data.mealName) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.63747 3.29655e-06C0.939949 3.29655e-06 0.348759 0.522753 0.276456 1.22188C0.171544 2.21921 0 4.02475 0 5.13542C0 6.18375 0.480608 7.12017 1.23129 7.73642C1.47797 7.939 1.59494 8.16142 1.59494 8.34842V8.81734L1.59423 8.85063C1.56516 9.27492 1.24051 14.0122 1.24051 14.875C1.24051 15.1541 1.29551 15.4304 1.40238 15.6882C1.50925 15.946 1.6659 16.1803 1.86337 16.3776C2.06084 16.5749 2.29527 16.7315 2.55328 16.8382C2.81129 16.945 3.08782 17 3.36709 17C3.64636 17 3.92289 16.945 4.1809 16.8382C4.43891 16.7315 4.67334 16.5749 4.87081 16.3776C5.06828 16.1803 5.22492 15.946 5.33179 15.6882C5.43867 15.4304 5.49367 15.1541 5.49367 14.875C5.49367 14.0122 5.16972 9.27492 5.13995 8.85063L5.13924 8.81734V8.34842C5.13924 8.16071 5.2562 7.939 5.50289 7.73642C5.88819 7.42115 6.19855 7.02424 6.4115 6.5744C6.62444 6.12456 6.73466 5.63305 6.73418 5.13542C6.73418 4.02475 6.56263 2.21921 6.45772 1.22188C6.4223 0.88606 6.26356 0.575283 6.01218 0.349605C5.76081 0.123927 5.43464 -0.000630412 5.09671 3.29655e-06C4.77276 3.29655e-06 4.47433 0.11192 4.23899 0.299628C3.98988 0.105469 3.68301 1.42686e-05 3.36709 3.29655e-06C3.05116 1.42686e-05 2.7443 0.105469 2.49519 0.299628C2.25179 0.105028 1.94919 -0.000680481 1.63747 3.29655e-06ZM3.01266 1.41667C3.01266 1.32274 3.05 1.23266 3.11647 1.16624C3.18294 1.09982 3.27309 1.0625 3.36709 1.0625C3.46109 1.0625 3.55124 1.09982 3.61771 1.16624C3.68418 1.23266 3.72152 1.32274 3.72152 1.41667V5.13542C3.72152 5.27632 3.77753 5.41144 3.87723 5.51107C3.97694 5.6107 4.11216 5.66667 4.25316 5.66667C4.39417 5.66667 4.52939 5.6107 4.62909 5.51107C4.7288 5.41144 4.78481 5.27632 4.78481 5.13542V1.37417C4.78481 1.29151 4.81767 1.21224 4.87616 1.15379C4.93466 1.09534 5.01399 1.0625 5.09671 1.0625C5.2562 1.0625 5.38522 1.18079 5.40081 1.33238C5.50572 2.33821 5.67089 4.08921 5.67089 5.13542C5.67139 5.47603 5.59602 5.81248 5.45024 6.12036C5.30446 6.42825 5.09192 6.69985 4.82805 6.91546C4.44668 7.22854 4.07595 7.72296 4.07595 8.34842V8.81734C4.07595 8.85275 4.07666 8.88533 4.07949 8.92358C4.11068 9.38046 4.43038 14.0597 4.43038 14.875C4.43038 15.1568 4.31836 15.427 4.11895 15.6263C3.91954 15.8256 3.64909 15.9375 3.36709 15.9375C3.08509 15.9375 2.81463 15.8256 2.61523 15.6263C2.41582 15.427 2.3038 15.1568 2.3038 14.875C2.3038 14.0604 2.62278 9.38046 2.65468 8.92358C2.65752 8.88533 2.65823 8.85275 2.65823 8.81734V8.34842C2.65823 7.72225 2.28749 7.22854 1.90613 6.91546C1.64225 6.69985 1.42972 6.42825 1.28394 6.12036C1.13816 5.81248 1.06279 5.47603 1.06329 5.13542C1.06329 4.08921 1.22846 2.33892 1.33337 1.33238C1.34146 1.25769 1.37708 1.18868 1.4333 1.1388C1.48951 1.08891 1.56229 1.06171 1.63747 1.0625C1.72019 1.0625 1.79952 1.09534 1.85801 1.15379C1.91651 1.21224 1.94937 1.29151 1.94937 1.37417V5.13542C1.94937 5.27632 2.00538 5.41144 2.10508 5.51107C2.20479 5.6107 2.34001 5.66667 2.48101 5.66667C2.62201 5.66667 2.75724 5.6107 2.85694 5.51107C2.95665 5.41144 3.01266 5.27632 3.01266 5.13542V1.41667ZM12.5823 1.06675V7.96875C12.5823 8.21667 12.6489 9.38329 12.7226 10.6675L12.7269 10.7419C12.8261 12.4674 12.9367 14.4004 12.9367 14.875C12.9367 15.1568 12.8247 15.427 12.6253 15.6263C12.4259 15.8256 12.1554 15.9375 11.8734 15.9375C11.5914 15.9375 11.321 15.8256 11.1216 15.6263C10.9222 15.427 10.8101 15.1568 10.8101 14.875C10.8101 14.4535 10.8973 12.7479 10.9866 11.1208C11.0389 10.1673 11.0928 9.21391 11.1483 8.26058L11.1638 7.99992L11.1646 7.96875C11.1646 7.82786 11.1085 7.69273 11.0088 7.5931C10.9091 7.49347 10.7739 7.4375 10.6329 7.4375H9.21519C9.16819 7.4375 9.12311 7.41885 9.08988 7.38564C9.05665 7.35243 9.03797 7.30738 9.03797 7.26042V4.78125C9.03798 3.82564 9.40614 2.90671 10.0661 2.21509C10.726 1.52347 11.627 1.11226 12.5823 1.06675ZM10.0694 8.5L10.0467 8.89384C10.0134 9.47254 9.96871 10.2538 9.92476 11.0628C9.83686 12.6685 9.74684 14.416 9.74684 14.875C9.74684 15.1541 9.80184 15.4304 9.90871 15.6882C10.0156 15.946 10.1722 16.1803 10.3697 16.3776C10.5672 16.5749 10.8016 16.7315 11.0596 16.8382C11.3176 16.945 11.5942 17 11.8734 17C12.1527 17 12.4292 16.945 12.6872 16.8382C12.9452 16.7315 13.1797 16.5749 13.3771 16.3776C13.5746 16.1803 13.7313 15.946 13.8381 15.6882C13.945 15.4304 14 15.1541 14 14.875C14 14.3643 13.888 12.4143 13.7916 10.7277L13.7888 10.681C13.7115 9.33584 13.6456 8.18125 13.6456 7.96875V0.531253C13.6456 0.390357 13.5896 0.255231 13.4899 0.155603C13.3902 0.055974 13.2549 3.29655e-06 13.1139 3.29655e-06H12.7595C11.4905 3.29655e-06 10.2734 0.503741 9.37612 1.4004C8.4788 2.29706 7.97468 3.51319 7.97468 4.78125V7.26042C7.97468 7.94467 8.53043 8.5 9.21519 8.5H10.0694Z" fill={currentElementId == "meal-name" || data.mealName ? "var(--darkBlue)" : "#6d6d6d"}/>
                              </svg>
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "meal-name" || data.mealName) ? "10px" : "14px", color: (currentElementId == "meal-name" || data.mealName) ? "var(--darkBlue)" : "", transition: "180ms" }}>Meal Name</p>
                            </div>
                            <input onChange={handleNutritionCarrierData("mealName",parentIndex)} id="meal-name" value={data.mealName} className={`${(currentElementId == "meal-name" || data.mealName) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Enter Meal Name" style={{ textTransform: 'capitalize' }} />
                          </div>
                          <div id={'time-wrapper'+parentIndex} onClick={handleTimeSelect(parentIndex)} className={`${(currentElementId == "meal-time" || data.mealTime) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == "meal-time" || data.mealTime) ? "1px solid var(--darkBlue)" : "", width: "84px"}}>
                            <div className="flex-item d-flex">
                              <svg className='m-r-4 flex-item' width={(currentElementId == "meal-time" || data.mealTime) ? "12" : "18"} height={(currentElementId == "meal-time" || data.mealTime) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 3.5V8L11 9.5M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z" stroke={currentElementId == "meal-time" || data.mealTime ? "var(--darkBlue)" : "#6d6d6d"} stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "meal-time" || data.mealTime) ? "10px" : "14px", color: (currentElementId == "meal-time" || data.mealTime) ? "var(--darkBlue)" : "", transition: "180ms" }}>Time</p>
                            </div>
                            <input id="meal-time" value={data.mealTime} className={`${(currentElementId == "meal-time" || data.mealTime) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="00:00" style={{ textTransform: 'capitalize' }} />
                          </div>
                          <div onClick={()=>handleDeleteNutritionMeal(parentIndex)} className='delete-meal d-flex' style={{marginLeft:"auto"}}>
                            <svg className='flex-item svg-stoke margin-auto' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L13 13M1 13L13 1" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <svg className='m-t-12 m-b-12' width="100%" height="auto" viewBox="0 0 380 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <line y1="1" x2="380.001" y2="1" stroke="#CECECE" stroke-dasharray="4 4"/>
                        </svg>
                        <div className='d-flex m-b-12'>
                          <p className='flex-item m-r-8 fs-16 font-weight-700'>Foods</p>
                          <div onClick={()=>handleAddNutritionContent(parentIndex)} className="bell-menu-container cursor-pointer d-flex bg-dark-blue" style={{position: "relative"}}>
                            <svg className="menu flex-item" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect x="6.61328" width="2" height="15" rx="1" fill="#ffffff" />
                              <rect x="15.1035" y="6.43555" width="2" height="15" rx="1" transform="rotate(89.5058 15.1035 6.43555)" fill="#ffffff" />
                            </svg>
                          </div>
                        </div>
                        {
                          data.contents && data.contents.map((content, childIndex) => {
                            return(
                              <div className={`${data.contents && data.contents.length !=  childIndex + 1 && 'm-b-12'} nutrition-content-container w-full`}>
                                <div className='nutrition-content-header w-full'>
                                  <div className='d-flex w-full flex-item space-between'>
                                    <div className='flex-item d-flex'>
                                      <p className='flex-item m-r-8 color-white font-weight-600'>{content.content.name}</p>
                                      {/* <svg className='flex-item' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.02504 13.602C5.73081 10.327 8.6812 8 12 8C15.3188 8 18.2682 10.327 18.975 13.602C19.003 13.732 19.0832 13.8458 19.1981 13.9186C19.313 13.9914 19.4531 14.0171 19.5876 13.99C19.7221 13.9629 19.8399 13.8854 19.9152 13.7744C19.9905 13.6633 20.0171 13.528 19.9891 13.398C19.185 9.673 15.8217 7 12 7C8.17826 7 4.81496 9.673 4.01087 13.398C3.98288 13.528 4.00945 13.6633 4.08475 13.7744C4.16005 13.8854 4.27791 13.9629 4.4124 13.99C4.54688 14.0171 4.68698 13.9914 4.80188 13.9186C4.91677 13.8458 4.99704 13.732 5.02504 13.602ZM11.9897 10C12.9503 10 13.8715 10.3687 14.5508 11.0251C15.2301 11.6815 15.6117 12.5717 15.6117 13.5C15.6117 14.4283 15.2301 15.3185 14.5508 15.9749C13.8715 16.6313 12.9503 17 11.9897 17C11.029 17 10.1078 16.6313 9.4285 15.9749C8.74924 15.3185 8.36764 14.4283 8.36764 13.5C8.36764 12.5717 8.74924 11.6815 9.4285 11.0251C10.1078 10.3687 11.029 10 11.9897 10Z" fill="white"/>
                                      </svg> */}
                                    </div>
                                    <div className='flex-item d-flex'>
                                      <div onClick={()=>handleChangeNutritionContent(parentIndex, childIndex)} className="bell-menu-container cursor-pointer d-flex m-r-12">
                                        <svg className="fill-svg flex-item" width="16" height="16" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M4.54883 8.875C3.32758 8.875 2.29299 8.45146 1.44508 7.60437C0.597578 6.75687 0.173828 5.72271 0.173828 4.50188C0.173828 3.28104 0.597578 2.24646 1.44508 1.39813C2.29258 0.549792 3.32716 0.125417 4.54883 0.125C5.29174 0.125 5.98737 0.301458 6.6357 0.654375C7.28362 1.00729 7.80591 1.5 8.20258 2.1325V0.125H8.82758V3.39375H5.55883V2.76875H7.87133C7.54549 2.14583 7.08758 1.65354 6.49758 1.29188C5.90758 0.930208 5.25799 0.749583 4.54883 0.75C3.50716 0.75 2.62174 1.11458 1.89258 1.84375C1.16341 2.57292 0.798828 3.45833 0.798828 4.5C0.798828 5.54167 1.16341 6.42708 1.89258 7.15625C2.62174 7.88542 3.50716 8.25 4.54883 8.25C5.35091 8.25 6.07487 8.02083 6.7207 7.5625C7.36654 7.10417 7.81966 6.5 8.08008 5.75H8.74383C8.46799 6.68583 7.94424 7.44062 7.17258 8.01437C6.40091 8.58812 5.52633 8.875 4.54883 8.875Z" fill="black"/>
                                        </svg>
                                      </div>
                                      <div onClick={()=>handleDeleteNutritionContent(parentIndex, childIndex)} className="bell-menu-container cursor-pointer d-flex">
                                        <svg className="fill-svg flex-item" width="16" height="16" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1.76 10.4998C1.48 10.4998 1.24167 10.4015 1.045 10.2048C0.848333 10.0081 0.75 9.77001 0.75 9.49043V1.7498H0.125V1.1248H2.625V0.643555H6.375V1.1248H8.875V1.7498H8.25V9.49043C8.25 9.77793 8.15375 10.0181 7.96125 10.2111C7.76875 10.404 7.52833 10.5002 7.24 10.4998H1.76ZM7.625 1.7498H1.375V9.49043C1.375 9.60251 1.41104 9.6946 1.48312 9.76668C1.55521 9.83876 1.6475 9.8748 1.76 9.8748H7.24063C7.33646 9.8748 7.42458 9.83481 7.505 9.75481C7.58542 9.67481 7.62542 9.58647 7.625 9.48981V1.7498ZM3.13 8.6248H3.755V2.9998H3.13V8.6248ZM5.245 8.6248H5.87V2.9998H5.245V8.6248Z" fill="black"/>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className='nutrition-content-body space-between d-flex'>
                                  <div className='nutrition-content-image'>
                                    <img className='flex-item w-full h-full' alt='Nutrition Content Image' src={`${config.API_URL}${config.prefixStream}/media/file/${content.content.nutritionGuides[0].foodImageId}`} />
                                  </div>
                                  <div className='flex-item' style={{width:"57%"}}>
                                    <div onClick={toggleInputFields(`serving-size-${childIndex}`)} className={`${(currentElementId == `serving-size-${childIndex}` || content.servingSize) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == `serving-size-${childIndex}` || content.servingSize) ? "1px solid var(--darkBlue)" : ""}}>
                                      <div className="flex-item d-flex">
                                        <svg className='m-r-4 flex-item' width={(currentElementId == `serving-size-${childIndex}` || content.servingSize) ? "12" : "18"} height={(currentElementId == `serving-size-${childIndex}` || content.servingSize) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1.63747 3.29655e-06C0.939949 3.29655e-06 0.348759 0.522753 0.276456 1.22188C0.171544 2.21921 0 4.02475 0 5.13542C0 6.18375 0.480608 7.12017 1.23129 7.73642C1.47797 7.939 1.59494 8.16142 1.59494 8.34842V8.81734L1.59423 8.85063C1.56516 9.27492 1.24051 14.0122 1.24051 14.875C1.24051 15.1541 1.29551 15.4304 1.40238 15.6882C1.50925 15.946 1.6659 16.1803 1.86337 16.3776C2.06084 16.5749 2.29527 16.7315 2.55328 16.8382C2.81129 16.945 3.08782 17 3.36709 17C3.64636 17 3.92289 16.945 4.1809 16.8382C4.43891 16.7315 4.67334 16.5749 4.87081 16.3776C5.06828 16.1803 5.22492 15.946 5.33179 15.6882C5.43867 15.4304 5.49367 15.1541 5.49367 14.875C5.49367 14.0122 5.16972 9.27492 5.13995 8.85063L5.13924 8.81734V8.34842C5.13924 8.16071 5.2562 7.939 5.50289 7.73642C5.88819 7.42115 6.19855 7.02424 6.4115 6.5744C6.62444 6.12456 6.73466 5.63305 6.73418 5.13542C6.73418 4.02475 6.56263 2.21921 6.45772 1.22188C6.4223 0.88606 6.26356 0.575283 6.01218 0.349605C5.76081 0.123927 5.43464 -0.000630412 5.09671 3.29655e-06C4.77276 3.29655e-06 4.47433 0.11192 4.23899 0.299628C3.98988 0.105469 3.68301 1.42686e-05 3.36709 3.29655e-06C3.05116 1.42686e-05 2.7443 0.105469 2.49519 0.299628C2.25179 0.105028 1.94919 -0.000680481 1.63747 3.29655e-06ZM3.01266 1.41667C3.01266 1.32274 3.05 1.23266 3.11647 1.16624C3.18294 1.09982 3.27309 1.0625 3.36709 1.0625C3.46109 1.0625 3.55124 1.09982 3.61771 1.16624C3.68418 1.23266 3.72152 1.32274 3.72152 1.41667V5.13542C3.72152 5.27632 3.77753 5.41144 3.87723 5.51107C3.97694 5.6107 4.11216 5.66667 4.25316 5.66667C4.39417 5.66667 4.52939 5.6107 4.62909 5.51107C4.7288 5.41144 4.78481 5.27632 4.78481 5.13542V1.37417C4.78481 1.29151 4.81767 1.21224 4.87616 1.15379C4.93466 1.09534 5.01399 1.0625 5.09671 1.0625C5.2562 1.0625 5.38522 1.18079 5.40081 1.33238C5.50572 2.33821 5.67089 4.08921 5.67089 5.13542C5.67139 5.47603 5.59602 5.81248 5.45024 6.12036C5.30446 6.42825 5.09192 6.69985 4.82805 6.91546C4.44668 7.22854 4.07595 7.72296 4.07595 8.34842V8.81734C4.07595 8.85275 4.07666 8.88533 4.07949 8.92358C4.11068 9.38046 4.43038 14.0597 4.43038 14.875C4.43038 15.1568 4.31836 15.427 4.11895 15.6263C3.91954 15.8256 3.64909 15.9375 3.36709 15.9375C3.08509 15.9375 2.81463 15.8256 2.61523 15.6263C2.41582 15.427 2.3038 15.1568 2.3038 14.875C2.3038 14.0604 2.62278 9.38046 2.65468 8.92358C2.65752 8.88533 2.65823 8.85275 2.65823 8.81734V8.34842C2.65823 7.72225 2.28749 7.22854 1.90613 6.91546C1.64225 6.69985 1.42972 6.42825 1.28394 6.12036C1.13816 5.81248 1.06279 5.47603 1.06329 5.13542C1.06329 4.08921 1.22846 2.33892 1.33337 1.33238C1.34146 1.25769 1.37708 1.18868 1.4333 1.1388C1.48951 1.08891 1.56229 1.06171 1.63747 1.0625C1.72019 1.0625 1.79952 1.09534 1.85801 1.15379C1.91651 1.21224 1.94937 1.29151 1.94937 1.37417V5.13542C1.94937 5.27632 2.00538 5.41144 2.10508 5.51107C2.20479 5.6107 2.34001 5.66667 2.48101 5.66667C2.62201 5.66667 2.75724 5.6107 2.85694 5.51107C2.95665 5.41144 3.01266 5.27632 3.01266 5.13542V1.41667ZM12.5823 1.06675V7.96875C12.5823 8.21667 12.6489 9.38329 12.7226 10.6675L12.7269 10.7419C12.8261 12.4674 12.9367 14.4004 12.9367 14.875C12.9367 15.1568 12.8247 15.427 12.6253 15.6263C12.4259 15.8256 12.1554 15.9375 11.8734 15.9375C11.5914 15.9375 11.321 15.8256 11.1216 15.6263C10.9222 15.427 10.8101 15.1568 10.8101 14.875C10.8101 14.4535 10.8973 12.7479 10.9866 11.1208C11.0389 10.1673 11.0928 9.21391 11.1483 8.26058L11.1638 7.99992L11.1646 7.96875C11.1646 7.82786 11.1085 7.69273 11.0088 7.5931C10.9091 7.49347 10.7739 7.4375 10.6329 7.4375H9.21519C9.16819 7.4375 9.12311 7.41885 9.08988 7.38564C9.05665 7.35243 9.03797 7.30738 9.03797 7.26042V4.78125C9.03798 3.82564 9.40614 2.90671 10.0661 2.21509C10.726 1.52347 11.627 1.11226 12.5823 1.06675ZM10.0694 8.5L10.0467 8.89384C10.0134 9.47254 9.96871 10.2538 9.92476 11.0628C9.83686 12.6685 9.74684 14.416 9.74684 14.875C9.74684 15.1541 9.80184 15.4304 9.90871 15.6882C10.0156 15.946 10.1722 16.1803 10.3697 16.3776C10.5672 16.5749 10.8016 16.7315 11.0596 16.8382C11.3176 16.945 11.5942 17 11.8734 17C12.1527 17 12.4292 16.945 12.6872 16.8382C12.9452 16.7315 13.1797 16.5749 13.3771 16.3776C13.5746 16.1803 13.7313 15.946 13.8381 15.6882C13.945 15.4304 14 15.1541 14 14.875C14 14.3643 13.888 12.4143 13.7916 10.7277L13.7888 10.681C13.7115 9.33584 13.6456 8.18125 13.6456 7.96875V0.531253C13.6456 0.390357 13.5896 0.255231 13.4899 0.155603C13.3902 0.055974 13.2549 3.29655e-06 13.1139 3.29655e-06H12.7595C11.4905 3.29655e-06 10.2734 0.503741 9.37612 1.4004C8.4788 2.29706 7.97468 3.51319 7.97468 4.78125V7.26042C7.97468 7.94467 8.53043 8.5 9.21519 8.5H10.0694Z" fill={(currentElementId == `serving-size-${childIndex}` || content.servingSize) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                        </svg>
                                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == `serving-size-${childIndex}` || content.servingSize) ? "10px" : "14px", color: (currentElementId == `serving-size-${childIndex}` || content.servingSize) ? "var(--darkBlue)" : "", transition: "180ms" }}>Serving Size (g)</p>
                                      </div>
                                      <input id={`serving-size-${childIndex}`} value={content.servingSize} className={`${(currentElementId == `serving-size-${childIndex}` || content.servingSize) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder="Enter Serving Size" style={{ textTransform: 'capitalize' }} onInput={handleNutritionCarrierContent(parentIndex,childIndex,"servingSize")} />
                                    </div>
                                    <div onClick={toggleInputFields(`calorie-intake-${childIndex}`)} className={`${(currentElementId == `calorie-intake-${childIndex}` || content.calorie) ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: (currentElementId == `calorie-intake-${childIndex}` || content.calorie) ? "1px solid var(--darkBlue)" : ""}}>
                                      <div className="flex-item d-flex">
                                        <svg className='m-r-4 flex-item' width={(currentElementId == `calorie-intake-${childIndex}` || content.calorie) ? "12" : "18"} height={(currentElementId == `calorie-intake-${childIndex}` || content.calorie) ? "12" : "18"} style={{ transition: "180ms" }} viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1.63747 3.29655e-06C0.939949 3.29655e-06 0.348759 0.522753 0.276456 1.22188C0.171544 2.21921 0 4.02475 0 5.13542C0 6.18375 0.480608 7.12017 1.23129 7.73642C1.47797 7.939 1.59494 8.16142 1.59494 8.34842V8.81734L1.59423 8.85063C1.56516 9.27492 1.24051 14.0122 1.24051 14.875C1.24051 15.1541 1.29551 15.4304 1.40238 15.6882C1.50925 15.946 1.6659 16.1803 1.86337 16.3776C2.06084 16.5749 2.29527 16.7315 2.55328 16.8382C2.81129 16.945 3.08782 17 3.36709 17C3.64636 17 3.92289 16.945 4.1809 16.8382C4.43891 16.7315 4.67334 16.5749 4.87081 16.3776C5.06828 16.1803 5.22492 15.946 5.33179 15.6882C5.43867 15.4304 5.49367 15.1541 5.49367 14.875C5.49367 14.0122 5.16972 9.27492 5.13995 8.85063L5.13924 8.81734V8.34842C5.13924 8.16071 5.2562 7.939 5.50289 7.73642C5.88819 7.42115 6.19855 7.02424 6.4115 6.5744C6.62444 6.12456 6.73466 5.63305 6.73418 5.13542C6.73418 4.02475 6.56263 2.21921 6.45772 1.22188C6.4223 0.88606 6.26356 0.575283 6.01218 0.349605C5.76081 0.123927 5.43464 -0.000630412 5.09671 3.29655e-06C4.77276 3.29655e-06 4.47433 0.11192 4.23899 0.299628C3.98988 0.105469 3.68301 1.42686e-05 3.36709 3.29655e-06C3.05116 1.42686e-05 2.7443 0.105469 2.49519 0.299628C2.25179 0.105028 1.94919 -0.000680481 1.63747 3.29655e-06ZM3.01266 1.41667C3.01266 1.32274 3.05 1.23266 3.11647 1.16624C3.18294 1.09982 3.27309 1.0625 3.36709 1.0625C3.46109 1.0625 3.55124 1.09982 3.61771 1.16624C3.68418 1.23266 3.72152 1.32274 3.72152 1.41667V5.13542C3.72152 5.27632 3.77753 5.41144 3.87723 5.51107C3.97694 5.6107 4.11216 5.66667 4.25316 5.66667C4.39417 5.66667 4.52939 5.6107 4.62909 5.51107C4.7288 5.41144 4.78481 5.27632 4.78481 5.13542V1.37417C4.78481 1.29151 4.81767 1.21224 4.87616 1.15379C4.93466 1.09534 5.01399 1.0625 5.09671 1.0625C5.2562 1.0625 5.38522 1.18079 5.40081 1.33238C5.50572 2.33821 5.67089 4.08921 5.67089 5.13542C5.67139 5.47603 5.59602 5.81248 5.45024 6.12036C5.30446 6.42825 5.09192 6.69985 4.82805 6.91546C4.44668 7.22854 4.07595 7.72296 4.07595 8.34842V8.81734C4.07595 8.85275 4.07666 8.88533 4.07949 8.92358C4.11068 9.38046 4.43038 14.0597 4.43038 14.875C4.43038 15.1568 4.31836 15.427 4.11895 15.6263C3.91954 15.8256 3.64909 15.9375 3.36709 15.9375C3.08509 15.9375 2.81463 15.8256 2.61523 15.6263C2.41582 15.427 2.3038 15.1568 2.3038 14.875C2.3038 14.0604 2.62278 9.38046 2.65468 8.92358C2.65752 8.88533 2.65823 8.85275 2.65823 8.81734V8.34842C2.65823 7.72225 2.28749 7.22854 1.90613 6.91546C1.64225 6.69985 1.42972 6.42825 1.28394 6.12036C1.13816 5.81248 1.06279 5.47603 1.06329 5.13542C1.06329 4.08921 1.22846 2.33892 1.33337 1.33238C1.34146 1.25769 1.37708 1.18868 1.4333 1.1388C1.48951 1.08891 1.56229 1.06171 1.63747 1.0625C1.72019 1.0625 1.79952 1.09534 1.85801 1.15379C1.91651 1.21224 1.94937 1.29151 1.94937 1.37417V5.13542C1.94937 5.27632 2.00538 5.41144 2.10508 5.51107C2.20479 5.6107 2.34001 5.66667 2.48101 5.66667C2.62201 5.66667 2.75724 5.6107 2.85694 5.51107C2.95665 5.41144 3.01266 5.27632 3.01266 5.13542V1.41667ZM12.5823 1.06675V7.96875C12.5823 8.21667 12.6489 9.38329 12.7226 10.6675L12.7269 10.7419C12.8261 12.4674 12.9367 14.4004 12.9367 14.875C12.9367 15.1568 12.8247 15.427 12.6253 15.6263C12.4259 15.8256 12.1554 15.9375 11.8734 15.9375C11.5914 15.9375 11.321 15.8256 11.1216 15.6263C10.9222 15.427 10.8101 15.1568 10.8101 14.875C10.8101 14.4535 10.8973 12.7479 10.9866 11.1208C11.0389 10.1673 11.0928 9.21391 11.1483 8.26058L11.1638 7.99992L11.1646 7.96875C11.1646 7.82786 11.1085 7.69273 11.0088 7.5931C10.9091 7.49347 10.7739 7.4375 10.6329 7.4375H9.21519C9.16819 7.4375 9.12311 7.41885 9.08988 7.38564C9.05665 7.35243 9.03797 7.30738 9.03797 7.26042V4.78125C9.03798 3.82564 9.40614 2.90671 10.0661 2.21509C10.726 1.52347 11.627 1.11226 12.5823 1.06675ZM10.0694 8.5L10.0467 8.89384C10.0134 9.47254 9.96871 10.2538 9.92476 11.0628C9.83686 12.6685 9.74684 14.416 9.74684 14.875C9.74684 15.1541 9.80184 15.4304 9.90871 15.6882C10.0156 15.946 10.1722 16.1803 10.3697 16.3776C10.5672 16.5749 10.8016 16.7315 11.0596 16.8382C11.3176 16.945 11.5942 17 11.8734 17C12.1527 17 12.4292 16.945 12.6872 16.8382C12.9452 16.7315 13.1797 16.5749 13.3771 16.3776C13.5746 16.1803 13.7313 15.946 13.8381 15.6882C13.945 15.4304 14 15.1541 14 14.875C14 14.3643 13.888 12.4143 13.7916 10.7277L13.7888 10.681C13.7115 9.33584 13.6456 8.18125 13.6456 7.96875V0.531253C13.6456 0.390357 13.5896 0.255231 13.4899 0.155603C13.3902 0.055974 13.2549 3.29655e-06 13.1139 3.29655e-06H12.7595C11.4905 3.29655e-06 10.2734 0.503741 9.37612 1.4004C8.4788 2.29706 7.97468 3.51319 7.97468 4.78125V7.26042C7.97468 7.94467 8.53043 8.5 9.21519 8.5H10.0694Z" fill={currentElementId == `calorie-intake-${childIndex}` || content.calorie ? "var(--darkBlue)" : "#6d6d6d"}/>
                                        </svg>
                                        <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == `calorie-intake-${childIndex}` || content.calorie) ? "10px" : "14px", color: (currentElementId == `calorie-intake-${childIndex}` || content.calorie) ? "var(--darkBlue)" : "", transition: "180ms" }}>Calorie (kcal)</p>
                                      </div>
                                      <input id={`calorie-intake-${childIndex}`} value={content.calorie} className={`${(currentElementId == `calorie-intake-${childIndex}` || content.calorie) ? "active-input-field" : "inactive-input-field"}`} type="number" placeholder="Enter Calorie" style={{ textTransform: 'capitalize' }} onInput={handleNutritionCarrierContent(parentIndex,childIndex,"calorie")}  />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          })
                        }
                      </div>
                    )}
                  )
                }
                <div className='w-full d-flex m-t-16'>
                  <div onClick={()=>handleAddNutritionMeal()} className="member-button-global btn-center d-flex flex-item margin-auto" style={{ width: "auto" }}>
                    <svg className='svg-stroke flex-item m-r-8' width="16" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 8H15.5M8.5 15V1" stroke="#E33A34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p className="flex-item color-red" style={{color:"#E33A34"}}>Add Meal</p>
                  </div>
                </div>
                <div className="bottom-action-button">
                  <div className='d-flex space-between'>
                    <div onClick={()=>handlePlannerHome(false)} className="member-button-global btn-center d-flex flex-item bg-grey-08" style={{ width: "auto" }}>
                      <p className="flex-item">Cancel</p>
                    </div>
                    {/* TODO */}
                    {/* <div className='d-flex flex-item' style={{cursor: isButtonLock ? "no-drop" : "pointer", width: "80%"}}>
                      <div onClick={isButtonLock ? null : handleUpdateNutritionContent} className={`member-button-global btn-center d-flex flex-item ${isButtonLock ? "member-button-global-inactive" : ""} w-full`}>
                        <p className="flex-item">Save & continue</p>
                      </div>
                    </div> */}
                    <div onClick={()=>handleUpdateNutritionContent()} className={`member-button-global btn-center d-flex flex-item ${isButtonLock ? "member-button-global-inactive" : ""}`} style={{width: "80%"}}>
                        <p className="flex-item" style={{ fontWeight: 600, whiteSpace:"nowrap" }}>Save & continue</p>
                      </div>
                  </div>
                </div>
              </div>
            )
          }


          {
            currentWindow == "selected-nutrition-content" && (
              <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" style={{ padding: window.innerWidth > 767 ? "4px 12px 40px 12px" : "12px" }}>
                <div className='d-flex w-full m-b-12'>
                  <div className='d-flex margin-auto'>
                    {
                      dayStorage.Days.filter(d=>nutritionPlanner.findIndex(data=>data.dayName == d.name) == -1).map((data, index) => {
                        return(
                            <div onClick={() => handleSelectedNutritionDay(data.name)} className={`${data.isSelected ? "day-chips day-chips-active" : "day-chips"} ${dayStorage.Days.length != index + 1 && "m-r-10"} d-flex cursor-pointer` } style={{width:"50px", height: "30px", padding: "0"}}>
                              <p className='flex-item' style={{margin:"0 auto"}}>{data.name}</p>
                            </div>
                          )
                        }
                      )
                    }
                  </div>
                </div>
                <div className='d-flex w-full m-b-16'>
                  <div className='d-flex margin-auto'>
                    <svg className='flex-item m-r-8' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 5.8H9.0064M9 12.2V8.2M17 9C17 13.4184 13.4184 17 9 17C4.5816 17 1 13.4184 1 9C1 4.5816 4.5816 1 9 1C13.4184 1 17 4.5816 17 9Z" stroke="#B6B6B6" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p className='flex-item color-grey-07'>You can select multiple days & plan for nutrition</p>
                  </div>
                </div>
                {
                  nutritionPlanner.map((data, index) => {
                    return(
                      <div className={`${nutritionPlanner.length != index + 1 && 'm-b-12'} nutrition-content-container w-full`}>
                        <div className='nutrition-content-header w-full'>
                          <div className='d-flex w-full flex-item space-between'>
                            <div className='flex-item d-flex'>
                              <p className='flex-item m-r-8 color-white font-weight-600'>{data.dayDisplayName}</p>
                            </div> 
                            <div className='d-flex'>                             
                              <svg onClick={handleDeleteNutritionPlan.bind(this,index)} className='flex-item' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.616 20.0005C7.168 20.0005 6.78667 19.8431 6.472 19.5285C6.15733 19.2138 6 18.8328 6 18.3855V6.00047H5V5.00047H9V4.23047H15V5.00047H19V6.00047H18V18.3855C18 18.8455 17.846 19.2298 17.538 19.5385C17.23 19.8471 16.8453 20.0011 16.384 20.0005H7.616ZM17 6.00047H7V18.3855C7 18.5648 7.05767 18.7121 7.173 18.8275C7.28833 18.9428 7.436 19.0005 7.616 19.0005H16.385C16.5383 19.0005 16.6793 18.9365 16.808 18.8085C16.9367 18.6805 17.0007 18.5391 17 18.3845V6.00047ZM9.808 17.0005H10.808V8.00047H9.808V17.0005ZM13.192 17.0005H14.192V8.00047H13.192V17.0005Z" fill="white"/>
                              </svg>
                              <div className='header-action-line-separator m-l-4 m-r-4 d-flex'/>
                              <svg onClick={()=>handleSelectPlannerDay("nutrition", data.dayName,true)} className='flex-item' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.1819 4.81833C18.6578 4.29436 17.9471 4 17.206 4C16.4649 4 15.7541 4.29436 15.23 4.81833L5.34722 14.7023C5.05902 14.9903 4.86017 15.3555 4.77459 15.7538L4.01279 19.3083C3.9927 19.4017 3.99632 19.4986 4.02333 19.5901C4.05034 19.6817 4.09986 19.7651 4.16739 19.8326C4.23491 19.9001 4.31828 19.9497 4.40987 19.9767C4.50147 20.0037 4.59837 20.0073 4.69172 19.9872L8.24641 19.2255C8.64477 19.1399 9.00993 18.941 9.29795 18.6528L19.1819 8.76942C19.7057 8.24539 20 7.5348 20 6.79387C20 6.05295 19.7057 5.34236 19.1819 4.81833ZM16.0387 5.62638C16.3512 5.33088 16.7666 5.16892 17.1967 5.17495C17.6267 5.18097 18.0375 5.35451 18.3415 5.65865C18.6456 5.96279 18.8191 6.37354 18.825 6.80357C18.8309 7.2336 18.6688 7.64897 18.3732 7.96137L17.8589 8.47569L15.5238 6.14126L16.0387 5.62638ZM14.7151 6.94931L17.0502 9.2843L8.49043 17.8454C8.35798 17.9778 8.19008 18.069 8.00695 18.1082L5.31465 18.6854L5.89186 15.9938C5.93105 15.8107 6.02235 15.6428 6.15474 15.5104L14.7151 6.94931Z" fill="white"/>
                              </svg>
                              <div className='header-action-line-separator m-l-4 m-r-4 d-flex'/>
                              <svg onClick={() => handleDayWorkoutCopyTo(data.dayName)} className='flex-item' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.69922 11.1002C6.69922 8.555 6.69922 7.2815 7.49032 6.4913C8.28052 5.7002 9.55402 5.7002 12.0992 5.7002H14.7992C17.3444 5.7002 18.6179 5.7002 19.4081 6.4913C20.1992 7.2815 20.1992 8.555 20.1992 11.1002V15.6002C20.1992 18.1454 20.1992 19.4189 19.4081 20.2091C18.6179 21.0002 17.3444 21.0002 14.7992 21.0002H12.0992C9.55402 21.0002 8.28052 21.0002 7.49032 20.2091C6.69922 19.4189 6.69922 18.1454 6.69922 15.6002V11.1002Z" stroke="white" stroke-width="1.5"/>
                                <path opacity="0.5" d="M6.7 18.3C5.98392 18.3 5.29716 18.0155 4.79081 17.5092C4.28446 17.0028 4 16.3161 4 15.6V10.2C4 6.8061 4 5.1087 5.0548 4.0548C6.1096 3.0009 7.8061 3 11.2 3H14.8C15.5161 3 16.2028 3.28446 16.7092 3.79081C17.2155 4.29716 17.5 4.98392 17.5 5.7" stroke="white" stroke-width="1.5"/>
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className='nutrition-content-body p-0'>
                          {
                            data.nutritionContents && data.nutritionContents.map((content, index) => {
                              return[
                                <div className='d-flex flex-item space-between w-full p-l-12 p-r-12 p-t-12 p-b-6'>
                                  <div className='flex-item'>
                                    <p className='flex-item fs-14 font-weight-600' style={{lineHeight:"14px"}}>{content.mealName}</p>
                                    <p className='fs-10 color-grey-03'>{content.contents.length} Item(s)</p>
                                  </div>
                                  <div className='eating-time d-flex flex-item'>
                                    <p className='flex-item fs-12 color-dark-blue font-weight-600 margin-auto'>{convert_24_to_12(content.mealTime)}</p>
                                  </div>
                                </div>,
                                data.nutritionContents.length != index + 1 && (
                                  <div className='flex-item w-full' style={{height:"1px", background: "#DEDEDE"}}/>
                                )
                              ]
                            })
                          }
                        </div>
                      </div>
                    )
                  })
                }
                <div className="bottom-action-button">
                  <div onClick={()=>handlePlannerHome(true)} className={`member-button-global btn-center d-flex flex-item w-full`}>
                    <p className="flex-item">Save & continue</p>
                  </div>
                </div>
              </div>
            )
          }

          {
            currentWindow == "nutrition-content-list" && (
              <div className='w-full h-full' style={{padding:"0px 12px 12px 12px"}}>
                {/* <div className='m-l-12 m-r-12 d-flex'>
                  <SearchFilter search={handleContentSearchKey.bind(this)} count={Total.content} searchType="Nutrition Content" isHideFilter={true} isSticky={false}/>
                </div> */}
                <div className='m-b-12'>
                  <SearchFilter searchType={"Nutrition Content"} searchingData={handleContentSearchKey.bind(this)} isSearchEnabled={true} isSticky={false} isHideFilter={true} />
                </div>

                {/* <SearchFilter search={handleContentSearchKey.bind(this)} count={Total.content} searchType="Nutrition Content" isHideFilter={true} isSticky={false}/> */}


                {
                  nutritionCarrier.length && ( 
                    <div className='d-flex space-between'>
                      <div className='d-flex'>
                        <svg className='flex-item m-r-8' width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11 7H11.008M11 15V10M21 11C21 16.523 16.523 21 11 21C5.477 21 1 16.523 1 11C1 5.477 5.477 1 11 1C16.523 1 21 5.477 21 11Z" stroke="#E33A34" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <p className='flex-item fs-14 font-weight-600'>Adding Foods in {getMealTime(parseInt(nutritionCarrier[isCurrentNutritionContentIndex.parentIndex].mealTime))}</p>
                      </div>
                      <div className='d-flex flex-item selected-dates bg-red'>
                        <p className='fs-12 color-white font-weight-700 flex-item'>{handleSelectedDays("short")}</p>
                      </div>
                    </div>
                  )
                }
                <div onClick={e => e.stopPropagation()} className="global-modal-scroll-container" onScroll={handleScroll} style={{ overflow: "auto", height:"90%", paddingLeft:"2px"}}>
                  {
                    Contents.map((data, index) => {
                      return(
                        <div className='nutrition-content-section-container space-between m-b-12 d-flex'>
                          <div onClick={()=>handleSelectNutritionContent(data, index)} className='nutrition-content-image'>
                            <input type='checkbox' className='nutrition-check-box' checked={allSelectedNutritionContent.findIndex(d=>d.content._id==data._id)!=-1} />
                            <img className='flex-item w-full h-full' alt='Nutrition Content Image' src={`${config.API_URL}${config.prefixStream}/media/file/${data.nutritionGuides[0].foodImageId}`} />
                          </div>
                          <div style={{width:"58%", alignSelf:"flex-start", padding:"12px"}}>
                            <div className='d-flex m-b-4'>
                              <p className='flex-item font-weight-600 fs-16 m-r-8'>{data.name}</p>
                              <svg className='flex-item' width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.02504 6.602C1.73081 3.327 4.6812 1 8 1C11.3188 1 14.2682 3.327 14.975 6.602C15.003 6.73196 15.0832 6.84584 15.1981 6.91861C15.313 6.99137 15.4531 7.01705 15.5876 6.99C15.7221 6.96295 15.8399 6.88538 15.9152 6.77436C15.9905 6.66334 16.0171 6.52796 15.9891 6.398C15.185 2.673 11.8217 0 8 0C4.17826 0 0.814959 2.673 0.0108719 6.398C-0.0171232 6.52796 0.0094528 6.66334 0.0847536 6.77436C0.160054 6.88538 0.277912 6.96295 0.412398 6.99C0.546885 7.01705 0.686984 6.99137 0.801876 6.91861C0.916768 6.84584 0.997041 6.73196 1.02504 6.602ZM7.98965 3C8.95027 3 9.87154 3.36875 10.5508 4.02513C11.2301 4.6815 11.6117 5.57174 11.6117 6.5C11.6117 7.42826 11.2301 8.3185 10.5508 8.97487C9.87154 9.63125 8.95027 10 7.98965 10C7.02903 10 6.10776 9.63125 5.4285 8.97487C4.74924 8.3185 4.36764 7.42826 4.36764 6.5C4.36764 5.57174 4.74924 4.6815 5.4285 4.02513C6.10776 3.36875 7.02903 3 7.98965 3Z" fill="var(--darkBlue)"/>
                              </svg>
                            </div>
                            <p className='fs-10 color-grey-03' style={{lineHeight:"12px"}}>{data.nutritionGuides[0].foodDescription}</p>
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
                <div className="bottom-action-button">
                  <div className='d-flex space-between'>
                    <div onClick={handleCloseContentSelect.bind(this)} className="member-button-global btn-center d-flex flex-item bg-grey-08" style={{ width: "auto" }}>
                      <p className="flex-item">Cancel</p>
                    </div>
                    <div className='d-flex flex-item' style={{cursor: isButtonLock ? "no-drop" : "pointer", width: "80%"}}>
                      <div onClick={isButtonLock ? null : () => handleAssignNutritionContent()} className={`member-button-global btn-center d-flex flex-item ${isButtonLock ? "member-button-global-inactive" : ""} w-full`}>
                        <p className="flex-item">Add Selected content(s)</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }

          {
            isVideoPlayerOpen && (
              <div onClick={toggleVideoPlayer.bind(this, "")} className="mobile-bottom-modal-container bottom-slider d-flex" style={{ position: "absolute", zIndex: 100, borderRadius: "0 8px 8px 0" }}>
                <div id="mobile-video-modal" onClick={e => e.stopPropagation()} className="mobile-bottom-modal" style={{ position: "relative", alignSelf: "flex-end", maxHeight: "60%", borderBottomRightRadius: "8px" }}>
                  {
                    (displayContent && displayContent.videoList && displayContent.videoList.length > 0) && displayContent.videoList.map(video => (
                      <iframe className="exercise-video-container" src={video.link} />
                    ))
                  }

                  {
                    (displayContent && displayContent.videoList && displayContent.videoList.length > 1) && (
                      <div className='d-flex space-between m-t-12 m-b-6'>
                        <div className='more-table-item-container p-t-8 p-b-8 p-l-12 p-r-12 d-flex'>
                          <p className='flex-item more-table-item-txt'>1/2</p>
                        </div>
                        <div className='d-flex flex-item'>
                          <div className='global-round-btn d-flex flex-item m-r-12' style={{ boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)" }}>
                            <svg className='flex-item stroke-svg' width="11" height="16" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M5 1L1 5.33333L5 10" stroke="#6D6D6D" stroke-linecap="round" />
                            </svg>
                          </div>
                          <div className='global-round-btn d-flex flex-item' style={{ boxShadow: "0px 0px 3px rgba(0, 0, 0, 0.25)" }}>
                            <svg className='flex-item stroke-svg' width="11" height="16" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 10L6 5.66667L1 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    )
                  }

                  {
                    (displayContent && displayContent.videoList && displayContent.videoList.length > 0) && displayContent.videoList.map(video => (
                      <div className='w-full m-t-12' style={{ textAlign: "left", justifyContent: "left" }}>
                        <p className='fs-16'>{video.title}</p>
                      </div>
                    ))
                  }
                </div>
              </div>
            )
          }

        </div>
      </div>
    </div>
  )
}

export default ManageWorkoutPlanner;